<template>
  <div>
  <div class="material-book-container" style="display: none;">
    <img :src="showMaterialBookContent ? rightBtn : leftBtn" alt="物料书" class="material-book-btn" @click="showBook">
    <!-- <div class="material-book-btn" @click="showBook">物<br/>料<br/>书<br/>{{ showMaterialBookContent ? '&gt;' : '&lt;' }}</div> -->
    <div class="material-book-content" v-if="showMaterialBookContent">
      <div class="material-book-title">物料书关联页</div>
      <template v-if="materialFileAllList.length > 0">
        <div class="material-book-tip">如关联页不准确，可下载完整版查阅</div>
        <div style="margin-bottom: 10px;" v-for="materialFile in materialFileAllList" :key="materialFile.id">
          <span style="font-size: 14px; color: #fff;margin-right: 10px;">{{ materialFile.name }}</span>
          <v-btn variant="text" size="small" @click="previewMaterialBook(materialFile.url)" style="background:rgba(0, 0, 0, 0.4);padding: 0 2px;">
            <v-icon style="margin-right: 2px;">mdi-download</v-icon>
            下载
          </v-btn>
        </div>
      </template>
      <template v-if="materialFileList.length > 0">
        <div class="material-book-list">
          <template v-for="materialFile in materialFileList" :key="materialFile.id">
            <div class="material-book-list">
              <template v-for="materialFile in materialFileList" :key="materialFile.id">
                <div class="material-images-container">
                  <div class="image-preview-list">
                    <div class="image-preview-item" style="width: 100%;height: auto;">
                      <img :src="materialFile.url" alt="">
                      <div class="image-actions"  @click="handleMaterialImagePreview(materialFileList, index, imageIndex, false)">
                        <v-icon 
                          icon="mdi-eye" 
                          size="20"
                          @click.stop="handleMaterialImagePreview(materialFileList, index, imageIndex, false)"
                        ></v-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </template>
        </div>
      </template>
      <div v-else style="text-align: center;color: #fff;margin-top: 10px;">
        <div v-if="Number(materialFileStatus) === 0">物料书解析中</div>
        <div v-else>暂无相关物料书关联页</div>
      </div>
    </div>
  </div>
  <div class="material-list-page">
    <div class="material-list-container">
      <v-card class="form-card">
        <v-card-text>
          <v-form ref="form" v-model="valid">

            <!-- 合同信息 -->
            <div class="form-section">
              <!-- <div class="section-title">合同信息</div> -->
              <v-row>
                <v-col cols="12" sm="3">
                  <v-text-field
                    v-model="contractInfo.code"
                    label="合同唯一码"
                    persistent-placeholder
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    readonly
                    class="v-field--readonly"
                  />
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field
                    :value="contractInfo.province + ' ' + contractInfo.region"
                    label="项目地区"
                    persistent-placeholder
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    readonly
                    class="v-field--readonly"
                  />
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field
                    v-model="contractInfo.salesmanName"
                    label="业务员"
                    persistent-placeholder
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    readonly
                    class="v-field--readonly"
                  />
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field
                    v-model="contractInfo.departmentName"
                    label="所属部门"
                    persistent-placeholder
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    readonly
                    class="v-field--readonly"
                  />
                </v-col>
              </v-row>
              <v-row>
                <!-- <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="contractInfo.customerName"
                    label="公司名称"
                    persistent-placeholder
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    readonly
                    class="v-field--readonly"
                  />
                </v-col>
                <v-col cols="12" sm="2">
                  <v-text-field
                    v-model="contractInfo.customerShortName"
                    label="客户简称"
                    persistent-placeholder
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    readonly
                    class="v-field--readonly"
                  />
                </v-col> -->
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="contractInfo.project"
                    label="项目名称"
                    persistent-placeholder
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    readonly
                    class="v-field--readonly"
                  />
                </v-col>
                <v-col cols="12" sm="2">
                  <v-text-field
                    v-model="contractInfo.projectType"
                    label="项目类型"
                    persistent-placeholder
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    readonly
                    class="v-field--readonly"
                  />
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field
                    v-model="contractInfo.wuliaoOwner"
                    label="物控负责人"
                    persistent-placeholder
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    readonly
                    class="v-field--readonly"
                  />
                </v-col>
              </v-row>
            </div>
            
            <div class="d-flex align-center" style="justify-content:space-between;margin-top:40px;margin-bottom:16px;">
              <div class="section-title-group">
                <div v-for="(item,index) in titleList" :key="item.title" :class="item.isChoosed ? 'normal-title normal-title-active' : 'normal-title'" @click="handleTitleClick(index,item.title)">{{ item.title }}</div>
              </div>
              <div v-if="titleList[0].isChoosed" class="d-flex">
                <v-text-field
                  v-model="keywordSearchProduct"
                  label="搜索"
                  persistent-placeholder
                  placeholder="产品名/批号/产品编号"
                  variant="outlined"
                  density="compact"
                  hide-details
                  append-inner-icon="mdi-magnify"
                  clearable
                  style="width:350px;max-width:350px;"
                  @click:clear="loadProductionOrderList()"
                  @keyup.enter="loadProductionOrderList()"
                  @click:append-inner="loadProductionOrderList()"
                />
                <div style="color:#fff;font-size: 16px;margin-left:12px">
                  <div><span style="color: #898989;">总品项</span> {{ productCount }}</div>
                  <div><span style="color: #898989;">总数量</span> {{ productCountSum }}</div>
                </div>
              </div>
              <v-text-field  v-if="titleList[2].isChoosed"
                v-model="keywordSearchMaterial"
                label="搜索"
                persistent-placeholder
                placeholder="产品名/批号/产品编号"
                variant="outlined"
                density="compact"
                hide-details
                append-inner-icon="mdi-magnify"
                clearable
                style="width:350px;max-width:350px;"
                @click:clear="loadMaterialSummaryMerge()"
                @keyup.enter="loadMaterialSummaryMerge()"
                @click:append-inner="loadMaterialSummaryMerge()"
              />
              <v-text-field  v-if="titleList[3].isChoosed"
                v-model="keywordSearchMetal"
                label="搜索"
                persistent-placeholder
                placeholder="产品名/批号/产品编号"
                variant="outlined"
                density="compact"
                hide-details
                append-inner-icon="mdi-magnify"
                clearable
                style="width:350px;max-width:350px;"
                @click:clear="loadMetalSummaryMerge()"
                @keyup.enter="loadMetalSummaryMerge()"
                @click:append-inner="loadMetalSummaryMerge()"
              />
            </div>
            <div class="form-section material-list-section">
              <!-- 物控汇总 -->
              <div class="product-table-container" v-if="titleList[1].isChoosed">
                <v-table class="product-table material-table material-summary-table sum-wuliao-table" hover fixed-header :style="{ maxHeight: `calc(100vh - 350px)` }">
                  <thead>
                    <tr>
                      <th v-for="header in materialHeaders" :key="header.key" :class="['text-' + header.align]" :style="{ minWidth: header.minWidth }">
                        <!-- <template v-if="header.key === 'actions' && showChoosePurchase">
                          <v-checkbox
                            class="material-checkbox"
                            v-model="isSelectAll"
                            @change="handleSelectAll"
                            hide-details
                            density="compact"
                            label="全选"
                          ></v-checkbox>
                        </template> -->
                        <!-- <template> -->
                          {{ header.title }}
                        <!-- </template> -->
                         <!-- 筛选按钮 -->
                         <v-menu v-if="header.filterable" location="bottom" @click.stop>
                          <template v-slot:activator="{ props }">
                            <v-btn
                              icon="mdi-filter"
                              size="small"
                              variant="text"
                              density="compact"
                              v-bind="props"
                              :color="(header.key === 'bigClass' ? bigClassPriceFilter : materialTypePriceFilter) ? '#D2475D' : undefined"
                              :class="(header.key === 'bigClass' ? bigClassPriceFilter : materialTypePriceFilter) ? 'filter-btn-active' : ''"
                              class="ml-2 filter-btn"
                              @click.stop
                            />
                          </template>
                          <v-card class="filter-menu">
                            <v-card-text class="pa-2">
                              <template v-if="header.key === 'materialType'">
                                <v-radio-group
                                  v-model="materialTypePriceFilter"
                                  density="compact"
                                  class="filter-radio-group"
                                  hide-details
                                  @update:model-value="loadWuliaoList"
                                >
                                  <v-radio
                                    label="全部"
                                    :value="null"
                                    color="#D2475D"
                                    density="compact"
                                  />
                                  <v-radio
                                    v-for="option in materialTypePriceOptions"
                                    :key="option"
                                    :label="option"
                                    :value="option"
                                    color="#D2475D"
                                    density="compact"
                                  />
                                </v-radio-group>
                              </template>
                              <template v-if="header.key === 'bigClass'">
                                <v-radio-group
                                  v-model="bigClassPriceFilter"
                                  density="compact"
                                  class="filter-radio-group"
                                  hide-details
                                  @update:model-value="loadWuliaoList"
                                >
                                  <v-radio
                                    label="全部"
                                    :value="null"
                                    color="#D2475D"
                                    density="compact"
                                  />
                                  <v-radio
                                    v-for="option in bigClassPriceOptions"
                                    :key="option"
                                    :label="option"
                                    :value="option"
                                    color="#D2475D"
                                    density="compact"
                                  />
                                </v-radio-group>
                              </template>
                            </v-card-text>
                            <v-divider />
                          </v-card>
                        </v-menu>
                      </th>
                    </tr>
                  </thead>
                  <tbody class="material-summary-table-body">
                    <template v-if="materialControlSummaryList.length > 0">
                      <tr 
                        v-for="(item, index) in materialControlSummaryList" 
                        :key="index" 
                        :style="{ 
                          height: isMaterialRowZoomed(index) ? '300px' : 'auto',
                        }"
                        :class="{'del-tr-1': Number(item.isDelete) === 1}"
                        class="del-tr"
                      >
                        <td v-for="header in materialHeaders" :key="header.key" :class="['text-' + header.align]" :style="{ minWidth: header.minWidth,position: 'relative' }">
                          <template v-if="header.key === 'nothing'">

                          </template>
                          <template v-if="header.key === 'materialType'">
                            <div>{{ item.materialType }}</div>
                          </template>
                          <template v-if="header.key === 'bigClass'">
                            <div>{{ item.bigClass }}</div>
                          </template>
                          <template v-if="header.key === 'materialCustomerNo'">
                            <div>{{ item.materialCustomerNo }}</div>
                          </template>
                          <template v-if="header.key === 'materialName'">
                            <div style="text-align: left!important">
                              <div>{{ item.materialName || '/' }}</div>
                              <div>{{ item.specDesc || '/' }}</div>
                              <div class="salesman-remark" style="font-size: 12px;color: #8F9093;">
                                {{ item.materialCode || '/' }}
                              </div>
                            </div>
                          </template>
                          <template v-else-if="header.key === 'materialDescription'">
                            <div style="text-align: left!important;">
                                <!-- <img v-if="item.materialDescriptionMerge && item.materialDescriptionMerge.length > 0"
                                  src="@/assets/materialTip.png" 
                                  alt="提示" 
                                  style="width: 32px; height: 16px; cursor: pointer; top: 3px;position: relative;margin-right: 4px;" 
                                  @click="showMaterialDescriptionMerge(item.materialDescriptionMerge)"
                                /> -->
                                {{ item.materialDescriptionMerge || '/' }}
                            </div>
                          </template>
                          <template v-else-if="header.key === 'materialCount'">
                            <div>{{ item.materialCount }}</div>
                          </template>
                          <template v-else-if="header.key === 'materialPrice'">
                            <div>{{ item.materialPrice }}</div>
                          </template>
                          <template v-else-if="header.key === 'materialUnit'">
                            <div>{{ item.materialUnit || '/' }}</div>
                          </template>
                          <template v-else-if="header.key === 'materialTotal'">
                            <div>{{ formatNumber(Number(item.materialTotal)) }}</div>
                          </template>
                          <template v-else-if="header.key === 'stock'">
                            <div>{{ item.currentInventory || '/' }}</div>
                          </template>
                          <template v-else-if="header.key === 'purchased'">
                            <div>{{ item.purchasedQuantity || '/' }}</div>
                          </template>
                          <template v-else-if="header.key === 'salesmanRemark'">
                            <div class="remark">{{ item.salesmanRemark }}</div>
                          </template>
                          <!-- <template v-else-if="header.key === 'wuliaoName'">
                            <div>{{ item.wuliaoName || '/' }}</div>
                          </template> -->
                          <template v-else-if="header.key === 'wuliaoRemark'">
                            <div class="remark">{{ item.wuliaoRemark || '/' }}</div>
                          </template>
                          <template v-else-if="header.key === 'wuliaoStatus'">
                            <v-chip
                              :color="getStatusWuliaoColor(Number(item.wuliaoStatus))"
                              size="small"
                              variant="flat"
                            >
                              {{ getStatusWuliaoText(Number(item.wuliaoStatus)) }}
                            </v-chip>
                          </template>
                          <template v-else-if="header.key === 'materialImageUrlsConfirmed'">
                            <div class="product-images-container" v-if="item.materialImageUrlsConfirmed && item.materialImageUrlsConfirmed.length > 0">
                              <div class="image-preview-list">
                                <template v-for="(image, imageIndex) in item.materialImageUrlsConfirmed" :key="imageIndex">
                                  <div v-if="imageIndex === 0" class="image-preview-item">
                                    <v-img
                                      :src="getImagePreviewUrl(image)"
                                      contain
                                      class="preview-image"
                                    ></v-img>
                                    <div class="image-actions"  @click="handleImagePreview(item.materialImageUrlsConfirmed, index, imageIndex, false)">
                                      <v-icon 
                                        icon="mdi-eye" 
                                        size="20"
                                        @click.stop="handleImagePreview(item.materialImageUrlsConfirmed, index, imageIndex, false)"
                                      ></v-icon>
                                    </div>
                                    <div class="image-count-preview">
                                      <img class="image-count-icon" src="@/assets/picicon.png" alt="">
                                      {{ '共' + item.materialImageUrlsConfirmed.length + '张' }}
                                    </div>
                                  </div>
                                </template>
                              </div>
                              <!-- <div v-else class="no-img"></div> -->
                            </div>
                            <div v-else>/</div>
                          </template>
                          <template v-if="header.key === 'materialTypeConfirmed'">
                            <div>{{ item.materialTypeConfirmed }}</div>
                          </template>
                          <template v-if="header.key === 'materialNameConfirmed'">
                            <div>{{ item.materialNameConfirmed }}</div>
                          </template>
                          <template v-else-if="header.key === 'materialCode'">
                            <div>{{ item.materialCode }}</div>
                          </template>
                          <template v-else-if="header.key === 'specDesc'">
                            <div>{{ item.specDesc }}</div>
                          </template>
                          <template v-else-if="header.key === 'materialImageUrls'">
                            <div
                              :class="[
                                'product-images-container',
                                isMaterialRowZoomed(index) ? 'preview-image-zoomed' : ''
                              ]"
                            >
                              <MaterialImagePreview
                                :image-urls="item.materialImageUrls || []"
                                :parent-index="index"
                                image-type="material"
                                :current-image-index="getCurrentMaterialImageIndex(index)"
                                :is-zoomed="isMaterialRowZoomed(index)"
                                :can-delete="false"
                                @update:current-image-index="(imageIndex) => updateMaterialImageIndex(index, imageIndex)"
                                @zoom-in="() => zoomMaterialIn(index)"
                                @zoom-out="() => zoomMaterialOut(index)"
                                @image-preview="handleImagePreview(item.materialImageUrls, index, getCurrentMaterialImageIndex(index), false, 'wuliao')"
                                @image-upload="handleMaterialImageUploadFromComponent"
                                @upload-success="handleMaterialImageUploadSuccess"
                              />
                            </div>
                          </template>
                          <template v-else-if="header.key === 'materialPriceConfirmed'">
                            <div>{{ item.materialPriceConfirmed }}</div>
                          </template>
                          <template v-else-if="header.key === 'actions'">
                            <v-checkbox
                              class="material-checkbox"
                              v-if="showChoosePurchase && Number(item.isDelete) !== 1"
                              :model-value="selectedMaterials.includes(item.id)"
                              @change="handleSelectMaterial(item)"
                              hide-details
                              density="compact"
                            ></v-checkbox>
                            <v-btn v-else style="display: block;margin: 0 auto!important;" class="list-edit-btn" @click="handleSeeMaterial(item, index)">查看</v-btn>
                          </template>
                        </td>
                      </tr>
                    </template>
                    <tr v-if="loadingMaterialControlSummary" class="text-center">
                      <td colspan="100%" class="py-8">
                        <v-progress-circular indeterminate color="primary" size="40" width="3"></v-progress-circular>
                        <div class="mt-2 text-grey">加载中...</div>
                      </td>
                    </tr>
                    <tr v-else-if="materialControlSummaryList.length === 0" class="text-center">
                      <td colspan="100%" class="py-8">
                        暂无物控汇总数据
                      </td>
                    </tr>
                  </tbody>
                </v-table>
              </div>

              <!-- 生产单 -->
              <div v-if="titleList[0].isChoosed" class="product-table-container">
                <v-table class="product-table material-table material-summary-table contract-table" hover fixed-header :style="{ maxHeight: `calc(100vh - 350px)` }">
                  <thead>
                    <tr>
                      <th
                        v-for="header in productionOrderHeaders"
                        :key="header.key"
                        :class="['text-' + header.align]"
                        :style="{ minWidth: header.width }"
                      >
                        <div class="align-center">
                          <template v-if="header.key === 'actions' && showProductChoosePurchase">
                            <v-checkbox
                              class="material-checkbox"
                              v-model="isProductSelectAll"
                              @change="handleProductSelectAll"
                              hide-details
                              density="compact"
                              label="全选"
                            ></v-checkbox>
                          </template>
                          <template v-else>
                            {{ header.title }}
                          </template>

                          <!-- 区域筛选 -->
                          <!-- <v-menu v-if="header.key === 'area'" v-model="productAreaFilterMenuOpen" location="bottom" :close-on-content-click="false">
                            <template v-slot:activator="{ props }">
                              <v-btn
                                icon="mdi-filter"
                                size="small"
                                variant="text"
                                density="compact"
                                v-bind="props"
                                :color="hasProductAreaFilter ? '#D2475D' : undefined"
                                :class="hasProductAreaFilter ? 'filter-btn-active' : ''"
                                class="ml-2 filter-btn"
                              />
                            </template>
                            <v-card class="filter-menu">
                              <v-card-text class="pa-3">
                                <v-select
                                  v-model="productAreaFilterForm.building"
                                  label="楼栋"
                                  :items="productBuildingFilterOptions"
                                  variant="outlined"
                                  density="compact"
                                  hide-details
                                  clearable
                                  class="mb-2"
                                />
                                <v-select
                                  v-model="productAreaFilterForm.roomType"
                                  label="楼层"
                                  :items="productRoomTypeFilterOptions"
                                  variant="outlined"
                                  density="compact"
                                  hide-details
                                  clearable
                                  class="mb-2"
                                />
                                <v-select
                                  v-model="productAreaFilterForm.floor"
                                  label="区域"
                                  :items="productFloorFilterOptions"
                                  variant="outlined"
                                  density="compact"
                                  hide-details
                                  clearable
                                  class="mb-2"
                                />
                                <v-select
                                  v-model="productAreaFilterForm.areaRoomType"
                                  label="房型"
                                  :items="productAreaRoomTypeFilterOptions"
                                  variant="outlined"
                                  density="compact"
                                  hide-details
                                  clearable
                                />
                                <div class="date-filter-actions" style="margin-top: 12px;">
                                  <v-btn
                                    size="small"
                                    color="error"
                                    variant="tonal"
                                    style="background-color: #453237!important;margin-right: 8px;"
                                    @click="clearProductAreaFilter"
                                  >
                                    清空
                                  </v-btn>
                                  <v-btn
                                    size="small"
                                    color="primary"
                                    variant="flat"
                                    @click="confirmProductAreaFilter"
                                  >
                                    确定
                                  </v-btn>
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-menu> -->

                          <!-- 产品筛选 -->
                          <v-menu v-if="header.key === 'productImageUrls'" location="bottom" :close-on-content-click="false">
                            <template v-slot:activator="{ props }">
                              <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="productionOrderSearchForm.typeOf.length > 0 ? '#D2475D' : undefined"
                                :class="productionOrderSearchForm.typeOf.length > 0 ? 'filter-btn-active' : ''"
                              />
                            </template>
                            <v-card class="filter-menu">
                              <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                <div class="filter-checkbox-group">
                                  <v-checkbox
                                    v-for="option in productionOrderTypeOfOptions"
                                    :key="option"
                                    :label="option"
                                    :model-value="productionOrderSearchForm.typeOf.includes(option)"
                                    @update:model-value="(checked) => handleProductionOrderSearch('typeOf', option, checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                  />
                                </div>
                              </v-card-text>
                              <!-- <v-divider /> -->
                              <!-- <v-card-actions class="justify-end pa-2">
                                <v-btn
                                  size="small"
                                  variant="text"
                                  color="#666"
                                  @click="setProductionOrderTypeOfSelection([])"
                                >
                                  清空
                                </v-btn>
                                <v-btn
                                  size="small"
                                  variant="text"
                                  color="#D2475D"
                                  @click="setProductionOrderTypeOfSelection([...productionOrderTypeOfOptions])"
                                >
                                  全选
                                </v-btn>
                              </v-card-actions> -->
                            </v-card>
                          </v-menu>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="productionOrderLoading" class="text-center">
                      <td :colspan="productionOrderHeaders.length" class="py-8">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                        <div class="mt-2">加载中...</div>
                      </td>
                    </tr>
                    <tr v-else-if="productionOrderList.length === 0" class="text-center">
                      <td :colspan="productionOrderHeaders.length" class="py-8">暂无数据</td>
                    </tr>
                    <template v-else>
                      <tr
                        v-for="(item, index) in productionOrderList"
                        :key="item.id || index"
                        :class="{'del-tr-1': Number(item.productionInvalidStatus) === 1 || Number(item.count) === 0}"
                        class="del-tr"
                      >
                        <td class="text-center">
                          <div v-if="item.imageUrls && item.imageUrls[0]?.url" style="position: relative;background:rgba(0, 0, 0, 0.5);width: 100px;height: 100px;line-height: 100px;">
                            <v-img :src="item.imageUrls[0].url" width="100" height="100" />
                            <v-img v-if="item.typeOf == '一厂'" style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;" :src="allotOneImg" width="100" height="100" />
                            <v-img v-if="item.typeOf == '二厂'" style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;" :src="allotTwoImg" width="100" height="100" />
                            <v-img v-if="item.typeOf == '三厂'" style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;" :src="allotThreeImg" width="100" height="100" />
                            <v-img v-if="item.typeOf == '四厂'" style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;" :src="allotFourImg" width="100" height="100" />
                          </div>
                          <div v-else class="no-img" style="width: 100px;height: 100px;line-height: 100px;">
                            <v-img v-if="item.typeOf == '一厂'" style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;" :src="allotOneImg" width="100" height="100" />
                            <v-img v-if="item.typeOf == '二厂'" style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;" :src="allotTwoImg" width="100" height="100" />
                            <v-img v-if="item.typeOf == '三厂'" style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;" :src="allotThreeImg" width="100" height="100" />
                            <v-img v-if="item.typeOf == '四厂'" style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;" :src="allotFourImg" width="100" height="100" />
                          </div>
                        </td>
                        <td class="text-left" style="padding-left: 8px!important;color: rgb(143, 144, 147)!important;font-size: 12px!important;word-break: break-all;word-wrap: break-word;">
                          {{ item.contractCode }}<br>
                          {{ item.code }}<br>
                          <template v-if="item.batch">{{ item.batch }}<br></template>
                          <div style="word-break: break-all;word-wrap: break-word;">{{ item.syscode }}</div>
                        </td>
                        <td class="text-center">
                          <div style="word-break: break-all;word-wrap: break-word;">{{ item.nameShort || '/' }}</div>
                          <div style="word-break: break-all;word-wrap: break-word;">{{ item.name || '/' }}</div>
                        </td>
                        <td class="text-center">
                          W:{{ item.width }} <br> 
                          D:{{ item.depth }} <br> 
                          H:{{ item.height }}
                        </td>
                        <td class="text-center"><pre style="word-break: break-all;word-wrap: break-word;white-space: pre-wrap;">{{ item.area }}</pre></td>
                        <td class="text-center">
                          <template v-if="item.preProduction === Number(0)">
                            <template v-if="item.qtyUpdateOldTotal">
                              <span style="display:inline-flex;align-items:center;gap:6px;justify-content:center;white-space:nowrap;">
                                <span style="color:#eb6d86;">{{ item.qtyUpdateOldTotal }}</span>
                                <img src="@/assets/right.png" style="width:14px;height:auto;opacity:0.6;" />
                                <span style="color:#eb6d86;">{{ item.count }}</span>
                              </span>
                            </template>
                            <template v-else>
                              {{ item.count }}
                            </template>
                          </template>
                          <template v-else>
                            <img src="@/assets/sample.png" alt="产前样" style="height: 18px;cursor: pointer;">
                          </template>
                        </td>
                        <td class="text-center">
                          <!-- <template v-if="item.toProductionStatus === Number(2)"> -->
                          <template v-if="item.toProductionStatus === Number(2) || item.toProductionStatus === Number(1)">
                            <img v-if="getProcessImage(item.currentType)" :src="getProcessImage(item.currentType)" :alt="item.currentType" style="height: 24px;cursor: pointer;">
                            <span v-else>{{ item.currentType || '/' }}</span>
                          </template>
                          <template v-else-if="item.toProductionStatus === Number(3)">完成生产</template>
                          <!-- <span v-else>/</span> -->
                        </td>
                        <td class="text-center" style="white-space: normal; word-break: break-all;">
                          {{ item.description || '/' }}
                        </td>
                        <!-- <td class="text-center">{{ item.salesmanName }}</td> -->
                        <td class="text-center">{{ formatIntDateProduction(item.deliveryTime) }}</td>
                        <td class="text-center">{{ formatIntDateProduction(item.productionAssignTime) }}</td>
                        <td class="text-center" style="white-space: normal; word-break: break-all;">
                          <template v-if="item.productionNode && item.productionNode.length > 0">
                            <span class="production-node" v-for="(citem, cindex) in item.productionNode" :key="cindex">
                              <template v-if="cindex === item.productionNode.length - 1">{{ citem }}</template>
                              <template v-else>{{ citem }}/</template>
                            </span>
                          </template>
                          <span v-else>/</span>
                        </td>
                        <td class="text-center">
                          <template v-if="showProductChoosePurchase">
                            <v-checkbox
                              v-if="item.productionInvalidStatus !== Number(1)"
                              class="material-checkbox"
                              :model-value="selectedProducts.includes(item.id)"
                              @change="handleSelectProduct(item)"
                              hide-details
                              density="compact"
                            ></v-checkbox>
                          </template>
                          <template v-else>
                            <div style="display: flex;justify-content: center;align-items: center;">
                              <v-btn class="list-edit-btn" style="margin:0;margin-right: 8px;" @click="handleProductionToDesign(item)">
                                图纸
                              </v-btn>
                              <v-btn class="list-edit-btn" style="margin:0;margin-right: 8px;" @click="handleProductionToMaterialControl(item)">
                                物控
                              </v-btn>
                              <v-btn
                                v-if="item.productionBomId && item.productionBomId !== null && item.productionBomId !== ''"
                                color="primary"
                                variant="flat"
                                style="margin: 0!important;margin-right: 8px;height: 28px;width: 52px;min-width: 52px;padding: 0;"
                                @click="handleProductionMaterial(item, index)"
                              >
                                料单
                              </v-btn>
                              <v-btn
                                v-else
                                color="primary"
                                variant="flat"
                                style="width: 52px;height:28px;background: #3b3b3b!important;color: #F4F4F4!important;box-shadow: 0 2px 4px #3b3b3b !important;font-size: 10px!important;margin: 0px!important;height: 28px!important;min-width: 52px!important;padding: 0!important;"
                              >
                                暂无料单
                              </v-btn>
                            </div>
                            <!-- <v-btn
                              v-if="item.productionBomId && item.productionBomId !== null && item.productionBomId !== ''"
                              color="primary"
                              variant="flat"
                              style="height: 28px;width: 80px;min-width: 80px;padding: 0;"
                              @click="handleProductionExportPdf(item)"
                            >
                              导出打印
                            </v-btn> -->
                          </template>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </v-table>
                <!-- 生产单分页 -->
                <div class="custom-pagination d-flex align-center justify-space-between mt-3">
                  <div class="pagination-info">共 {{ productionOrderTotal }} 条记录</div>
                  <div class="d-flex align-center">
                    <div class="pagination-controls">
                      <v-btn
                        icon="mdi-chevron-double-left"
                        variant="text"
                        density="comfortable"
                        :disabled="productionOrderPage === 1"
                        @click="productionOrderPage = 1; loadProductionOrderList()"
                        class="pagination-btn"
                      />
                      <v-btn
                        icon="mdi-chevron-left"
                        variant="text"
                        density="comfortable"
                        :disabled="productionOrderPage === 1"
                        @click="productionOrderPage--; loadProductionOrderList()"
                        class="pagination-btn"
                      />
                      <span class="pagination-text mx-2">{{ productionOrderPage }} / {{ productionOrderTotalPages }}</span>
                      <v-btn
                        icon="mdi-chevron-right"
                        variant="text"
                        density="comfortable"
                        :disabled="productionOrderPage === productionOrderTotalPages"
                        @click="productionOrderPage++; loadProductionOrderList()"
                        class="pagination-btn"
                      />
                      <v-btn
                        icon="mdi-chevron-double-right"
                        variant="text"
                        density="comfortable"
                        :disabled="productionOrderPage === productionOrderTotalPages"
                        @click="productionOrderPage = productionOrderTotalPages; loadProductionOrderList()"
                        class="pagination-btn"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <!-- 常规材料汇总 -->
              <div v-if="titleList[2].isChoosed" class="product-table-container">
                <div class="d-flex gap-2 search-type-toggle">
                  <v-btn-toggle v-model="materialSummarySearchType" mandatory class="button-group">
                    <v-btn value="materialSummaryProduct" class="toggle-button" variant="text">按品项</v-btn>
                    <v-btn value="materialSummaryMaterial" class="toggle-button" variant="text">按项目</v-btn>
                  </v-btn-toggle>
                </div>
                <!-- 按品项汇总 -->
                <v-table
                  v-if="materialSummarySearchType === 'materialSummaryProduct'"
                  class="table-border product-table material-table material-summary-table"
                  hover
                  fixed-header
                  :style="{ maxHeight: `calc(100vh - 350px)` }"
                >
                  <thead>
                    <tr>
                      <th
                        v-for="header in projectMaterialSummaryProductHeaders"
                        :key="header.key"
                        :class="['text-' + header.align]"
                        :style="{ width: `${Number(header.minWidth) + 1}px` }"
                      >
                        <div class="align-center">
                          <template v-if="header.key === 'materialName'">
                            <span style="color:#D2475D;font-weight: 800;">{{ header.title }}</span>
                          </template>
                          <template v-else>
                            {{ header.title }}
                          </template>

                          <!-- 物料名称筛选（常规材料汇总-按品项） -->
                          <v-menu v-if="header.key === 'materialName'" location="bottom" :close-on-content-click="false">
                            <template v-slot:activator="{ props }">
                              <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="materialSummarySearchForm.materialName.length > 0 ? '#D2475D' : undefined"
                                :class="materialSummarySearchForm.materialName.length > 0 ? 'filter-btn-active' : ''"
                              />
                            </template>
                            <v-card class="filter-menu">
                              <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                <div class="filter-checkbox-group">
                                  <v-checkbox
                                    v-for="option in materialmaterialNamesSummaryOptions"
                                    :key="option"
                                    :label="option"
                                    :model-value="materialSummarySearchForm.materialName.includes(option)"
                                    @update:model-value="(checked) => handleSummaryCheckboxChange('materialName', option, checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                  />
                                </div>
                              </v-card-text>
                              <v-divider />
                            </v-card>
                          </v-menu>

                          <!-- 产品筛选（常规材料汇总-按品项） -->
                          <v-menu v-if="header.key === 'product'" location="bottom" :close-on-content-click="false">
                            <template v-slot:activator="{ props }">
                              <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="materialSummarySearchForm.productName.length > 0 ? '#D2475D' : undefined"
                                :class="materialSummarySearchForm.productName.length > 0 ? 'filter-btn-active' : ''"
                              />
                            </template>
                            <v-card class="filter-menu">
                              <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                <div class="filter-checkbox-group">
                                  <v-checkbox
                                    v-for="option in materialproductNamesSummaryOptions"
                                    :key="option"
                                    :model-value="materialSummarySearchForm.productName.includes(option)"
                                    @update:model-value="(checked) => handleSummaryCheckboxChange('productName', option, checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                  >
                                    <template #label>
                                      <div class="d-flex flex-column">
                                        <span>{{ option }}</span>
                                        <!-- <span style="color: #898989;font-size: 12px;">{{ option }}</span> -->
                                      </div>
                                    </template>
                                  </v-checkbox>
                                </div>
                              </v-card-text>
                              <v-divider />
                            </v-card>
                          </v-menu>

                          <!-- 物料规格筛选（常规材料汇总-按品项） -->
                          <v-menu v-if="header.key === 'materialSpec'" location="bottom" :close-on-content-click="false">
                            <template v-slot:activator="{ props }">
                              <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="materialSummarySearchForm.materialSpec.length > 0 ? '#D2475D' : undefined"
                                :class="materialSummarySearchForm.materialSpec.length > 0 ? 'filter-btn-active' : ''"
                              />
                            </template>
                            <v-card class="filter-menu">
                              <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                <v-text-field
                                  v-model="materialSpecSummaryFilterKeyword"
                                  placeholder="搜索规格"
                                  density="compact"
                                  variant="outlined"
                                  clearable
                                  hide-details
                                  class="mb-2 search-menu"
                                />
                                <div class="filter-checkbox-group">
                                  <v-checkbox
                                    v-for="option in filteredMaterialSpecsSummaryOptions"
                                    :key="option"
                                    :label="option"
                                    :model-value="materialSummarySearchForm.materialSpec.includes(option)"
                                    @update:model-value="(checked) => handleSummaryCheckboxChange('materialSpec', option, checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                  />
                                </div>
                              </v-card-text>
                              <v-divider />
                            </v-card>
                          </v-menu>

                          <!-- 物料编号筛选（常规材料汇总-按品项） -->
                          <v-menu v-if="header.key === 'materialCode'" location="bottom" :close-on-content-click="false">
                            <template v-slot:activator="{ props }">
                              <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="materialSummarySearchForm.materialCode.length > 0 ? '#D2475D' : undefined"
                                :class="materialSummarySearchForm.materialCode.length > 0 ? 'filter-btn-active' : ''"
                              />
                            </template>
                            <v-card class="filter-menu">
                              <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                <v-text-field
                                  v-model="materialCodeSummaryFilterKeyword"
                                  placeholder="搜索编号"
                                  density="compact"
                                  variant="outlined"
                                  clearable
                                  hide-details
                                  class="mb-2 search-menu"
                                />
                                <div class="filter-checkbox-group">
                                  <v-checkbox
                                    v-for="option in filteredMaterialCodesSummaryOptions"
                                    :key="String(option)"
                                    :label="String(option)"
                                    :model-value="materialSummarySearchForm.materialCode.includes(String(option))"
                                    @update:model-value="(checked) => handleSummaryCheckboxChange('materialCode', String(option), checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                  />
                                </div>
                              </v-card-text>
                              <v-divider />
                              <v-card-actions class="pa-2 justify-end">
                                <v-btn size="small" variant="text" color="#D2475D" @click="materialSummarySearchForm.materialCode = []; handleMaterialSummarySearch()">清空</v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-menu>

                          <!-- 大类筛选（常规材料汇总-按品项） -->
                          <v-menu v-if="header.key === 'bigClass'" location="bottom" :close-on-content-click="false">
                            <template v-slot:activator="{ props }">
                              <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="materialSummarySearchForm.bigClass.length > 0 ? '#D2475D' : undefined"
                                :class="materialSummarySearchForm.bigClass.length > 0 ? 'filter-btn-active' : ''"
                              />
                            </template>
                            <v-card class="filter-menu">
                              <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                <div class="filter-checkbox-group">
                                  <v-checkbox
                                    v-for="option in materialbigClassesSummaryOptions"
                                    :key="option"
                                    :label="option"
                                    :model-value="materialSummarySearchForm.bigClass.includes(option)"
                                    @update:model-value="(checked) => handleSummaryCheckboxChange('bigClass', option, checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                  />
                                </div>
                              </v-card-text>
                              <v-divider />
                            </v-card>
                          </v-menu>

                          <!-- 小类筛选（常规材料汇总-按品项） -->
                          <v-menu v-if="header.key === 'smallClass'" location="bottom" :close-on-content-click="false">
                            <template v-slot:activator="{ props }">
                              <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="materialSummarySearchForm.smallClass.length > 0 ? '#D2475D' : undefined"
                                :class="materialSummarySearchForm.smallClass.length > 0 ? 'filter-btn-active' : ''"
                              />
                            </template>
                            <v-card class="filter-menu">
                              <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                <div class="filter-checkbox-group">
                                  <v-checkbox
                                    v-for="option in materialsmallClassesSummaryOptions"
                                    :key="option"
                                    :label="option"
                                    :model-value="materialSummarySearchForm.smallClass.includes(option)"
                                    @update:model-value="(checked) => handleSummaryCheckboxChange('smallClass', option, checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                  />
                                </div>
                              </v-card-text>
                              <v-divider />
                            </v-card>
                          </v-menu>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody class="material-summary-table-body">
                    <tr v-if="loadingMaterialSummary" class="text-center">
                      <td :colspan="projectMaterialSummaryProductHeaders.length" class="py-8">
                        <v-progress-circular indeterminate color="primary" size="40" width="3"></v-progress-circular>
                        <div class="mt-2 text-grey">加载中...</div>
                      </td>
                    </tr>
                    <tr
                      v-else-if="materialSummaryProductList.length === 0"
                      class="text-center"
                    >
                      <td :colspan="projectMaterialSummaryProductHeaders.length" class="py-8">
                        料单暂无数据
                      </td>
                    </tr>
                    <template v-else>
                      <template
                        v-for="(productItem, pIndex) in materialSummaryProductList"
                        :key="pIndex"
                      >
                        <tr
                          v-for="(item, index) in productItem.summaryList || []"
                          :key="`${pIndex}-${index}`"
                        >
                          <!-- 产品信息，仅在每个产品的首行展示，行合并 -->
                          <!-- 产品图列 -->
                          <td
                            v-if="index === 0"
                            :rowspan="(productItem.summaryList && productItem.summaryList.length) || 1"
                            colspan="2"
                            class="product-info-cell-border text-left"
                          >
                            <div
                              v-if="productItem.product?.imageUrls && JSON.parse(productItem.product.imageUrls) && JSON.parse(productItem.product.imageUrls)[0]?.url"
                              style="position: relative;background:rgba(0, 0, 0, 0.5);width: 100px;height: 100px;line-height: 100px;"
                            >
                              <v-img
                                :src="JSON.parse(productItem.product.imageUrls)[0]?.url"
                                width="100"
                                height="100"
                              />
                              <v-img
                                v-if="productItem.product.typeOf == '一厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;"
                                :src="allotOneImg"
                                width="30"
                                height="18"
                              />
                              <v-img
                                v-if="productItem.product.typeOf == '二厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;"
                                :src="allotTwoImg"
                                width="30"
                                height="18"
                              />
                              <v-img
                                v-if="productItem.product.typeOf == '三厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;"
                                :src="allotThreeImg"
                                width="30"
                                height="18"
                              />
                              <v-img
                                v-if="productItem.product.typeOf == '四厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;"
                                :src="allotFourImg"
                                width="30"
                                height="18"
                              />
                            </div>
                            <div
                              v-else
                              class="no-img"
                              style="position: relative;width: 100px;height: 100px;line-height: 100px;"
                            >
                              <v-img
                                v-if="productItem.product.typeOf == '一厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;"
                                :src="allotOneImg"
                                width="30"
                                height="18"
                              />
                              <v-img
                                v-if="productItem.product.typeOf == '二厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;"
                                :src="allotTwoImg"
                                width="30"
                                height="18"
                              />
                              <v-img
                                v-if="productItem.product.typeOf == '三厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;"
                                :src="allotThreeImg"
                                width="30"
                                height="18"
                              />
                              <v-img
                                v-if="productItem.product.typeOf == '四厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;"
                                :src="allotFourImg"
                                width="30"
                                height="18"
                              />
                            </div>

                            <div class="product-text ml-2 text-left">
                              <div v-if="productItem.product?.name">{{ productItem.product?.name }}</div>
                              <!-- <div>{{ getProductDisplayName(productItem.product) }}</div> -->
                              <div style="font-size: 12px;color: rgb(143, 144, 147);" v-if="productItem.product?.code">{{ productItem.product?.code }}</div>
                              <div style="font-size: 12px;color: rgb(143, 144, 147);" v-if="productItem.product?.batch">{{ productItem.product?.batch }}</div>
                              <div style="font-size: 12px;color: rgb(143, 144, 147);" v-if="productItem.product?.syscode">{{ productItem.product?.syscode }}</div>
                              <div style="font-size: 12px;color: rgb(143, 144, 147);" v-if="productItem.product?.count">产品数量 {{ productItem.product?.count }}</div>
                              <div style="font-size: 12px;color: rgb(143, 144, 147);" v-if="productItem.product?.uploadUserName">料单上传人 {{ productItem.product?.uploadUserName }}</div>
                              <v-btn
                                style="margin-top: 6px;"
                                class="list-edit-btn"
                                @click="handleProductionManufactureToDesign(productItem.product)"
                              >
                                图纸
                              </v-btn>
                            </div>
                          </td>

                          <!-- <td class="text-center">
                            {{ item.partName || '/' }}
                          </td> -->
                          <td class="text-center">
                            {{ item.materialName || '/' }}
                          </td>
                          <td class="text-center">
                            {{ item.materialSpec || '/' }}
                          </td>
                          <td class="text-center">
                            {{ item.materialCode || '/' }}
                          </td>
                          <td class="text-center">
                            {{ item.bigClass || '/' }}
                          </td>
                          <td class="text-center">
                            {{ item.smallClass || '/' }}
                          </td>
                          <!-- <td class="text-center">
                            <template v-if="item.factoryUsageMap">
                              <template
                                v-for="(usage, factoryName) in item.factoryUsageMap"
                                :key="factoryName"
                              >
                                <div>
                                  {{ factoryName }}：{{ usage }}
                                  <template v-if="item.materialUsageUnit">
                                    {{ item.materialUsageUnit }}
                                  </template>
                                </div>
                              </template>
                            </template>
                            <template v-else>
                              /
                            </template>
                          </td> -->
                          <td class="text-center">
                            <template v-if="item.totalUsage">
                              {{ formatNumberUse(item.totalUsage, 4) }}
                              <template v-if="item.materialUsageUnit">
                                {{ item.materialUsageUnit }}
                              </template>
                            </template>
                            <template v-else>
                              /
                            </template>
                          </td>
                          <td class="text-center">
                            <template v-if="item.productUsageSum">
                              {{ formatNumberUse(item.productUsageSum, 4) }}
                              <template v-if="item.materialUsageUnit">
                                {{ item.materialUsageUnit }}
                              </template>
                            </template>
                            <template v-else>
                              /
                            </template>
                          </td>
                        <td class="text-center">
                          <v-btn
                            style="margin: 0!important;"
                            v-if="item.purchaseList?.length > 0"
                            class="list-edit-btn"
                            @click="handleSeeMaterialPurchaseList(item, 'material', materialSummarySearchType === 'materialSummaryProduct' ? 1 : 0)"
                          >
                            查看
                          </v-btn>
                          <v-img class="statusImg" v-if="item.purchaseItemList?.length > 0 && !item.purchaseList?.length" :src="yijiagouImg"/>
                        </td>
                        <td class="text-center">
                          <!-- <template v-if="item.purchaseList?.length > 0 || item.purchaseItemList?.length > 0"></template> -->
                          <!-- <template v-else> -->
                            <v-checkbox
                              class="material-checkbox"
                              v-if="showFactoryChoosePurchase"
                              :model-value="selectedFactoryMaterials.includes(buildFactorySummaryKey(item, productItem))"
                              @change="handleChooseFactorySummaryMaterial(item, index, productItem)"
                              hide-details
                              density="compact"
                            ></v-checkbox>
                          <!-- </template> -->
                        </td>
                        </tr>
                      </template>
                    </template>
                  </tbody>
                </v-table>
                <!-- 按项目汇总（常规材料汇总） -->
                <v-table v-if="materialSummarySearchType === 'materialSummaryMaterial'" class="table-border product-table material-table material-summary-table" hover fixed-header :style="{ maxHeight: `calc(100vh - 350px)` }">
                  <thead>
                    <tr>
                      <th
                        v-for="header in projectMaterialSummaryHeaders"
                        :key="header.key"
                        :class="['text-' + header.align]"
                        :style="{ width: `${Number(header.minWidth) + 1}px` }"
                      >
                        <div class="align-center">
                          <template v-if="header.key === 'materialName'">
                            <span style="color:#D2475D;font-weight: 800;">{{ header.title }}</span>
                          </template>
                          <template v-else>
                            {{ header.title }}
                          </template>

                          <!-- 物料名称筛选（常规材料汇总） -->
                          <v-menu v-if="header.key === 'materialName'" location="bottom" :close-on-content-click="false">
                            <template v-slot:activator="{ props }">
                              <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="materialSummarySearchForm.materialName.length > 0 ? '#D2475D' : undefined"
                                :class="materialSummarySearchForm.materialName.length > 0 ? 'filter-btn-active' : ''"
                              />
                            </template>
                            <v-card class="filter-menu">
                              <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                <div class="filter-checkbox-group">
                                  <v-checkbox
                                    v-for="option in materialmaterialNamesSummaryOptions"
                                    :key="option"
                                    :label="option"
                                    :model-value="materialSummarySearchForm.materialName.includes(option)"
                                    @update:model-value="(checked) => handleSummaryCheckboxChange('materialName', option, checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                  />
                                </div>
                              </v-card-text>
                              <v-divider />
                            </v-card>
                          </v-menu>

                          <!-- 物料规格筛选（常规材料汇总） -->
                          <v-menu v-if="header.key === 'materialSpec'" location="bottom" :close-on-content-click="false">
                            <template v-slot:activator="{ props }">
                              <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="materialSummarySearchForm.materialSpec.length > 0 ? '#D2475D' : undefined"
                                :class="materialSummarySearchForm.materialSpec.length > 0 ? 'filter-btn-active' : ''"
                              />
                            </template>
                            <v-card class="filter-menu">
                              <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                <v-text-field
                                  v-model="materialSpecFilterKeyword"
                                  placeholder="搜索规格"
                                  density="compact"
                                  variant="outlined"
                                  clearable
                                  hide-details
                                  class="mb-2 search-menu"
                                />
                                <div class="filter-checkbox-group">
                                  <v-checkbox
                                    v-for="option in filteredMaterialSpecsSummaryOptions"
                                    :key="option"
                                    :label="option"
                                    :model-value="materialSummarySearchForm.materialSpec.includes(option)"
                                    @update:model-value="(checked) => handleSummaryCheckboxChange('materialSpec', option, checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                  />
                                </div>
                              </v-card-text>
                              <v-divider />
                            </v-card>
                          </v-menu>

                          <!-- 物料编号筛选（常规材料汇总-按项目） -->
                          <v-menu v-if="header.key === 'materialCode'" location="bottom" :close-on-content-click="false">
                            <template v-slot:activator="{ props }">
                              <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="materialSummarySearchForm.materialCode.length > 0 ? '#D2475D' : undefined"
                                :class="materialSummarySearchForm.materialCode.length > 0 ? 'filter-btn-active' : ''"
                              />
                            </template>
                            <v-card class="filter-menu">
                              <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                <v-text-field
                                  v-model="materialCodeSummaryFilterKeyword"
                                  placeholder="搜索编号"
                                  density="compact"
                                  variant="outlined"
                                  clearable
                                  hide-details
                                  class="mb-2 search-menu"
                                />
                                <div class="filter-checkbox-group">
                                  <v-checkbox
                                    v-for="option in filteredMaterialCodesSummaryOptions"
                                    :key="String(option)"
                                    :label="String(option)"
                                    :model-value="materialSummarySearchForm.materialCode.includes(String(option))"
                                    @update:model-value="(checked) => handleSummaryCheckboxChange('materialCode', String(option), checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                  />
                                </div>
                              </v-card-text>
                              <v-divider />
                              <v-card-actions class="pa-2 justify-end">
                                <v-btn size="small" variant="text" color="#D2475D" @click="materialSummarySearchForm.materialCode = []; handleMaterialSummarySearch()">清空</v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-menu>

                          <!-- 大类筛选（常规材料汇总） -->
                          <v-menu v-if="header.key === 'bigClass'" location="bottom" :close-on-content-click="false">
                            <template v-slot:activator="{ props }">
                              <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="materialSummarySearchForm.bigClass.length > 0 ? '#D2475D' : undefined"
                                :class="materialSummarySearchForm.bigClass.length > 0 ? 'filter-btn-active' : ''"
                              />
                            </template>
                            <v-card class="filter-menu">
                              <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                <div class="filter-checkbox-group">
                                  <v-checkbox
                                    v-for="option in materialbigClassesSummaryOptions"
                                    :key="option"
                                    :label="option"
                                    :model-value="materialSummarySearchForm.bigClass.includes(option)"
                                    @update:model-value="(checked) => handleSummaryCheckboxChange('bigClass', option, checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                  />
                                </div>
                              </v-card-text>
                              <v-divider />
                            </v-card>
                          </v-menu>

                          <!-- 小类筛选（常规材料汇总） -->
                          <v-menu v-if="header.key === 'smallClass'" location="bottom" :close-on-content-click="false">
                            <template v-slot:activator="{ props }">
                              <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="materialSummarySearchForm.smallClass.length > 0 ? '#D2475D' : undefined"
                                :class="materialSummarySearchForm.smallClass.length > 0 ? 'filter-btn-active' : ''"
                              />
                            </template>
                            <v-card class="filter-menu">
                              <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                <div class="filter-checkbox-group">
                                  <v-checkbox
                                    v-for="option in materialsmallClassesSummaryOptions"
                                    :key="option"
                                    :label="option"
                                    :model-value="materialSummarySearchForm.smallClass.includes(option)"
                                    @update:model-value="(checked) => handleSummaryCheckboxChange('smallClass', option, checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                  />
                                </div>
                              </v-card-text>
                              <v-divider />
                            </v-card>
                          </v-menu>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody class="material-summary-table-body">
                    <tr v-if="loadingMaterialSummary" class="text-center">
                      <td :colspan="projectMaterialSummaryHeaders.length" class="py-8">
                        <v-progress-circular indeterminate color="primary" size="40" width="3"></v-progress-circular>
                        <div class="mt-2 text-grey">加载中...</div>
                      </td>
                    </tr>
                    <tr v-else-if="mergeProductionBomSummaryItems.length === 0" class="text-center">
                      <td :colspan="projectMaterialSummaryHeaders.length" class="py-8">料单暂无数据</td>
                    </tr>
                    <template v-else>
                      <tr
                        v-for="(item, index) in mergeProductionBomSummaryItems"
                        :key="index"
                      >
                        <td></td>
                        <td class="text-left" style="text-align: left !important;">
                          {{ item.materialName || '/' }}
                        </td>
                        <td class="text-center">
                          {{ item.materialSpec || '/' }}
                        </td>
                        <td class="text-center">
                          {{ item.materialCode || '/' }}
                        </td>
                        <!-- <td class="text-center">
                          {{ item.purchaseList?.length || '/' }}
                        </td> -->
                        <td class="text-center">
                          {{ item.bigClass || '/' }}
                        </td>
                        <td class="text-center">
                          {{ item.smallClass || '/' }}
                        </td>
                        <td class="text-center">
                          <template v-if="item.factoryUsageMap">
                            <template v-for="(usage, factoryName) in item.factoryUsageMap" :key="factoryName">
                              <div>
                                {{ factoryName }}：{{ usage }}
                                <template v-if="item.materialUsageUnit">
                                  {{ item.materialUsageUnit }}
                                </template>
                              </div>
                            </template>
                          </template>
                          <template v-else>
                            /
                          </template>
                        </td>
                        <!-- <td class="text-center">
                          <template v-if="item.totalUsage">
                            {{ item.totalUsage}}
                            <template v-if="item.materialUsageUnit">
                              {{ item.materialUsageUnit }}
                            </template>
                          </template>
                          <template v-else>
                            /
                          </template>
                        </td> -->
                        <td class="text-center">
                          <template v-if="item.productUsageSum">
                            {{ formatNumberUse(item.productUsageSum, 4) }}
                            <template v-if="item.materialUsageUnit">
                              {{ item.materialUsageUnit }}
                            </template>
                          </template>
                          <template v-else>
                            /
                          </template>
                        </td>
                        <td class="text-center">
                          <v-btn
                            style="margin: 0!important;"
                            v-if="item.purchaseList?.length > 0"
                            class="list-edit-btn"
                            @click="handleSeeMaterialPurchaseList(item, 'material', 0)"
                          >
                            查看
                          </v-btn>
                          <v-img class="statusImg" v-if="item.purchaseItemList?.length > 0 && !item.purchaseList?.length" :src="yijiagouImg"/>
                        </td>
                        <!-- v-if="showFactoryChoosePurchase && item.materialName" -->
                        <td class="text-center">
                          <!-- <template v-if="item.purchaseList?.length > 0 || item.purchaseItemList?.length > 0"></template>
                          <template v-else> -->
                            <v-checkbox
                              class="material-checkbox"
                              v-if="showFactoryChoosePurchase"
                              :model-value="selectedFactoryMaterials.includes(index)"
                              @change="handleChooseFactorySummaryMaterial(item, index)"
                              hide-details
                              density="compact"
                            ></v-checkbox>
                          <!-- </template> -->
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </v-table>
                <!-- 常规材料汇总分页 -->
                <div class="custom-pagination d-flex align-center justify-space-between">
                  <div class="pagination-info">共 {{ materialSummaryPagination.total }} 条记录</div>
                  
                  <div class="d-flex align-center">
                    <div class="pagination-controls">
                      <v-btn
                        icon="mdi-chevron-double-left"
                        variant="text"
                        density="comfortable"
                        :disabled="materialSummaryPagination.page === 1"
                        @click="handleMaterialSummaryPageChange(1)"
                        class="pagination-btn"
                      />
                      <v-btn
                        icon="mdi-chevron-left"
                        variant="text"
                        density="comfortable"
                        :disabled="materialSummaryPagination.page === 1"
                        @click="handleMaterialSummaryPageChange(materialSummaryPagination.page - 1)"
                        class="pagination-btn"
                      />
                      <span class="pagination-text mx-2">{{ materialSummaryPagination.page }} / {{ materialSummaryTotalPages }}</span>
                      <v-btn
                        icon="mdi-chevron-right"
                        variant="text"
                        density="comfortable"
                        :disabled="materialSummaryPagination.page === materialSummaryTotalPages"
                        @click="handleMaterialSummaryPageChange(materialSummaryPagination.page + 1)"
                        class="pagination-btn"
                      />
                      <v-btn
                        icon="mdi-chevron-double-right"
                        variant="text"
                        density="comfortable"
                        :disabled="materialSummaryPagination.page === materialSummaryTotalPages"
                        @click="handleMaterialSummaryPageChange(materialSummaryTotalPages)"
                        class="pagination-btn"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <!-- 定制&五金汇总 -->
              <div v-if="titleList[3].isChoosed" class="product-table-container">
                <div class="d-flex gap-2 search-type-toggle">
                  <v-btn-toggle v-model="metalSummarySearchType" mandatory class="button-group">
                    <v-btn value="metalSummaryProduct" class="toggle-button" variant="text">按品项</v-btn>
                    <v-btn value="metalSummaryMaterial" class="toggle-button" variant="text">按项目</v-btn>
                  </v-btn-toggle>
                </div>
                <!-- 定制&五金汇总 - 按品项 -->
                <v-table
                  v-if="metalSummarySearchType === 'metalSummaryProduct'"
                  class="table-border product-table material-table material-summary-table"
                  hover
                  fixed-header
                  :style="{ maxHeight: `calc(100vh - 350px)` }"
                >
                  <thead>
                    <tr>
                      <th
                        v-for="header in projectFiveMetalSummaryProductHeaders"
                        :key="header.key"
                        :class="['text-' + header.align]"
                        :style="{ minWidth: `${Number(header.minWidth) + 1}px` }"
                      >
                        <div class="align-center">
                          <template v-if="header.key === 'materialName'">
                            <span style="color:#D2475D;font-weight: 800;">{{ header.title }}</span>
                          </template>
                          <template v-else>
                            {{ header.title }}
                          </template>

                          <!-- 产品筛选（定制&五金汇总-按品项） -->
                          <v-menu v-if="header.key === 'product'" location="bottom" :close-on-content-click="false">
                            <template v-slot:activator="{ props }">
                              <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="metalSummarySearchForm.productName.length > 0 ? '#D2475D' : undefined"
                                :class="metalSummarySearchForm.productName.length > 0 ? 'filter-btn-active' : ''"
                              />
                            </template>
                            <v-card class="filter-menu">
                              <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                <div class="filter-checkbox-group">
                                  <v-checkbox
                                    v-for="option in metalproductNamesOptions"
                                    :key="option"
                                    :label="option"
                                    :model-value="metalSummarySearchForm.productName.includes(option)"
                                    @update:model-value="(checked) => handleMetalSummaryCheckboxChange('productName', option, checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                  />
                                </div>
                              </v-card-text>
                              <v-divider />
                            </v-card>
                          </v-menu>

                          <!-- 零件筛选（定制&五金汇总-按品项） -->
                          <v-menu v-if="header.key === 'partName'" location="bottom" :close-on-content-click="false">
                            <template v-slot:activator="{ props }">
                              <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="metalSummarySearchForm.partName.length > 0 ? '#D2475D' : undefined"
                                :class="metalSummarySearchForm.partName.length > 0 ? 'filter-btn-active' : ''"
                              />
                            </template>
                            <v-card class="filter-menu">
                              <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                <div class="filter-checkbox-group">
                                  <v-checkbox
                                    v-for="option in metalSummaryPartNamesOptions"
                                    :key="option"
                                    :label="option"
                                    :model-value="metalSummarySearchForm.partName.includes(option)"
                                    @update:model-value="(checked) => handleMetalSummaryCheckboxChange('partName', option, checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                  />
                                </div>
                              </v-card-text>
                              <v-divider />
                            </v-card>
                          </v-menu>

                          <!-- 物料名称筛选（定制&五金汇总-按品项） -->
                          <v-menu v-if="header.key === 'materialName'" location="bottom" :close-on-content-click="false">
                            <template v-slot:activator="{ props }">
                              <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="metalSummarySearchForm.materialName.length > 0 ? '#D2475D' : undefined"
                                :class="metalSummarySearchForm.materialName.length > 0 ? 'filter-btn-active' : ''"
                              />
                            </template>
                            <v-card class="filter-menu">
                              <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                <div class="filter-checkbox-group">
                                  <v-checkbox
                                    v-for="option in metalSummaryMaterialNamesOptions"
                                    :key="option"
                                    :label="option"
                                    :model-value="metalSummarySearchForm.materialName.includes(option)"
                                    @update:model-value="(checked) => handleMetalSummaryCheckboxChange('materialName', option, checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                  />
                                </div>
                              </v-card-text>
                              <v-divider />
                            </v-card>
                          </v-menu>

                          <!-- 物料规格筛选（定制&五金汇总-按品项） -->
                          <v-menu v-if="header.key === 'materialSpec'" location="bottom" :close-on-content-click="false">
                            <template v-slot:activator="{ props }">
                              <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="metalSummarySearchForm.materialSpec.length > 0 ? '#D2475D' : undefined"
                                :class="metalSummarySearchForm.materialSpec.length > 0 ? 'filter-btn-active' : ''"
                              />
                            </template>
                            <v-card class="filter-menu">
                              <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                <v-text-field
                                  v-model="metalSummaryMetalSpecFilterKeyword"
                                  placeholder="搜索规格"
                                  density="compact"
                                  variant="outlined"
                                  clearable
                                  hide-details
                                  class="mb-2 search-menu"
                                />
                                <div class="filter-checkbox-group">
                                  <v-checkbox
                                    v-for="option in filteredMetalSummaryMetalSpecsOptions"
                                    :key="option"
                                    :label="option"
                                    :model-value="metalSummarySearchForm.materialSpec.includes(option)"
                                    @update:model-value="(checked) => handleMetalSummaryCheckboxChange('materialSpec', option, checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                  />
                                </div>
                              </v-card-text>
                              <v-divider />
                            </v-card>
                          </v-menu>

                          <!-- 物料编号筛选（定制&五金汇总-按品项） -->
                          <v-menu v-if="header.key === 'materialCode'" location="bottom" :close-on-content-click="false">
                            <template v-slot:activator="{ props }">
                              <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="metalSummarySearchForm.materialCode.length > 0 ? '#D2475D' : undefined"
                                :class="metalSummarySearchForm.materialCode.length > 0 ? 'filter-btn-active' : ''"
                              />
                            </template>
                            <v-card class="filter-menu">
                              <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                <v-text-field
                                  v-model="metalSummaryMaterialCodeFilterKeyword"
                                  placeholder="搜索编号"
                                  density="compact"
                                  variant="outlined"
                                  clearable
                                  hide-details
                                  class="mb-2 search-menu"
                                />
                                <div class="filter-checkbox-group">
                                  <v-checkbox
                                    v-for="option in filteredMetalSummaryMaterialCodesOptions"
                                    :key="String(option)"
                                    :label="String(option)"
                                    :model-value="metalSummarySearchForm.materialCode.includes(String(option))"
                                    @update:model-value="(checked) => handleMetalSummaryCheckboxChange('materialCode', String(option), checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                  />
                                </div>
                              </v-card-text>
                              <v-divider />
                              <v-card-actions class="pa-2 justify-end">
                                <v-btn size="small" variant="text" color="#D2475D" @click="metalSummarySearchForm.materialCode = []; handleMetalSummarySearch()">清空</v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-menu>

                          <!-- 大类筛选（定制&五金汇总-按品项） -->
                          <v-menu v-if="header.key === 'bigClass'" location="bottom" :close-on-content-click="false">
                            <template v-slot:activator="{ props }">
                              <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="metalSummarySearchForm.bigClass.length > 0 ? '#D2475D' : undefined"
                                :class="metalSummarySearchForm.bigClass.length > 0 ? 'filter-btn-active' : ''"
                              />
                            </template>
                            <v-card class="filter-menu">
                              <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                <div class="filter-checkbox-group">
                                  <v-checkbox
                                    v-for="option in metalSummaryBigClassesOptions"
                                    :key="option"
                                    :label="option"
                                    :model-value="metalSummarySearchForm.bigClass.includes(option)"
                                    @update:model-value="(checked) => handleMetalSummaryCheckboxChange('bigClass', option, checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                  />
                                </div>
                              </v-card-text>
                              <v-divider />
                            </v-card>
                          </v-menu>

                          <!-- 小类筛选（定制&五金汇总-按品项） -->
                          <v-menu v-if="header.key === 'smallClass'" location="bottom" :close-on-content-click="false">
                            <template v-slot:activator="{ props }">
                              <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="metalSummarySearchForm.smallClass.length > 0 ? '#D2475D' : undefined"
                                :class="metalSummarySearchForm.smallClass.length > 0 ? 'filter-btn-active' : ''"
                              />
                            </template>
                            <v-card class="filter-menu">
                              <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                <div class="filter-checkbox-group">
                                  <v-checkbox
                                    v-for="option in metalSummarySmallClassesOptions"
                                    :key="option"
                                    :label="option"
                                    :model-value="metalSummarySearchForm.smallClass.includes(option)"
                                    @update:model-value="(checked) => handleMetalSummaryCheckboxChange('smallClass', option, checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                  />
                                </div>
                              </v-card-text>
                              <v-divider />
                            </v-card>
                          </v-menu>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody class="material-summary-table-body">
                    <tr v-if="loadingMetalSummary" class="text-center">
                      <td :colspan="projectFiveMetalSummaryProductHeaders.length" class="py-8">
                        <v-progress-circular indeterminate color="primary" size="40" width="3" />
                        <div class="mt-2 text-grey">加载中...</div>
                      </td>
                    </tr>
                    <tr
                      v-else-if="mergeProductionMetalSummaryProductItems.length === 0"
                      class="text-center"
                    >
                      <td :colspan="projectFiveMetalSummaryProductHeaders.length" class="py-8">
                        料单暂无数据
                      </td>
                    </tr>
                    <template v-else>
                      <template
                        v-for="(productItem, pIndex) in mergeProductionMetalSummaryProductItems"
                        :key="pIndex"
                      >
                        <tr
                          v-for="(item, index) in productItem.summaryList || []"
                          :key="`${pIndex}-${index}`"
                        >
                          <!-- 产品图列 -->
                          <td
                            v-if="index === 0"
                            :rowspan="(productItem.summaryList && productItem.summaryList.length) || 1"
                            colspan="2"
                            class="product-info-cell-border text-left"
                          >
                            <div
                              v-if="productItem.product?.imageUrls && JSON.parse(productItem.product.imageUrls) && JSON.parse(productItem.product.imageUrls)[0]?.url"
                              style="position: relative;background:rgba(0, 0, 0, 0.5);width: 100px;height: 100px;line-height: 100px;"
                            >
                              <v-img
                                :src="JSON.parse(productItem.product.imageUrls)[0]?.url"
                                width="100"
                                height="100"
                              />
                              <v-img
                                v-if="productItem.product.typeOf == '一厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;"
                                :src="allotOneImg"
                                width="30"
                                height="18"
                              />
                              <v-img
                                v-if="productItem.product.typeOf == '二厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;"
                                :src="allotTwoImg"
                                width="30"
                                height="18"
                              />
                              <v-img
                                v-if="productItem.product.typeOf == '三厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;"
                                :src="allotThreeImg"
                                width="30"
                                height="18"
                              />
                              <v-img
                                v-if="productItem.product.typeOf == '四厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;"
                                :src="allotFourImg"
                                width="30"
                                height="18"
                              />
                            </div>
                            <div
                              v-else
                              class="no-img"
                              style="position: relative;width: 100px;height: 100px;line-height: 100px;"
                            >
                              <v-img
                                v-if="productItem.product.typeOf == '一厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;"
                                :src="allotOneImg"
                                width="30"
                                height="18"
                              />
                              <v-img
                                v-if="productItem.product.typeOf == '二厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;"
                                :src="allotTwoImg"
                                width="30"
                                height="18"
                              />
                              <v-img
                                v-if="productItem.product.typeOf == '三厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;"
                                :src="allotThreeImg"
                                width="30"
                                height="18"
                              />
                              <v-img
                                v-if="productItem.product.typeOf == '四厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;"
                                :src="allotFourImg"
                                width="30"
                                height="18"
                              />
                            </div>

                            <div class="product-text ml-2 text-left">
                              <div v-if="productItem.product?.name">{{ productItem.product?.name }}</div>
                              <!-- <div>{{ getProductDisplayName(productItem.product) }}</div> -->
                              <div style="font-size: 12px;color: rgb(143, 144, 147);" v-if="productItem.product?.code">{{ productItem.product?.code }}</div>
                              <div style="font-size: 12px;color: rgb(143, 144, 147);" v-if="productItem.product?.batch">{{ productItem.product?.batch }}</div>
                              <div style="font-size: 12px;color: rgb(143, 144, 147);" v-if="productItem.product?.syscode">{{ productItem.product?.syscode }}</div>
                              <div style="font-size: 12px;color: rgb(143, 144, 147);" v-if="productItem.product?.count">产品数量 {{ productItem.product?.count }}</div>
                              <div style="font-size: 12px;color: rgb(143, 144, 147);" v-if="productItem.product?.uploadUserName">料单上传人 {{ productItem.product?.uploadUserName }}</div>
                              <v-btn
                                style="margin-top: 6px;"
                                class="list-edit-btn"
                                @click="handleProductionManufactureToDesign(productItem.product)"
                              >
                                图纸
                              </v-btn>
                            </div>
                          </td>

                          <!-- 材料相关列 -->
                          <td class="text-center">
                            {{ item.partName || '/' }}
                          </td>
                          <td class="text-center">
                            {{ item.materialName || '/' }}
                          </td>
                          <td class="text-center">
                            {{ item.materialSpec || '/' }}
                          </td>
                          <td class="text-center">
                            {{ item.materialCode || '/' }}
                          </td>
                          <td class="text-left" style="padding-left: 16px!important;text-align: left!important;">
                            <template v-if="item.width || item.depth || item.height">
                              <template v-if="item.width">
                                W:{{ item.width || '/' }} <br>
                              </template>
                              <template v-if="item.depth">
                                D:{{ item.depth || '/' }} <br>
                              </template>
                              <template v-if="item.height">
                                H:{{ item.height || '/' }}
                              </template>
                            </template>
                            <template v-else>
                              /
                            </template>
                          </td>
                          <td class="text-center">
                            {{ item.remark || '/' }}
                          </td>
                          <td class="text-center">
                            {{ item.bigClass || '/' }}
                          </td>
                          <td class="text-center">
                            {{ item.smallClass || '/' }}
                          </td>
                          <!-- <td class="text-center">
                            <template v-if="item.factoryUsageMap">
                              <template
                                v-for="(usage, factoryName) in item.factoryUsageMap"
                                :key="factoryName"
                              >
                                <div>
                                  {{ factoryName }}：{{ usage }}
                                  <template v-if="item.materialUsageUnit">
                                    {{ item.materialUsageUnit }}
                                  </template>
                                </div>
                              </template>
                            </template>
                            <template v-else>
                              /
                            </template>
                          </td> -->
                          <td class="text-center">
                            <template v-if="item.totalUsage">
                              {{ formatNumberUse(item.totalUsage, 4) }}
                              <template v-if="item.materialUsageUnit">
                                {{ item.materialUsageUnit }}
                              </template>
                            </template>
                            <template v-else>
                              /
                            </template>
                          </td>
                          <td class="text-center">
                            <template v-if="item.productUsageSum">
                              {{ formatNumberUse(item.productUsageSum, 4) }}
                              <template v-if="item.materialUsageUnit">
                                {{ item.materialUsageUnit }}
                              </template>
                            </template>
                            <template v-else>
                              /
                            </template>
                          </td>
                          <td class="text-center">
                            <v-btn
                              style="margin: 0!important;"
                              v-if="item.purchaseList?.length > 0"
                              class="list-edit-btn"
                              @click="handleSeeMaterialPurchaseList(item,'hardware', metalSummarySearchType === 'metalSummaryProduct' ? 1 : 0)"
                            >
                              查看
                            </v-btn>
                            <v-img class="statusImg" v-if="item.purchaseItemList?.length > 0 && !item.purchaseList?.length" :src="yijiagouImg"/>
                          </td>
                          <td class="text-center">
                            <!-- <template v-if="item.purchaseList?.length > 0 || item.purchaseItemList?.length > 0"></template>
                            <template v-else> -->
                              <v-checkbox
                                class="material-checkbox"
                                v-if="showFactoryChoosePurchaseHardware"
                                :model-value="selectedHardwareMaterials.includes(buildHardwareSummaryKey(item, productItem))"
                                @change="handleChooseHardwareSummaryMaterial(item, index, productItem)"
                                hide-details
                                density="compact"
                              />
                            <!-- </template> -->
                          </td>
                        </tr>
                      </template>
                    </template>
                  </tbody>
                </v-table>
                <!-- 按项目汇总（定制&五金汇总） -->
                <v-table v-if="metalSummarySearchType === 'metalSummaryMaterial'" class="table-border product-table material-table material-summary-table" hover fixed-header :style="{ maxHeight: `calc(100vh - 350px)` }">
                  <thead>
                    <tr>
                      <th
                        v-for="header in projectFiveMetalSummaryHeaders"
                        :key="header.key"
                        :class="['text-' + header.align]"
                        :style="{ minWidth: `${Number(header.minWidth) + 1}px` }"
                      >
                        <template v-if="header.key === 'materialName'">
                          <span style="color:#D2475D;font-weight: 800;">{{ header.title }}</span>
                        </template>
                        <template v-else>
                          {{ header.title }}
                        </template>

                        <!-- 零件筛选（定制&五金汇总） -->
                        <v-menu v-if="header.key === 'partName'" location="bottom" :close-on-content-click="false">
                          <template v-slot:activator="{ props }">
                            <v-btn
                              icon="mdi-filter"
                              variant="text"
                              density="compact"
                              size="small"
                              v-bind="props"
                              :color="metalSummarySearchForm.partName.length > 0 ? '#D2475D' : undefined"
                              :class="metalSummarySearchForm.partName.length > 0 ? 'filter-btn-active' : ''"
                            />
                          </template>
                          <v-card class="filter-menu">
                            <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                              <div class="filter-checkbox-group">
                                <v-checkbox
                                  v-for="option in metalSummaryPartNamesOptions"
                                  :key="option"
                                  :label="option"
                                  :model-value="metalSummarySearchForm.partName.includes(option)"
                                  @update:model-value="(checked) => handleMetalSummaryCheckboxChange('partName', option, checked)"
                                  color="#D2475D"
                                  density="compact"
                                  hide-details
                                />
                              </div>
                            </v-card-text>
                            <v-divider />
                          </v-card>
                        </v-menu>

                        <!-- 物料名称筛选（定制&五金汇总） -->
                        <v-menu v-if="header.key === 'materialName'" location="bottom" :close-on-content-click="false">
                          <template v-slot:activator="{ props }">
                            <v-btn
                              icon="mdi-filter"
                              variant="text"
                              density="compact"
                              size="small"
                              v-bind="props"
                              :color="metalSummarySearchForm.materialName.length > 0 ? '#D2475D' : undefined"
                              :class="metalSummarySearchForm.materialName.length > 0 ? 'filter-btn-active' : ''"
                            />
                          </template>
                          <v-card class="filter-menu">
                            <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                              <div class="filter-checkbox-group">
                                <v-checkbox
                                  v-for="option in metalSummaryMaterialNamesOptions"
                                  :key="option"
                                  :label="option"
                                  :model-value="metalSummarySearchForm.materialName.includes(option)"
                                  @update:model-value="(checked) => handleMetalSummaryCheckboxChange('materialName', option, checked)"
                                  color="#D2475D"
                                  density="compact"
                                  hide-details
                                />
                              </div>
                            </v-card-text>
                            <v-divider />
                          </v-card>
                        </v-menu>

                        <!-- 物料规格筛选（定制&五金汇总-按项目） -->
                        <v-menu v-if="header.key === 'materialSpec'" location="bottom" :close-on-content-click="false">
                          <template v-slot:activator="{ props }">
                            <v-btn
                              icon="mdi-filter"
                              variant="text"
                              density="compact"
                              size="small"
                              v-bind="props"
                              :color="metalSummarySearchForm.materialSpec.length > 0 ? '#D2475D' : undefined"
                              :class="metalSummarySearchForm.materialSpec.length > 0 ? 'filter-btn-active' : ''"
                            />
                          </template>
                          <v-card class="filter-menu">
                            <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                              <v-text-field
                                v-model="metalSummaryMetalSpecFilterKeyword"
                                placeholder="搜索规格"
                                density="compact"
                                variant="outlined"
                                clearable
                                hide-details
                                class="mb-2 search-menu"
                              />
                              <div class="filter-checkbox-group">
                                <v-checkbox
                                  v-for="option in filteredMetalSummaryMetalSpecsOptions"
                                  :key="option"
                                  :label="option"
                                  :model-value="metalSummarySearchForm.materialSpec.includes(option)"
                                  @update:model-value="(checked) => handleMetalSummaryCheckboxChange('materialSpec', option, checked)"
                                  color="#D2475D"
                                  density="compact"
                                  hide-details
                                />
                              </div>
                            </v-card-text>
                            <v-divider />
                          </v-card>
                        </v-menu>

                        <!-- 物料编号筛选（定制&五金汇总-按项目） -->
                        <v-menu v-if="header.key === 'materialCode'" location="bottom" :close-on-content-click="false">
                          <template v-slot:activator="{ props }">
                            <v-btn
                              icon="mdi-filter"
                              variant="text"
                              density="compact"
                              size="small"
                              v-bind="props"
                              :color="metalSummarySearchForm.materialCode.length > 0 ? '#D2475D' : undefined"
                              :class="metalSummarySearchForm.materialCode.length > 0 ? 'filter-btn-active' : ''"
                            />
                          </template>
                          <v-card class="filter-menu">
                            <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                              <v-text-field
                                v-model="metalSummaryMaterialCodeFilterKeyword"
                                placeholder="搜索编号"
                                density="compact"
                                variant="outlined"
                                clearable
                                hide-details
                                class="mb-2 search-menu"
                              />
                              <div class="filter-checkbox-group">
                                <v-checkbox
                                  v-for="option in filteredMetalSummaryMaterialCodesOptions"
                                  :key="String(option)"
                                  :label="String(option)"
                                  :model-value="metalSummarySearchForm.materialCode.includes(String(option))"
                                  @update:model-value="(checked) => handleMetalSummaryCheckboxChange('materialCode', String(option), checked)"
                                  color="#D2475D"
                                  density="compact"
                                  hide-details
                                />
                              </div>
                            </v-card-text>
                            <v-divider />
                            <v-card-actions class="pa-2 justify-end">
                              <v-btn size="small" variant="text" color="#D2475D" @click="metalSummarySearchForm.materialCode = []; handleMetalSummarySearch()">清空</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-menu>

                        <!-- 大类筛选（定制&五金汇总） -->
                        <v-menu v-if="header.key === 'bigClass'" location="bottom" :close-on-content-click="false">
                          <template v-slot:activator="{ props }">
                            <v-btn
                              icon="mdi-filter"
                              variant="text"
                              density="compact"
                              size="small"
                              v-bind="props"
                              :color="metalSummarySearchForm.bigClass.length > 0 ? '#D2475D' : undefined"
                              :class="metalSummarySearchForm.bigClass.length > 0 ? 'filter-btn-active' : ''"
                            />
                          </template>
                          <v-card class="filter-menu">
                            <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                              <div class="filter-checkbox-group">
                                <v-checkbox
                                  v-for="option in metalSummaryBigClassesOptions"
                                  :key="option"
                                  :label="option"
                                  :model-value="metalSummarySearchForm.bigClass.includes(option)"
                                  @update:model-value="(checked) => handleMetalSummaryCheckboxChange('bigClass', option, checked)"
                                  color="#D2475D"
                                  density="compact"
                                  hide-details
                                />
                              </div>
                            </v-card-text>
                            <v-divider />
                          </v-card>
                        </v-menu>

                        <!-- 小类筛选（定制&五金汇总） -->
                        <v-menu v-if="header.key === 'smallClass'" location="bottom" :close-on-content-click="false">
                          <template v-slot:activator="{ props }">
                            <v-btn
                              icon="mdi-filter"
                              variant="text"
                              density="compact"
                              size="small"
                              v-bind="props"
                              :color="metalSummarySearchForm.smallClass.length > 0 ? '#D2475D' : undefined"
                              :class="metalSummarySearchForm.smallClass.length > 0 ? 'filter-btn-active' : ''"
                            />
                          </template>
                          <v-card class="filter-menu">
                            <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                              <div class="filter-checkbox-group">
                                <v-checkbox
                                  v-for="option in metalSummarySmallClassesOptions"
                                  :key="option"
                                  :label="option"
                                  :model-value="metalSummarySearchForm.smallClass.includes(option)"
                                  @update:model-value="(checked) => handleMetalSummaryCheckboxChange('smallClass', option, checked)"
                                  color="#D2475D"
                                  density="compact"
                                  hide-details
                                />
                              </div>
                            </v-card-text>
                            <v-divider />
                          </v-card>
                        </v-menu>
                      </th>
                    </tr>
                  </thead>
                  <tbody class="material-summary-table-body">
                    <tr v-if="loadingMetalSummary" class="text-center">
                      <td :colspan="projectFiveMetalSummaryHeaders.length" class="py-8">
                        <v-progress-circular indeterminate color="primary" size="40" width="3"></v-progress-circular>
                        <div class="mt-2 text-grey">加载中...</div>
                      </td>
                    </tr>
                    <tr v-else-if="mergeProductionMetalSummaryItems.length === 0" class="text-center">
                      <td :colspan="projectFiveMetalSummaryHeaders.length" class="py-8">料单暂无数据</td>
                    </tr>
                    <template v-else>
                      <tr
                        v-for="(item, index) in mergeProductionMetalSummaryItems"
                        :key="index"
                      >
                        <td></td>
                        <td class="text-center">
                          {{ item.partName || '/' }}
                        </td>
                        <td class="text-center" style="color:#D2475D;font-weight: 600;">
                          {{ item.materialName || '/' }}
                        </td>
                        <td class="text-center">
                          {{ item.materialSpec || '/' }}
                        </td>
                        <td class="text-center">
                          {{ item.materialCode || '/' }}
                        </td>
                        <!-- <td class="text-center">
                          {{ item.purchaseList?.length || '/' }}
                        </td> -->
                        <td class="text-left" style="padding-left: 16px!important;text-align: left!important;">
                          <template v-if="item.width || item.depth || item.height">
                            <template v-if="item.width">
                              W:{{ item.width || '/' }} <br>
                            </template>
                            <template v-if="item.depth">
                              D:{{ item.depth || '/' }} <br>
                            </template>
                            <template v-if="item.height">
                              H:{{ item.height || '/' }}
                            </template>
                          </template>
                          <template v-else>
                            /
                          </template>
                        </td>
                        <td class="text-center">
                          {{ item.remark || '/' }}
                        </td>
                        <td class="text-center">
                          {{ item.bigClass || '/' }}
                        </td>
                        <td class="text-center">
                          {{ item.smallClass || '/' }}
                        </td>
                        <td class="text-center">
                          <template v-if="item.factoryUsageMap">
                            <template v-for="(usage, factoryName) in item.factoryUsageMap" :key="factoryName">
                              <div>
                                {{ factoryName }}：{{ usage }} {{ item.materialUsageUnit }}
                              </div>
                            </template>
                          </template>
                          <template v-else>
                            /
                          </template>
                        </td>
                        <!-- <td class="text-center">
                          <template v-if="item.totalUsage">
                            {{ item.totalUsage}}
                            <template v-if="item.materialUsageUnit">
                              {{ item.materialUsageUnit }}
                            </template>
                          </template>
                          <template v-else>
                            /
                          </template>
                        </td> -->
                        <td class="text-center">
                          <template v-if="item.productUsageSum">
                            {{ formatNumberUse(item.productUsageSum, 4) }}
                            <template v-if="item.materialUsageUnit">
                              {{ item.materialUsageUnit }}
                            </template>
                          </template>
                          <template v-else>
                            /
                          </template>
                        </td>
                        <td class="text-center">
                          <v-btn style="margin: 0!important;" v-if="item.purchaseList?.length > 0" class="list-edit-btn" @click="handleSeeMaterialPurchaseList(item,'hardware')">查看</v-btn>
                          <v-img class="statusImg" v-if="item.purchaseItemList?.length > 0 && !item.purchaseList?.length" :src="yijiagouImg"/>
                        </td>
                        <!-- v-if="showFactoryChoosePurchaseHardware && item.materialName" -->
                        <td class="text-center">
                          <!-- <template v-if="item.purchaseList?.length > 0 || item.purchaseItemList?.length > 0"></template>
                          <template v-else> -->
                            <v-checkbox
                              class="material-checkbox"
                              v-if="showFactoryChoosePurchaseHardware"
                              :model-value="selectedHardwareMaterials.includes(buildHardwareSummaryKey(item))"
                              @change="handleChooseHardwareSummaryMaterial(item, index)"
                              hide-details
                              density="compact"
                            ></v-checkbox>
                          <!-- </template> -->
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </v-table>
                <!-- 定制&五金汇总分页 -->
                <div class="custom-pagination d-flex align-center justify-space-between">
                  <div class="pagination-info">共 {{ metalSummaryPagination.total }} 条记录</div>
                  
                  <div class="d-flex align-center">
                    <div class="pagination-controls">
                      <v-btn
                        icon="mdi-chevron-double-left"
                        variant="text"
                        density="comfortable"
                        :disabled="metalSummaryPagination.page === 1"
                        @click="handleMetalSummaryPageChange(1)"
                        class="pagination-btn"
                      />
                      <v-btn
                        icon="mdi-chevron-left"
                        variant="text"
                        density="comfortable"
                        :disabled="metalSummaryPagination.page === 1"
                        @click="handleMetalSummaryPageChange(metalSummaryPagination.page - 1)"
                        class="pagination-btn"
                      />
                      <span class="pagination-text mx-2">{{ metalSummaryPagination.page }} / {{ metalSummaryTotalPages }}</span>
                      <v-btn
                        icon="mdi-chevron-right"
                        variant="text"
                        density="comfortable"
                        :disabled="metalSummaryPagination.page === metalSummaryTotalPages"
                        @click="handleMetalSummaryPageChange(metalSummaryPagination.page + 1)"
                        class="pagination-btn"
                      />
                      <v-btn
                        icon="mdi-chevron-double-right"
                        variant="text"
                        density="comfortable"
                        :disabled="metalSummaryPagination.page === metalSummaryTotalPages"
                        @click="handleMetalSummaryPageChange(metalSummaryTotalPages)"
                        class="pagination-btn"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <!-- 采购单 -->
              <div v-if="titleList[4].isChoosed" class="product-table-container">
                <v-table class="product-table material-table material-summary-table" hover fixed-header :style="{ maxHeight: `calc(100vh - 350px)` }">
                  <thead>
                    <tr>
                      <th v-for="header in purchaseSummaryHeaders" :key="header.key" :class="['text-' + header.align]" :style="{ width: `${header.width}` }">
                        {{ header.title }}
                      </th>
                    </tr>
                  </thead>
                    <tbody class="material-summary-table-body">
                      <template v-if="purchaseSummaryList.length > 0">
                        <tr v-for="item in purchaseSummaryList" :key="item.id">
                          <!-- 采购单号 -->
                          <td class="text-left">
                            <div class="text-left">{{ item.purchaseOrderNo || '-' }}</div>
                            <div class="text-left" style="color: #898989">{{ formatYMDate(item.createTime) }}</div>
                          </td>
                          <td class="text-left" data-key="projectName">
                            <div>{{ item.project || '/' }}</div>
                            <div style="color: #898989" v-if="item?.contract.code || item?.so">{{ item?.contract.code || item?.so || '/' }}</div>
                          </td>
                          <!-- 供应商 -->
                          <td class="text-left">
                            <div class="text-left">{{ item.supplierName || '/' }}</div>
                            <div class="text-left" style="color: #898989">{{ item.supplierNo || '/' }}</div>
                          </td>
                          <!-- 付款公司 -->
                          <td class="text-left">{{ item.paymentCompany || '/' }}</td>
                          <!-- 税率 -->
                          <!-- <td class="text-center">{{ item.taxRate ? `${item.taxRate}%` : '0%' }}</td> -->
                          <!-- 税额 -->
                          <!-- <td class="text-center">{{ formatNumber(Number(item.taxAmount || 0)) }}</td> -->
                          <!-- 合计金额 -->
                          <!-- <td class="text-center">{{ formatNumber(Number(item.totalAmount || item.totalPrice || 0)) }}</td> -->
                          <!-- 含税总金额 -->
                          <td class="text-center">{{ formatNumber(Number(item.totalAmountWithTax || 0)) }}</td>
                          <!-- 付款类型 -->
                          <td class="text-center">
                            <div class="payment-type" style="margin-right:0!important;">{{ getPaymentMethod(item.paymentType).label }}</div>
                          </td>
                          <!-- 采购标准 -->
                          <!-- <td class="text-center">{{ item.purchaseStandard || '/' }}</td> -->
                          <!-- 送货地址 -->
                          <td class="text-center">{{ item.warehouseName || '/' }}</td>
                          <!-- 下单人 -->
                          <td class="text-center">{{ item.createUserName || item?.user?.nickname || '/' }}</td>
                          <!-- 已付 -->
                          <td class="text-center">{{ formatNumber(Number(item.paidAmount || 0)) }}</td>
                          <!-- 操作 -->
                          <td class="text-center">
                            <div class="flex-between">
                               <!-- <v-btn style="display: inline-block;width: 80px!important;margin-right: 10px;" class="list-edit-btn"  @click="handleExportMaterialPdf(item)">导出pdf</v-btn> -->
                               <v-btn style="display: inline-block;width: 80px!important;margin-right: 10px;" class="list-edit-btn"  @click="handleBrowserPrintPurchase(item)">打印pdf</v-btn>
                              <!-- <v-btn style="display: inline-block;width: 80px!important;margin-right: 10px;" class="list-edit-btn"  @click="handleExportPdf(item)">导出pdf</v-btn> -->
                              <v-btn style="display: inline-block;" class="list-edit-btn"  @click="handleSeePurchase(item)">查看</v-btn>
                              <!-- <v-menu location="bottom">
                                <template #activator="{ props: menuProps }">
                                  <v-btn
                                    v-bind="menuProps"
                                    style="display: inline-block;width: 92px!important;margin-right: 10px;"
                                    class="list-edit-btn"
                                  >
                                    导出/打印
                                  </v-btn>
                                </template>
                                <v-list density="compact" class="purchase-export-menu">
                                  <v-list-item title="下载 PDF" @click="handleExportMaterialPdf(item)" />
                                  <v-list-item title="浏览器打印（针式多联）" @click="handleBrowserPrintPurchase(item)" />
                                </v-list>
                              </v-menu> -->
                            </div>
                          </td>
                        </tr>
                      </template>
                      <template v-else>
                        <tr v-if="loadingPurchaseSummary" class="text-center">
                          <td :colspan="purchaseSummaryHeaders.length" class="py-8">
                            <v-progress-circular indeterminate color="primary" size="40" width="3"></v-progress-circular>
                            <div class="mt-2 text-grey">加载中...</div>
                          </td>
                        </tr>
                      </template>
                      <tr v-if="purchaseSummaryList.length === 0 && !loadingPurchaseSummary">
                        <td colspan="100%" class="text-center">
                          暂无采购单数据
                        </td>
                      </tr>
                  </tbody>
                </v-table>
              </div> 
              
              <!-- 常规材料 老的 -->
              <div  style="display: none;" class="product-table-container">
                <v-table class="product-table material-table material-summary-table" hover fixed-header :style="{ maxHeight: `calc(100vh - 350px)` }">
                  <thead>
                    <tr>
                      <th v-for="header in materialSummarizeHeaders" :key="header.key" :class="['text-' + header.align]" :style="{ minWidth: `${Number(header.minWidth) + 1}px` }">
                        <template v-if="header.key === 'actions' && showFactoryChoosePurchase">
                          <v-checkbox
                            class="material-checkbox"
                            v-model="isFactorySelectAll"
                            @change="handleFactorySelectAll"
                            hide-details
                            density="compact"
                            label="全选"
                          ></v-checkbox>
                        </template>
                        <template v-else>
                          {{ header.title }}
                        </template>
                        <!-- 筛选按钮 -->
                        <v-menu v-if="header.filterable" location="bottom" @click.stop>
                          <template v-slot:activator="{ props }">
                            <v-btn
                              icon="mdi-filter"
                              size="small"
                              variant="text"
                              density="compact"
                              v-bind="props"
                              :color="(header.key === 'kind' ? kindFilter : header.key === 'bigClass' ? bigClassFilter : typeFilter) ? '#D2475D' : undefined"
                              :class="(header.key === 'kind' ? kindFilter : header.key === 'bigClass' ? bigClassFilter : typeFilter) ? 'filter-btn-active' : ''"
                              class="ml-2 filter-btn"
                              @click.stop
                            />
                          </template>
                          <v-card class="filter-menu">
                            <v-card-text class="pa-2">
                              <template v-if="header.key === 'kind'">
                                <v-radio-group
                                  v-model="kindFilter"
                                  density="compact"
                                  class="filter-radio-group"
                                  hide-details
                                  @update:model-value="loadMaterialSummary"
                                >
                                  <v-radio
                                    label="全部"
                                    :value="null"
                                    color="#D2475D"
                                    density="compact"
                                  />
                                  <v-radio
                                    v-for="option in kindOptions"
                                    :key="option"
                                    :label="option"
                                    :value="option"
                                    color="#D2475D"
                                    density="compact"
                                  />
                                </v-radio-group>
                              </template>
                              <template v-if="header.key === 'bigClass'">
                                <v-radio-group
                                  v-model="bigClassFilter"
                                  density="compact"
                                  class="filter-radio-group"
                                  hide-details
                                  @update:model-value="loadMaterialSummary"
                                >
                                  <v-radio
                                    label="全部"
                                    :value="null"
                                    color="#D2475D"
                                    density="compact"
                                  />
                                  <v-radio
                                    v-for="option in bigClassSummaryOptions"
                                    :key="option"
                                    :label="option"
                                    :value="option"
                                    color="#D2475D"
                                    density="compact"
                                  />
                                </v-radio-group>
                              </template>
                              <template v-if="header.key === 'type'">
                                <v-radio-group
                                  v-model="typeFilter"
                                  density="compact"
                                  class="filter-radio-group"
                                  hide-details
                                  @update:model-value="loadMaterialSummary"
                                >
                                  <v-radio
                                    label="全部"
                                    :value="null"
                                    color="#D2475D"
                                    density="compact"
                                  />
                                  <v-radio
                                    v-for="option in smallClassSummaryOptions"
                                    :key="option"
                                    :label="option"
                                    :value="option"
                                    color="#D2475D"
                                    density="compact"
                                  />
                                </v-radio-group>
                              </template>
                            </v-card-text>
                            <v-divider />
                          </v-card>
                        </v-menu>
                      </th>
                    </tr>
                  </thead>
                  <tbody class="material-summary-table-body">
                    <template v-if="materialSummaryList.length > 0">
                      <tr v-for="(item, index) in materialSummaryList" :key="index">
                        <td></td>
                        <td style="text-align: left!important;">
                          <template v-if="item.materialName || item.materialSpec || item.materialCode">
                            <template v-if="item.materialName">
                              <p>{{ item.materialName }}</p>
                            </template>
                            <template v-if="item.specDesc">
                              <p>{{ item.specDesc }}</p>
                            </template>
                            <template v-if="item.materialCode">
                              <p class="material-code">{{ item.materialCode }}</p>
                            </template>
                          </template>
                          <template v-else>
                            /
                          </template>
                        </td>
                        <td>{{ item.bigClass || '/' }}</td>
                        <td>{{ item.smallClass || '/' }}</td>
                        <td>{{ item.totalUsageWithProductCount || '/' }}
                          <template v-if="Number(item.totalUsageWithProductCount) > 0">
                            {{ item.totalUsageUnit }}
                          </template>
                        </td>
                        <td>{{ item.currentInventory || '/' }}</td>
                        <td>{{ item.purchasedQuantity || '/' }}</td>
                        <td>
                          <v-checkbox
                            class="material-checkbox"
                            v-if="showFactoryChoosePurchase"
                            :model-value="selectedFactoryMaterials.includes(item.id)"
                            @change="handleSelectFactoryMaterial(item)"
                            hide-details
                            density="compact"
                          ></v-checkbox>
                          <v-btn v-else style="display: block;margin: 0 auto!important;" class="list-edit-btn" @click="handleSeeBomMaterial(item, index)">查看</v-btn>
                        </td>
                      </tr>
                    </template>
                    <tr v-if="materialSummaryList.length === 0">
                      <td colspan="100%" class="text-center">
                        暂无常规材料数据
                      </td>
                    </tr>
                  </tbody>
                </v-table>
              </div>

              <!-- 常规材料 -->
              <div style="display: none;" class="product-table-container">
                <v-table class="product-table material-table material-summary-table" hover fixed-header :style="{ maxHeight: `calc(100vh - 350px)` }">
                  <thead>
                    <tr>
                      <th v-for="header in projectMaterialHeaders" :key="header.key" :class="['text-' + header.align]" :style="{ width: `${Number(header.minWidth) + 1}px` }">
                        <!-- <template v-if="header.key === 'actions' && showFactoryChoosePurchase">
                          <v-checkbox
                            class="material-checkbox"
                            v-model="isFactorySelectAll"
                            @change="handleFactorySelectAll"
                            hide-details
                            density="compact"
                            label="全选"
                          ></v-checkbox>
                        </template> -->
                        <!-- <template> -->
                          <div class="align-center">
                            <template v-if="header.key === 'partName' || header.key === 'materialName'">
                              <span style="color:#D2475D;font-weight: 800;">{{ header.title }}</span>
                            </template>
                            <template v-else>
                              {{ header.title }}
                            </template>
                            <!-- 产品筛选 -->
                            <v-menu v-if="header.key === 'productName'" location="bottom" :close-on-content-click="false">
                              <template v-slot:activator="{ props }">
                                <v-btn
                                  icon="mdi-filter"
                                  variant="text"
                                  density="compact"
                                  size="small"
                                  v-bind="props"
                                  :color="materialSearchForm.productName.length > 0 ? '#D2475D' : undefined"
                                  :class="materialSearchForm.productName.length > 0 ? 'filter-btn-active' : ''"
                                />
                              </template>
                              <v-card class="filter-menu">
                                <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                  <div class="filter-checkbox-group">
                                    <v-checkbox
                                      v-for="option in materialproductNamesOptions"
                                      :key="option"
                                      :label="option"
                                      :model-value="materialSearchForm.productName.includes(option)"
                                      @update:model-value="(checked) => handleCheckboxChange('productName', option, checked)"
                                      color="#D2475D"
                                      density="compact"
                                      hide-details
                                    />
                                  </div>
                                </v-card-text>
                                <v-divider />
                              </v-card>
                            </v-menu>
                            <!-- 已选中的标签显示 -->
                            <!-- <div v-if="materialSearchForm.productName.length > 0" class="selected-tags">
                              <v-chip
                                v-for="tag in materialSearchForm.productName"
                                :key="tag"
                                size="x-small"
                                closable
                                color="#D2475D"
                                variant="outlined"
                                @click:close="removeFilterTag('productName', tag)"
                              >
                                {{ tag }}
                              </v-chip>
                            </div> -->
                            <!-- 成品组件筛选 -->
                            <v-menu v-if="header.key === 'finishedComponentName'" location="bottom" :close-on-content-click="false">
                              <template v-slot:activator="{ props }">
                                <v-btn
                                  icon="mdi-filter"
                                  variant="text"
                                  density="compact"
                                  size="small"
                                  v-bind="props"
                                  :color="materialSearchForm.finishedComponentName.length > 0 ? '#D2475D' : undefined"
                                  :class="materialSearchForm.finishedComponentName.length > 0 ? 'filter-btn-active' : ''"
                                />
                              </template>
                              <v-card class="filter-menu">
                                <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                  <div class="filter-checkbox-group">
                                    <v-checkbox
                                      v-for="option in materialfinishedComponentNamesOptions"
                                      :key="option"
                                      :label="option"
                                      :model-value="materialSearchForm.finishedComponentName.includes(option)"
                                      @update:model-value="(checked) => handleCheckboxChange('finishedComponentName', option, checked)"
                                      color="#D2475D"
                                      density="compact"
                                      hide-details
                                    />
                                  </div>
                                </v-card-text>
                                <v-divider />
                              </v-card>
                            </v-menu>
                            <!-- 组件筛选 -->
                            <v-menu v-if="header.key === 'componentName'" location="bottom" :close-on-content-click="false">
                              <template v-slot:activator="{ props }">
                                <v-btn
                                  icon="mdi-filter"
                                  variant="text"
                                  density="compact"
                                  size="small"
                                  v-bind="props"
                                  :color="materialSearchForm.componentName.length > 0 ? '#D2475D' : undefined"
                                  :class="materialSearchForm.componentName.length > 0 ? 'filter-btn-active' : ''"
                                />
                              </template>
                              <v-card class="filter-menu">
                                <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                  <div class="filter-checkbox-group">
                                    <v-checkbox
                                      v-for="option in materialcomponentNamesOptions"
                                      :key="option"
                                      :label="option"
                                      :model-value="materialSearchForm.componentName.includes(option)"
                                      @update:model-value="(checked) => handleCheckboxChange('componentName', option, checked)"
                                      color="#D2475D"
                                      density="compact"
                                      hide-details
                                    />
                                  </div>
                                </v-card-text>
                                <v-divider />
                              </v-card>
                            </v-menu>
                            <!-- 已选中的标签显示 -->
                            <!-- <div v-if="materialSearchForm.componentName.length > 0" class="selected-tags">
                              <v-chip
                                v-for="tag in materialSearchForm.componentName"
                                :key="tag"
                                size="x-small"
                                closable
                                color="#D2475D"
                                variant="outlined"
                                @click:close="removeFilterTag('componentName', tag)"
                              >
                                {{ tag }}
                              </v-chip>
                            </div> -->
                            <!-- 零件筛选 -->
                            <v-menu v-if="header.key === 'partName'" location="bottom" :close-on-content-click="false">
                              <template v-slot:activator="{ props }">
                                <v-btn
                                  icon="mdi-filter"
                                  variant="text"
                                  density="compact"
                                  size="small"
                                  v-bind="props"
                                  :color="materialSearchForm.partName.length > 0 ? '#D2475D' : undefined"
                                  :class="materialSearchForm.partName.length > 0 ? 'filter-btn-active' : ''"
                                />
                              </template>
                              <v-card class="filter-menu">
                                <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                  <div class="filter-checkbox-group">
                                    <v-checkbox
                                      v-for="option in materialpartNamesOptions"
                                      :key="option"
                                      :label="option"
                                      :model-value="materialSearchForm.partName.includes(option)"
                                      @update:model-value="(checked) => handleCheckboxChange('partName', option, checked)"
                                      color="#D2475D"
                                      density="compact"
                                      hide-details
                                    />
                                  </div>
                                </v-card-text>
                                <v-divider />
                              </v-card>
                            </v-menu>
                            <!-- 已选中的标签显示 -->
                            <!-- <div v-if="materialSearchForm.partName.length > 0" class="selected-tags">
                              <v-chip
                                v-for="tag in materialSearchForm.partName"
                                :key="tag"
                                size="x-small"
                                closable
                                color="#D2475D"
                                variant="outlined"
                                @click:close="removeFilterTag('partName', tag)"
                              >
                                {{ tag }}
                              </v-chip>
                            </div> -->
                            <!-- 物料名称筛选 -->
                            <v-menu v-if="header.key === 'materialName'" location="bottom" :close-on-content-click="false">
                              <template v-slot:activator="{ props }">
                                <v-btn
                                  icon="mdi-filter"
                                  variant="text"
                                  density="compact"
                                  size="small"
                                  v-bind="props"
                                  :color="materialSearchForm.materialName.length > 0 ? '#D2475D' : undefined"
                                  :class="materialSearchForm.materialName.length > 0 ? 'filter-btn-active' : ''"
                                />
                              </template>
                              <v-card class="filter-menu">
                                <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                  <div class="filter-checkbox-group">
                                    <v-checkbox
                                      v-for="option in materialmaterialNamesOptions"
                                      :key="option"
                                      :label="option"
                                      :model-value="materialSearchForm.materialName.includes(option)"
                                      @update:model-value="(checked) => handleCheckboxChange('materialName', option, checked)"
                                      color="#D2475D"
                                      density="compact"
                                      hide-details
                                    />
                                  </div>
                                </v-card-text>
                                <v-divider />
                              </v-card>
                            </v-menu>
                            <!-- 已选中的标签显示 -->
                            <!-- <div v-if="materialSearchForm.materialName.length > 0" class="selected-tags">
                              <v-chip
                                v-for="tag in materialSearchForm.materialName"
                                :key="tag"
                                size="x-small"
                                closable
                                color="#D2475D"
                                variant="outlined"
                                @click:close="removeFilterTag('materialName', tag)"
                              >
                                {{ tag }}
                              </v-chip>
                            </div> -->
                            <!-- 物料规格筛选 -->
                            <v-menu v-if="header.key === 'materialSpec'" location="bottom" :close-on-content-click="false">
                              <template v-slot:activator="{ props }">
                                <v-btn
                                  icon="mdi-filter"
                                  variant="text"
                                  density="compact"
                                  size="small"
                                  v-bind="props"
                                  :color="materialSearchForm.materialSpec.length > 0 ? '#D2475D' : undefined"
                                  :class="materialSearchForm.materialSpec.length > 0 ? 'filter-btn-active' : ''"
                                />
                              </template>
                              <v-card class="filter-menu">
                                <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                  <v-text-field
                                    v-model="materialSpecFilterKeyword"
                                    placeholder="搜索规格"
                                    density="compact"
                                    variant="outlined"
                                    clearable
                                    hide-details
                                    class="mb-2 search-menu"
                                  />
                                  <div class="filter-checkbox-group">
                                    <v-checkbox
                                      v-for="option in filteredMaterialSpecsOptions"
                                      :key="option"
                                      :label="option"
                                      :model-value="materialSearchForm.materialSpec.includes(option)"
                                      @update:model-value="(checked) => handleCheckboxChange('materialSpec', option, checked)"
                                      color="#D2475D"
                                      density="compact"
                                      hide-details
                                    />
                                  </div>
                                </v-card-text>
                                <v-divider />
                              </v-card>
                            </v-menu>
                            <!-- 已选中的标签显示 -->
                            <!-- <div v-if="materialSearchForm.materialSpec.length > 0" class="selected-tags">
                              <v-chip
                                v-for="tag in materialSearchForm.materialSpec"
                                :key="tag"
                                size="x-small"
                                closable
                                color="#D2475D"
                                variant="outlined"
                                @click:close="removeFilterTag('materialSpec', tag)"
                              >
                                {{ tag }}
                              </v-chip>
                            </div> -->
                            <!-- 物料编号筛选 -->
                            <v-menu v-if="header.key === 'materialCode'" location="bottom" :close-on-content-click="false">
                              <template v-slot:activator="{ props }">
                                <v-btn
                                  icon="mdi-filter"
                                  variant="text"
                                  density="compact"
                                  size="small"
                                  v-bind="props"
                                  :color="materialSearchForm.materialCode.length > 0 ? '#D2475D' : undefined"
                                  :class="materialSearchForm.materialCode.length > 0 ? 'filter-btn-active' : ''"
                                />
                              </template>
                              <v-card class="filter-menu">
                                <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                  <v-text-field
                                    v-model="materialCodeFilterKeyword"
                                    placeholder="搜索编号"
                                    density="compact"
                                    variant="outlined"
                                    clearable
                                    hide-details
                                    class="mb-2 search-menu"
                                  />
                                  <div class="filter-checkbox-group">
                                    <v-checkbox
                                      v-for="option in filteredMaterialCodesOptions"
                                      :key="String(option)"
                                      :label="String(option)"
                                      :model-value="materialSearchForm.materialCode.includes(String(option))"
                                      @update:model-value="(checked) => handleCheckboxChange('materialCode', String(option), checked)"
                                      color="#D2475D"
                                      density="compact"
                                      hide-details
                                    />
                                  </div>
                                </v-card-text>
                                <v-divider />
                                <v-card-actions class="pa-2 justify-end">
                                  <v-btn size="small" variant="text" color="#D2475D" @click="materialSearchForm.materialCode = []; handleMaterialSearch()">清空</v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-menu>
                            <!-- 大类筛选 -->
                            <v-menu v-if="header.key === 'bigClass'" location="bottom" :close-on-content-click="false">
                              <template v-slot:activator="{ props }">
                                <v-btn
                                  icon="mdi-filter"
                                  variant="text"
                                  density="compact"
                                  size="small"
                                  v-bind="props"
                                  :color="materialSearchForm.bigClass.length > 0 ? '#D2475D' : undefined"
                                  :class="materialSearchForm.bigClass.length > 0 ? 'filter-btn-active' : ''"
                                />
                              </template>
                              <v-card class="filter-menu">
                                <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                  <div class="filter-checkbox-group">
                                    <v-checkbox
                                      v-for="option in materialbigClassesOptions"
                                      :key="option"
                                      :label="option"
                                      :model-value="materialSearchForm.bigClass.includes(option)"
                                      @update:model-value="(checked) => handleCheckboxChange('bigClass', option, checked)"
                                      color="#D2475D"
                                      density="compact"
                                      hide-details
                                    />
                                  </div>
                                </v-card-text>
                                <v-divider />
                              </v-card>
                            </v-menu>
                            <!-- 已选中的标签显示 -->
                            <!-- <div v-if="materialSearchForm.bigClass.length > 0" class="selected-tags">
                              <v-chip
                                v-for="tag in materialSearchForm.bigClass"
                                :key="tag"
                                size="x-small"
                                closable
                                color="#D2475D"
                                variant="outlined"
                                @click:close="removeFilterTag('bigClass', tag)"
                              >
                                {{ tag }}
                              </v-chip>
                            </div> -->
                            <!-- 小类筛选 -->
                            <v-menu v-if="header.key === 'smallClass'" location="bottom" :close-on-content-click="false">
                              <template v-slot:activator="{ props }">
                                <v-btn
                                  icon="mdi-filter"
                                  variant="text"
                                  density="compact"
                                  size="small"
                                  v-bind="props"
                                  :color="materialSearchForm.smallClass.length > 0 ? '#D2475D' : undefined"
                                  :class="materialSearchForm.smallClass.length > 0 ? 'filter-btn-active' : ''"
                                />
                              </template>
                              <v-card class="filter-menu">
                                <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                  <div class="filter-checkbox-group">
                                    <v-checkbox
                                      v-for="option in materialsmallClassesOptions"
                                      :key="option"
                                      :label="option"
                                      :model-value="materialSearchForm.smallClass.includes(option)"
                                      @update:model-value="(checked) => handleCheckboxChange('smallClass', option, checked)"
                                      color="#D2475D"
                                      density="compact"
                                      hide-details
                                    />
                                  </div>
                                </v-card-text>
                                <v-divider />
                              </v-card>
                            </v-menu>
                            <!-- 已选中的标签显示 -->
                            <!-- <div v-if="materialSearchForm.smallClass.length > 0" class="selected-tags">
                              <v-chip
                                v-for="tag in materialSearchForm.smallClass"
                                :key="tag"
                                size="x-small"
                                closable
                                color="#D2475D"
                                variant="outlined"
                                @click:close="removeFilterTag('smallClass', tag)"
                              >
                                {{ tag }}
                              </v-chip>
                            </div> -->
                          </div>
                        <!-- </template> -->
                      </th>
                    </tr>
                  </thead>
                  <tbody class="material-summary-table-body">
                    <tr v-if="loadingMaterialSummary" class="text-center">
                      <td :colspan="projectMaterialHeaders.length" class="py-8">
                        <v-progress-circular indeterminate color="primary" size="40" width="3"></v-progress-circular>
                        <div class="mt-2 text-grey">加载中...</div>
                      </td>
                    </tr>
                    <tr v-else-if="mergeProductionBomItems.length === 0" class="text-center">
                      <td :colspan="projectMaterialHeaders.length" class="py-8">料单暂无数据</td>
                    </tr>
                    <template v-else>
                      <tr
                        v-for="(item, index) in mergeProductionBomItems" :key="index"
                      >
                        <td></td>
                        <td class="text-left" style="text-align: left!important;">
                          {{ item.product?.name }} <br>
                          <span style="color:#898989;word-wrap: unset !important;word-break: keep-all !important;">{{ item.product?.code }}</span> <br>
                          <span style="color:#898989;word-wrap: unset !important;word-break: keep-all !important;">{{ item.product?.syscode }}</span>
                        </td>
                        <td class="text-center">
                          {{ item.sequenceNo }}
                        </td>
                        <td class="text-center">
                          {{ item.finishedComponentName || '/' }}
                        </td>
                        <td class="text-center">
                          {{ item.componentName || '/' }}
                        </td>
                        <td class="text-center">
                          {{ item.partName || '/' }}
                        </td>
                        <td class="text-center">
                          {{ item.materialName || '/' }}
                        </td>
                        <td class="text-center">
                          {{ item.materialSpec || '/' }}
                        </td>
                        <td class="text-center">
                          {{ item.materialCode || '/' }}
                        </td>
                        <td class="text-left" style="padding-left: 16px!important;text-align: left!important;">
                          <template v-if="item.width || item.depth || item.height">
                            <template v-if="item.width">
                              W:{{ item.width || '/' }} <br>
                            </template>
                            <template v-if="item.depth">
                              D:{{ item.depth || '/' }} <br>
                            </template>
                            <template v-if="item.height">
                              H:{{ item.height || '/' }}
                            </template>
                          </template>
                          <template v-else>
                            /
                          </template>
                        </td>
                        <td class="text-center">
                          {{ item.quantity || '/' }}
                        </td>
                        <td class="text-center">
                          {{ item.remark || '/' }}
                        </td>
                        <td class="text-center">
                          {{ item.bigClass || '/' }}
                        </td>
                        <td class="text-center">
                          {{ item.smallClass || '/' }}
                        </td>
                        <td class="text-center">
                          {{ item.materialUsage || '/' }} 
                          <template v-if="item.materialUsage">
                            {{ item.materialUsageUnit }}
                          </template>
                        </td>
                        <td class="text-center">
                          <!-- <template v-if="contractInfo.productCount">
                            {{ contractInfo.productCount * (item.materialUsage || 0) }} 
                            <template v-if="item.materialUsageUnit">
                              {{ item.materialUsageUnit }}
                            </template>
                          </template>
                          <template v-else>
                            /
                          </template> -->
                          <template v-if="item.product?.count">
                            {{ formatNumberUse(item.product?.count * (item.materialUsage || 0)) }} 
                            <template v-if="item.materialUsageUnit">
                              {{ item.materialUsageUnit }}
                            </template>
                          </template>
                          <template v-else>
                            /
                          </template>
                        </td>
                        <td>
                          <v-checkbox
                            class="material-checkbox"
                            v-if="showFactoryChoosePurchase && (item.partName || item.materialName)"
                            :model-value="selectedFactoryMaterials.includes(index)"
                            @change="handleChooseFactoryMaterial(item, index)"
                            hide-details
                            density="compact"
                          ></v-checkbox>
                          <!-- <v-btn v-else style="display: block;margin: 0 auto!important;" class="list-edit-btn" @click="handleSeeBomMaterial(item, index)">查看</v-btn> -->
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </v-table>
                <!-- 常规材料分页 -->
                <div class="custom-pagination d-flex align-center justify-space-between">
                  <div class="pagination-info">共 {{ materialPagination.total }} 条记录</div>
                  
                  <div class="d-flex align-center">
                    <div class="pagination-controls">
                      <v-btn
                        icon="mdi-chevron-double-left"
                        variant="text"
                        density="comfortable"
                        :disabled="materialPagination.page === 1"
                        @click="handleMaterialPageChange(1)"
                        class="pagination-btn"
                      />
                      <v-btn
                        icon="mdi-chevron-left"
                        variant="text"
                        density="comfortable"
                        :disabled="materialPagination.page === 1"
                        @click="handleMaterialPageChange(materialPagination.page - 1)"
                        class="pagination-btn"
                      />
                      <span class="pagination-text mx-2">{{ materialPagination.page }} / {{ materialTotalPages }}</span>
                      <v-btn
                        icon="mdi-chevron-right"
                        variant="text"
                        density="comfortable"
                        :disabled="materialPagination.page === materialTotalPages"
                        @click="handleMaterialPageChange(materialPagination.page + 1)"
                        class="pagination-btn"
                      />
                      <v-btn
                        icon="mdi-chevron-double-right"
                        variant="text"
                        density="comfortable"
                        :disabled="materialPagination.page === materialTotalPages"
                        @click="handleMaterialPageChange(materialTotalPages)"
                        class="pagination-btn"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <!-- 定制&五金 老的 -->
              <div style="display: none;" class="product-table-container">
                <v-table class="product-table material-table material-summary-table" hover fixed-header :style="{ maxHeight: `calc(100vh - 350px)` }">
                  <thead>
                    <tr>
                      <th v-for="header in materialSummarizeHeaders" :key="header.key" :class="['text-' + header.align]" :style="{ minWidth: `${Number(header.minWidth) + 1}px` }">
                        <template v-if="header.key === 'actions' && showFactoryChoosePurchaseHardware">
                          <v-checkbox
                            class="material-checkbox"
                            v-model="isHardwareSelectAll"
                            @change="handleHardwareSelectAll"
                            hide-details
                            density="compact"
                            label="全选"
                          ></v-checkbox>
                        </template>
                        <template v-else>
                          {{ header.title }}
                        </template>
                        <!-- 筛选按钮 -->
                        <v-menu v-if="header.filterable" location="bottom" @click.stop>
                          <template v-slot:activator="{ props }">
                            <v-btn
                              icon="mdi-filter"
                              size="small"
                              variant="text"
                              density="compact"
                              v-bind="props"
                              :color="(header.key === 'kind' ? kindFilter : header.key === 'bigClass' ? bigClassHardwareFilter : typeHardwareFilter) ? '#D2475D' : undefined"
                              :class="(header.key === 'kind' ? kindFilter : header.key === 'bigClass' ? bigClassHardwareFilter : typeHardwareFilter) ? 'filter-btn-active' : ''"
                              class="ml-2 filter-btn"
                              @click.stop
                            />
                          </template>
                          <v-card class="filter-menu">
                            <v-card-text class="pa-2">
                              <template v-if="header.key === 'kind'">
                                <v-radio-group
                                  v-model="kindHardwareFilter"
                                  density="compact"
                                  class="filter-radio-group"
                                  hide-details
                                  @update:model-value="loadMaterialSummaryHardware"
                                >
                                  <v-radio
                                    label="全部"
                                    :value="null"
                                    color="#D2475D"
                                    density="compact"
                                  />
                                  <v-radio
                                    v-for="option in kindHardwareOptions"
                                    :key="option"
                                    :label="option"
                                    :value="option"
                                    color="#D2475D"
                                    density="compact"
                                  />
                                </v-radio-group>
                              </template>
                              <template v-if="header.key === 'bigClass'">
                                <v-radio-group
                                  v-model="bigClassHardwareFilter"
                                  density="compact"
                                  class="filter-radio-group"
                                  hide-details
                                  @update:model-value="loadMaterialSummaryHardware"
                                >
                                  <v-radio
                                    label="全部"
                                    :value="null"
                                    color="#D2475D"
                                    density="compact"
                                  />
                                  <v-radio
                                    v-for="option in bigClassSummaryHardwareOptions"
                                    :key="option"
                                    :label="option"
                                    :value="option"
                                    color="#D2475D"
                                    density="compact"
                                  />
                                </v-radio-group>
                              </template>
                              <template v-if="header.key === 'type'">
                                <v-radio-group
                                  v-model="typeHardwareFilter"
                                  density="compact"
                                  class="filter-radio-group"
                                  hide-details
                                  @update:model-value="loadMaterialSummaryHardware"
                                >
                                  <v-radio
                                    label="全部"
                                    :value="null"
                                    color="#D2475D"
                                    density="compact"
                                  />
                                  <v-radio
                                    v-for="option in smallClassSummaryHardwareOptions"
                                    :key="option"
                                    :label="option"
                                    :value="option"
                                    color="#D2475D"
                                    density="compact"
                                  />
                                </v-radio-group>
                              </template>
                            </v-card-text>
                            <v-divider />
                          </v-card>
                        </v-menu>
                      </th>
                    </tr>
                  </thead>
                  <tbody class="material-summary-table-body">
                    <template v-if="materialSummaryHardwareList.length > 0">
                      <tr v-for="(item, index) in materialSummaryHardwareList" :key="index">
                        <td></td>
                        <td style="text-align: left!important;">
                          <template v-if="item.materialName || item.materialSpec || item.materialCode">
                            <template v-if="item.materialName">
                              <p>{{ item.materialName }}</p>
                            </template>
                            <template v-if="item.specDesc">
                              <p>{{ item.specDesc }}</p>
                            </template>
                            <template v-if="item.materialCode">
                              <p class="material-code">{{ item.materialCode }}</p>
                            </template>
                          </template>
                          <template v-else>
                            /
                          </template>
                        </td>
                        <td>{{ item.bigClass || '/' }}</td>
                        <td>{{ item.smallClass || '/' }}</td>
                        <!-- <td>{{ item.totalQuantity || '/' }}</td> -->
                        <td>{{ item.totalUsageWithProductCount || '/' }}
                          <template v-if="Number(item.totalUsageWithProductCount) > 0">
                            {{ item.totalUsageUnit }}
                          </template>
                        </td>
                        <td>{{ item.currentInventory || '/' }}</td>
                        <td>{{ item.purchasedQuantity || '/' }}</td>
                        <td>
                          <v-checkbox
                            class="material-checkbox"
                            v-if="showFactoryChoosePurchaseHardware"
                            :model-value="selectedHardwareMaterials.includes(index)"
                            @change="handleSelectHardwareMaterial(item, index)"
                            hide-details
                            density="compact"
                          ></v-checkbox>
                          <v-btn v-else style="display: block;margin: 0 auto!important;" class="list-edit-btn" @click="handleSeeBomMaterial(item, index)">查看</v-btn>
                        </td>
                      </tr>
                    </template>
                    <tr v-if="materialSummaryHardwareList.length === 0">
                      <td colspan="100%" class="text-center">
                        暂无定制&五金数据
                      </td>
                    </tr>
                  </tbody>
                </v-table>
              </div>

              <!-- 定制&五金-->
              <div style="display: none!important;" class="product-table-container">
                <v-table class="product-table material-table material-summary-table" hover fixed-header :style="{ maxHeight: `calc(100vh - 350px)` }">
                  <thead>
                    <tr>
                      <th v-for="header in projectFiveMetalHeaders" :key="header.key" :class="['text-' + header.align]" :style="{ width: `${Number(header.minWidth) + 1}px` }">
                        <!-- <template v-if="header.key === 'actions' && showFactoryChoosePurchaseHardware">
                          <v-checkbox
                            class="material-checkbox"
                            v-model="isHardwareSelectAll"
                            @change="handleHardwareSelectAll"
                            hide-details
                            density="compact"
                            label="全选"
                          ></v-checkbox>
                        </template> -->
                        <!-- <template> -->
                          <div class="align-center">
                            <template v-if="header.key === 'partName' || header.key === 'materialName'">
                              <span style="color:#D2475D;font-weight: 800;">{{ header.title }}</span>
                            </template>
                            <template v-else>
                              {{ header.title }}
                            </template>
                            <!-- 产品筛选 -->
                            <v-menu v-if="header.key === 'productName'" location="bottom" :close-on-content-click="false">
                              <template v-slot:activator="{ props }">
                                <v-btn
                                  icon="mdi-filter"
                                  variant="text"
                                  density="compact"
                                  size="small"
                                  v-bind="props"
                                  :color="metalSearchForm.productName.length > 0 ? '#D2475D' : undefined"
                                  :class="metalSearchForm.productName.length > 0 ? 'filter-btn-active' : ''"
                                />
                              </template>
                              <v-card class="filter-menu">
                                <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                  <div class="filter-checkbox-group">
                                    <v-checkbox
                                      v-for="option in metalproductNamesOptions"
                                      :key="option"
                                      :label="option"
                                      :model-value="metalSearchForm.productName.includes(option)"
                                      @update:model-value="(checked) => handleMetalCheckboxChange('productName', option, checked)"
                                      color="#D2475D"
                                      density="compact"
                                      hide-details
                                    />
                                  </div>
                                </v-card-text>
                                <v-divider />
                              </v-card>
                            </v-menu>
                            <!-- 成品组件筛选 -->
                            <v-menu v-if="header.key === 'finishedComponentName'" location="bottom" :close-on-content-click="false">
                              <template v-slot:activator="{ props }">
                                <v-btn
                                  icon="mdi-filter"
                                  variant="text"
                                  density="compact"
                                  size="small"
                                  v-bind="props"
                                  :color="metalSearchForm.finishedComponentName.length > 0 ? '#D2475D' : undefined"
                                  :class="metalSearchForm.finishedComponentName.length > 0 ? 'filter-btn-active' : ''"
                                />
                              </template>
                              <v-card class="filter-menu">
                                <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                  <div class="filter-checkbox-group">
                                    <v-checkbox
                                      v-for="option in metalfinishedComponentNamesOptions"
                                      :key="option"
                                      :label="option"
                                      :model-value="metalSearchForm.finishedComponentName.includes(option)"
                                      @update:model-value="(checked) => handleMetalCheckboxChange('finishedComponentName', option, checked)"
                                      color="#D2475D"
                                      density="compact"
                                      hide-details
                                    />
                                  </div>
                                </v-card-text>
                                <v-divider />
                              </v-card>
                            </v-menu>
                            <!-- 组件筛选 -->
                            <v-menu v-if="header.key === 'componentName'" location="bottom" :close-on-content-click="false">
                              <template v-slot:activator="{ props }">
                                <v-btn
                                  icon="mdi-filter"
                                  variant="text"
                                  density="compact"
                                  size="small"
                                  v-bind="props"
                                  :color="metalSearchForm.componentName.length > 0 ? '#D2475D' : undefined"
                                  :class="metalSearchForm.componentName.length > 0 ? 'filter-btn-active' : ''"
                                />
                              </template>
                              <v-card class="filter-menu">
                                <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                  <div class="filter-checkbox-group">
                                    <v-checkbox
                                      v-for="option in metalcomponentNamesOptions"
                                      :key="option"
                                      :label="option"
                                      :model-value="metalSearchForm.componentName.includes(option)"
                                      @update:model-value="(checked) => handleMetalCheckboxChange('componentName', option, checked)"
                                      color="#D2475D"
                                      density="compact"
                                      hide-details
                                    />
                                  </div>
                                </v-card-text>
                                <v-divider />
                              </v-card>
                            </v-menu>
                            <!-- 零件筛选 -->
                            <v-menu v-if="header.key === 'partName'" location="bottom" :close-on-content-click="false">
                              <template v-slot:activator="{ props }">
                                <v-btn
                                  icon="mdi-filter"
                                  variant="text"
                                  density="compact"
                                  size="small"
                                  v-bind="props"
                                  :color="metalSearchForm.partName.length > 0 ? '#D2475D' : undefined"
                                  :class="metalSearchForm.partName.length > 0 ? 'filter-btn-active' : ''"
                                />
                              </template>
                              <v-card class="filter-menu">
                                <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                  <div class="filter-checkbox-group">
                                    <v-checkbox
                                      v-for="option in metalpartNamesOptions"
                                      :key="option"
                                      :label="option"
                                      :model-value="metalSearchForm.partName.includes(option)"
                                      @update:model-value="(checked) => handleMetalCheckboxChange('partName', option, checked)"
                                      color="#D2475D"
                                      density="compact"
                                      hide-details
                                    />
                                  </div>
                                </v-card-text>
                                <v-divider />
                              </v-card>
                            </v-menu>
                            <!-- 物料名称筛选 -->
                            <v-menu v-if="header.key === 'materialName'" location="bottom" :close-on-content-click="false">
                              <template v-slot:activator="{ props }">
                                <v-btn
                                  icon="mdi-filter"
                                  variant="text"
                                  density="compact"
                                  size="small"
                                  v-bind="props"
                                  :color="metalSearchForm.materialName.length > 0 ? '#D2475D' : undefined"
                                  :class="metalSearchForm.materialName.length > 0 ? 'filter-btn-active' : ''"
                                />
                              </template>
                              <v-card class="filter-menu">
                                <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                  <div class="filter-checkbox-group">
                                    <v-checkbox
                                      v-for="option in metalmaterialNamesOptions"
                                      :key="option"
                                      :label="option"
                                      :model-value="metalSearchForm.materialName.includes(option)"
                                      @update:model-value="(checked) => handleMetalCheckboxChange('materialName', option, checked)"
                                      color="#D2475D"
                                      density="compact"
                                      hide-details
                                    />
                                  </div>
                                </v-card-text>
                                <v-divider />
                              </v-card>
                            </v-menu>
                            <!-- 物料规格筛选 -->
                            <v-menu v-if="header.key === 'materialSpec'" location="bottom" :close-on-content-click="false">
                              <template v-slot:activator="{ props }">
                                <v-btn
                                  icon="mdi-filter"
                                  variant="text"
                                  density="compact"
                                  size="small"
                                  v-bind="props"
                                  :color="metalSearchForm.materialSpec.length > 0 ? '#D2475D' : undefined"
                                  :class="metalSearchForm.materialSpec.length > 0 ? 'filter-btn-active' : ''"
                                />
                              </template>
                              <v-card class="filter-menu">
                                <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                  <v-text-field
                                    v-model="metalSpecFilterKeyword"
                                    placeholder="搜索规格"
                                    density="compact"
                                    variant="outlined"
                                    clearable
                                    hide-details
                                    class="mb-2 search-menu"
                                  />
                                  <div class="filter-checkbox-group">
                                    <v-checkbox
                                      v-for="option in filteredMetalSpecsOptions"
                                      :key="option"
                                      :label="option"
                                      :model-value="metalSearchForm.materialSpec.includes(option)"
                                      @update:model-value="(checked) => handleMetalCheckboxChange('materialSpec', option, checked)"
                                      color="#D2475D"
                                      density="compact"
                                      hide-details
                                    />
                                  </div>
                                </v-card-text>
                                <v-divider />
                              </v-card>
                            </v-menu>
                            <!-- 物料编号筛选（定制&五金明细） -->
                            <v-menu v-if="header.key === 'materialCode'" location="bottom" :close-on-content-click="false">
                              <template v-slot:activator="{ props }">
                                <v-btn
                                  icon="mdi-filter"
                                  variant="text"
                                  density="compact"
                                  size="small"
                                  v-bind="props"
                                  :color="metalSearchForm.materialCode.length > 0 ? '#D2475D' : undefined"
                                  :class="metalSearchForm.materialCode.length > 0 ? 'filter-btn-active' : ''"
                                />
                              </template>
                              <v-card class="filter-menu">
                                <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                  <v-text-field
                                    v-model="metalMaterialCodeFilterKeyword"
                                    placeholder="搜索编号"
                                    density="compact"
                                    variant="outlined"
                                    clearable
                                    hide-details
                                    class="mb-2 search-menu"
                                  />
                                  <div class="filter-checkbox-group">
                                    <v-checkbox
                                      v-for="option in filteredMetalMaterialCodesOptions"
                                      :key="String(option)"
                                      :label="String(option)"
                                      :model-value="metalSearchForm.materialCode.includes(String(option))"
                                      @update:model-value="(checked) => handleMetalCheckboxChange('materialCode', String(option), checked)"
                                      color="#D2475D"
                                      density="compact"
                                      hide-details
                                    />
                                  </div>
                                </v-card-text>
                                <v-divider />
                                <v-card-actions class="pa-2 justify-end">
                                  <v-btn size="small" variant="text" color="#D2475D" @click="metalSearchForm.materialCode = []; handleMetalSearch()">清空</v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-menu>
                            <!-- 大类筛选 -->
                            <v-menu v-if="header.key === 'bigClass'" location="bottom" :close-on-content-click="false">
                              <template v-slot:activator="{ props }">
                                <v-btn
                                  icon="mdi-filter"
                                  variant="text"
                                  density="compact"
                                  size="small"
                                  v-bind="props"
                                  :color="metalSearchForm.bigClass.length > 0 ? '#D2475D' : undefined"
                                  :class="metalSearchForm.bigClass.length > 0 ? 'filter-btn-active' : ''"
                                />
                              </template>
                              <v-card class="filter-menu">
                                <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                  <div class="filter-checkbox-group">
                                    <v-checkbox
                                      v-for="option in metalbigClassesOptions"
                                      :key="option"
                                      :label="option"
                                      :model-value="metalSearchForm.bigClass.includes(option)"
                                      @update:model-value="(checked) => handleMetalCheckboxChange('bigClass', option, checked)"
                                      color="#D2475D"
                                      density="compact"
                                      hide-details
                                    />
                                  </div>
                                </v-card-text>
                                <v-divider />
                              </v-card>
                            </v-menu>
                            <!-- 小类筛选 -->
                            <v-menu v-if="header.key === 'smallClass'" location="bottom" :close-on-content-click="false">
                              <template v-slot:activator="{ props }">
                                <v-btn
                                  icon="mdi-filter"
                                  variant="text"
                                  density="compact"
                                  size="small"
                                  v-bind="props"
                                  :color="metalSearchForm.smallClass.length > 0 ? '#D2475D' : undefined"
                                  :class="metalSearchForm.smallClass.length > 0 ? 'filter-btn-active' : ''"
                                />
                              </template>
                              <v-card class="filter-menu">
                                <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto;">
                                  <div class="filter-checkbox-group">
                                    <v-checkbox
                                      v-for="option in metalsmallClassesOptions"
                                      :key="option"
                                      :label="option"
                                      :model-value="metalSearchForm.smallClass.includes(option)"
                                      @update:model-value="(checked) => handleMetalCheckboxChange('smallClass', option, checked)"
                                      color="#D2475D"
                                      density="compact"
                                      hide-details
                                    />
                                  </div>
                                </v-card-text>
                                <v-divider />
                              </v-card>
                            </v-menu>
                          </div>
                        <!-- </template> -->
                      </th>
                    </tr>
                  </thead>
                  <tbody class="material-summary-table-body">
                    <tr v-if="loadingMaterialSummaryHardware" class="text-center">
                      <td :colspan="projectFiveMetalHeaders.length" class="py-8">
                        <v-progress-circular indeterminate color="primary" size="40" width="3"></v-progress-circular>
                        <div class="mt-2 text-grey">加载中...</div>
                      </td>
                    </tr>
                    <tr v-else-if="mergeProductionWareMetalItems.length === 0" class="text-center">
                      <td :colspan="projectFiveMetalHeaders.length" class="py-8">料单暂无数据</td>
                    </tr>
                    <template v-else>
                      <tr
                        v-for="(item, index) in mergeProductionWareMetalItems" :key="index"
                      >
                        <td></td>
                        <td class="text-left" style="text-align: left!important;">
                          {{ item.product?.name }} <br>
                          <span style="color:#898989;word-wrap: unset !important;word-break: keep-all !important;">{{ item.product?.code }}</span> <br>
                          <span style="color:#898989;word-wrap: unset !important;word-break: keep-all !important;">{{ item.product?.syscode }}</span>
                        </td>
                        <td class="text-center">
                          {{ item.sequenceNo }}
                        </td>
                        <td class="text-center">
                          {{ item.finishedComponentName || '/' }}
                        </td>
                        <td class="text-center">
                          {{ item.componentName || '/' }}
                        </td>
                        <td class="text-center">
                          {{ item.partName || '/' }}
                        </td>
                        <td class="text-center">
                          {{ item.materialName || '/' }}
                        </td>
                        <td class="text-center">
                          {{ item.materialSpec || '/' }}
                        </td>
                        <td class="text-center">
                          {{ item.materialCode || '/' }}
                        </td>
                        <td class="text-left" style="padding-left: 16px!important;text-align: left!important;">
                          <template v-if="item.width || item.depth || item.height">
                            <template v-if="item.width">
                              W:{{ item.width || '/' }} <br>
                            </template>
                            <template v-if="item.depth">
                              D:{{ item.depth || '/' }} <br>
                            </template>
                            <template v-if="item.height">
                              H:{{ item.height || '/' }}
                            </template>
                          </template>
                          <template v-else>
                            /
                          </template>
                        </td>
                        <td class="text-center">
                          {{ item.quantity || '/' }}
                        </td>
                        <td class="text-center">
                          {{ item.remark || '/' }}
                        </td>
                        <td class="text-center">
                          {{ item.bigClass || '/' }}
                        </td>
                        <td class="text-center">
                          {{ item.smallClass || '/' }}
                        </td>
                        <td class="text-center">
                          {{ item.materialUsage || '/' }} 
                          <template v-if="item.materialUsage">
                            {{ item.materialUsageUnit }}
                          </template>
                        </td>
                        <td class="text-center">
                          <!-- <template v-if="contractInfo.productCount">
                            {{ contractInfo.productCount * (item.materialUsage || 0) }} 
                            <template v-if="item.materialUsageUnit">
                              {{ item.materialUsageUnit }}
                            </template>
                          </template>
                          <template v-else>
                            /
                          </template> -->
                          <template v-if="item.product?.count">
                            {{ formatNumberUse(item.product?.count * (item.materialUsage || 0), 4) }} 
                            <template v-if="item.materialUsageUnit">
                              {{ item.materialUsageUnit }}
                            </template>
                          </template>
                          <template v-else>
                            /
                          </template>
                        </td>
                        <td>
                          <v-checkbox
                            class="material-checkbox"
                            v-if="showFactoryChoosePurchaseHardware"
                            :model-value="selectedHardwareMaterials.includes(index)"
                            @change="handleChooseHardwareMaterial(item, index)"
                            hide-details
                            density="compact"
                          ></v-checkbox>
                          <!-- <v-btn v-else style="display: block;margin: 0 auto!important;" class="list-edit-btn" @click="handleSeeBomMaterial(item, index)">查看</v-btn> -->
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </v-table>
                <!-- 定制&五金分页 -->
                <div class="custom-pagination d-flex align-center justify-space-between">
                  <div class="pagination-info">共 {{ metalPagination.total }} 条记录</div>
                  
                  <div class="d-flex align-center">
                    <div class="pagination-controls">
                      <v-btn
                        icon="mdi-chevron-double-left"
                        variant="text"
                        density="comfortable"
                        :disabled="metalPagination.page === 1"
                        @click="handleMetalPageChange(1)"
                        class="pagination-btn"
                      />
                      <v-btn
                        icon="mdi-chevron-left"
                        variant="text"
                        density="comfortable"
                        :disabled="metalPagination.page === 1"
                        @click="handleMetalPageChange(metalPagination.page - 1)"
                        class="pagination-btn"
                      />
                      <span class="pagination-text mx-2">{{ metalPagination.page }} / {{ metalTotalPages }}</span>
                      <v-btn
                        icon="mdi-chevron-right"
                        variant="text"
                        density="comfortable"
                        :disabled="metalPagination.page === metalTotalPages"
                        @click="handleMetalPageChange(metalPagination.page + 1)"
                        class="pagination-btn"
                      />
                      <v-btn
                        icon="mdi-chevron-double-right"
                        variant="text"
                        density="comfortable"
                        :disabled="metalPagination.page === metalTotalPages"
                        @click="handleMetalPageChange(metalTotalPages)"
                        class="pagination-btn"
                      />
                    </div>
                  </div>
                </div>
              </div>                        
            </div>
          </v-form>
        </v-card-text>
        <!-- 按钮区域 -->
        <div class="form-actions">
          <template v-if="titleList[0].isChoosed || titleList[1].isChoosed || titleList[2].isChoosed || titleList[3].isChoosed">
            <v-btn v-if="currentChooseAction !== ''" color="error" variant="tonal" @click="handleCancelPurchase">
              取消
            </v-btn>
            <v-btn v-if="currentChooseAction === 'direct' || currentChooseAction === ''" color="primary" variant="flat" @click="currentChooseAction === '' ? startDirectPurchase() : handleDirectPurchase()">
              <v-img :src="purchaseCaseImg" width="20" height="20" class="mr-1" />
              {{ currentChooseAction === '' ? '直接采购' : '确定' }}
            </v-btn>
            <v-btn v-if="currentChooseAction === 'add' || currentChooseAction === ''" color="primary" variant="flat" @click="currentChooseAction === '' ? startAddPurchase() : handleAddPurchase()">
              <v-img :src="purchaseCarImg" width="20" height="20" class="mr-1" />
              {{ currentChooseAction === '' ? '加采购项' : '确定' }}
            </v-btn>
            <v-btn color="primary" variant="flat" @click="handleExportProductionOrderPdf" v-if="titleList[0].isChoosed">导出生产单</v-btn>
          </template>
        </div>
        <div class="form-actions" style="display: none;">
          <!-- <v-btn
            color="primary"
            @click="handleSubmit"
            :loading="loading"
            :disabled="!valid"
          >
            提交估价
          </v-btn> -->
          <!-- <v-checkbox
            v-if="isEdit === 'estimate'"
            v-model="productInfo.pricingFinish"
            @change="handleCheckAll"
            class="estimate-checkbox"
          /> -->
          <v-checkbox
            v-if="isEdit === 'estimate'"
            v-model="productInfo.pricingStatus"
            @change="handleCheckAll"
            class="estimate-checkbox"
          />
          <v-btn
            color="primary"
            variant="flat"
            class="ml-4"
            @click="correlateMaterialItem"
          >
            引用汇总
          </v-btn>
          <v-btn
            color="primary"
            variant="flat"
            class="ml-4"
            @click="addMaterialItem"
          >
            添加物料
          </v-btn>
          <!-- <v-btn
            color="primary"
            variant="flat"
            class="ml-4"
            @click="handleScreenshotImport"
          >
            截图导入
          </v-btn> -->
          <v-btn v-if="isEdit === 'estimate'"
            color="primary"
            variant="flat"
            class="ml-4"
            @click="copyProductMaterial"
          >
            复制物料
          </v-btn>
          <!-- <v-btn
            color="primary"
            variant="flat"
            class="ml-4"
            @click="importMaterial"
          >
            导入物料
          </v-btn> -->
          <!-- <v-btn
            color="primary"
            variant="flat"
            @click="handleSaveAll"
            class="ml-4"
          >
            保存
          </v-btn> -->
        </div>
       

        <!-- 公共Loading组件 -->
        <div v-if="showCommonLoading" class="common-loading-overlay">
          <div class="common-loading-container">
            <div class="common-loading-spinner"></div>
            <p class="common-loading-text">{{ commonLoadingText || '加载中...' }}</p>
          </div>
        </div>

        <!-- 发起采购对话框 -->
        <v-dialog
          v-model="showPurchaseDialog"
          max-width="1250"
          height="80vh"
          persistent
        >
          <v-card class="purchase-dialog">
            <v-card-title class="d-flex justify-space-between align-center">
              <span>{{ purchaseData.purchaseOrderNo ? '修改采购' : '发起采购' }}</span>
              <v-btn
                icon="mdi-close"
                variant="text"
                @click="closePurchaseDialog"
              />
            </v-card-title>
            <v-card-text>
              <v-form ref="purchaseForm" v-model="purchaseValid">
                <!-- 供应商选择 -->
                <v-row>
                  <v-col cols="4">
                    <v-autocomplete
                      v-model="purchaseData.vendor"
                      v-model:search="vendorSearchText"
                      :items="vendorSearchText ? vendorList : []"
                      :loading="vendorLoading"
                      :no-filter="true"
                      item-title="companyName"
                      item-value="id"
                      label="供应商"
                      placeholder="请输入供应商名搜索"
                      persistent-placeholder
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      :no-data-text="vendorSearchText ? '没有找到匹配的供应商' : '请输入供应商名进行搜索'"
                      clearable
                      return-object
                    >
                      <template v-slot:item="{ props, item }">
                        <v-list-item
                          v-bind="props"
                          :title="item.raw.companyName"
                          :subtitle="item.raw.type ? `${item.raw.type}` : ''"
                        />
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="3">
                    <v-select
                      v-model="purchaseData.warehouse"
                      :items="formattedWarehouseList"
                      item-title="warehouseName"
                      item-value="warehouseAddress"
                      label="送货地址"
                      placeholder="请选择送货地址"
                      persistent-placeholder
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      return-object
                      @update:model-value="handleWarehouseChange"
                    >
                      <template v-slot:item="{ props, item }">
                        <v-list-item
                          v-bind="props"
                          :title="item.raw.warehouseName"
                          :subtitle="item.raw.warehouseAddress ? `地址: ${item.raw.warehouseAddress}` : ''"
                        />
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="5">
                    <v-select
                      v-model="purchaseData.purchaseStandard"
                      :items="purchaseStandardList"
                      item-title="value"
                      item-value="value"
                      label="采购标准"
                      placeholder="请选择采购标准"
                      persistent-placeholder
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      return-object
                    >
                      <!-- <template v-slot:item="{ props, item }">
                        <v-list-item
                          v-bind="props"
                          :title="item.raw.warehouseName"
                          :subtitle="item.raw.warehouseNo ? `编号: ${item.raw.warehouseNo}` : ''"
                        />
                      </template> -->
                    </v-select>
                  </v-col> 
                </v-row>
                <!-- 付款信息 -->
                <v-row class="mt-4">
                  <v-col>
                    <v-select
                      v-model="purchaseData.paymentMethod"
                      :items="paymentMethods"
                      label="付款方式"
                      persistent-placeholder
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      item-title="label"
                      item-value="value"
                    />
                  </v-col>
                  <v-col>
                    <v-select
                      v-model="purchaseData.taxRate"
                      :items="taxRates"
                      label="税率"
                      persistent-placeholder
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      item-title="label"
                      item-value="value"
                      return-object
                    />
                  </v-col>
                  <v-col>
                    <v-select
                      v-model="purchaseData.tax"
                      :items="taxs"
                      label="是否含税"
                      persistent-placeholder
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      item-title="label"
                      item-value="value"
                      return-object
                    />
                  </v-col>
                  <v-col>
                    <v-select
                      v-model="purchaseData.paymentCompany"
                      :items="paymentCompanys"
                      label="付款公司"
                      persistent-placeholder
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      item-title="label"
                      item-value="value"
                      return-object
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-text-field
                      v-model="purchaseData.taxAmount"
                      label="税额"
                      persistent-placeholder
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      type="number"
                      class="v-field--readonly"
                      readonly
                    />
                  </v-col> 
                  <!-- <v-col cols="4">
                    <div style="position: relative;">
                      <v-text-field
                        v-model="purchaseData.paymentDate"
                        label="计划交货"
                        persistent-placeholder
                        variant="outlined"
                        density="compact"
                        hide-details="auto"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        class="native-date-field"
                        @click="openNativeDatePicker"
                      />
                      <input
                        ref="nativeDateInput"
                        type="date"
                        v-model="purchaseData.paymentDate"
                        style="position: absolute; left: 0; top: 100%; opacity: 0; pointer-events: none; width: 100%; height: 1px; z-index: 9999;"
                        @change="onNativeDateChange"
                      />
                    </div>
                  </v-col> -->
                  <v-col cols="2">
                    <v-text-field 
                      label="合计金额"
                      persistent-placeholder
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      :model-value="purchaseData.totalAmount"
                      type="number"
                      class="v-field--readonly"
                      readonly
                    >
                      <!-- <template v-slot:append-inner>
                        <span>元</span>
                      </template> -->
                    </v-text-field>
                  </v-col>
                  <v-col cols="2">
                    <v-text-field 
                      label="含税总金额"
                      persistent-placeholder
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      v-model.number="purchaseData.totalAmountWithTax"
                      type="number"
                      readonly
                      class="v-field--readonly"
                    >
                      <!-- <template v-slot:append-inner>
                        <span>元</span>
                      </template> -->
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-textarea
                      v-model="purchaseData.remark"
                      label="采购备注"
                      persistent-placeholder
                      variant="outlined"
                      density="compact"
                      hide-details
                      rows="2"
                      resize="false"
                      auto-grow
                      maxlength="500"
                    ></v-textarea>
                  </v-col>
                </v-row>
                <!-- 物料列表 -->
                 <!-- {{selectedMaterialDetails}} -->
                <div style="color: #fff; font-size: 16px; font-weight: bold; margin-top: 10px;">物料</div>
                <div class="material-purchase-list">
                  <div class="material-purchase-body">
                    <div 
                      v-for="(material,index) in selectedMaterialDetails" 
                      :key="material.id"
                      class="material-purchase-item"
                    >
                      <div style="color:#fff;margin-right: 10px;">{{ index + 1 }}</div>
                      <div class="item-content" style="width: 13%;">
                        <div class="material-name" style="text-align: left;">{{ material.materialName }}</div>
                        <div style="text-align: left;">{{ material.specDesc }}</div>
                        <div class="material-code" style="text-align: left;">{{ material.materialCode }}</div>
                      </div>
                      <div class="item-content" style="width: 13%;">
                        <div class="material-name" style="text-align: left;padding-left: 6px;border-left: 3px solid #D2475D;line-height: 1;margin-bottom: 4px;">下单状态</div>
                        <div class="material-name" style="text-align: left;">
                          料单预估 <span class="material-code">
                            {{ material.bomEstimate || '/' }}
                            <template v-if="material.bomEstimate">{{ material.bomEstimateUnit }}</template>
                          </span>
                        </div>
                        <div style="text-align: left;">
                          采购中 <span class="material-code">
                            {{ material.purchasing || '/' }}
                            <template v-if="material.purchasing">{{ material.purchasingUnit }}</template>
                          </span>
                        </div>
                        <div class="material-name" style="text-align: left;">
                          库存 <span class="material-code">
                            {{ material.inventory || '/' }}
                            <template v-if="material.inventory">{{ material.inventoryUnit }}</template>
                          </span>
                        </div>
                      </div>
                      <!-- <div class="item-content" style="width: 17%;">
                        <v-textarea
                          v-model="material.brand"
                          label="品牌"
                          persistent-placeholder
                          variant="outlined"
                          density="compact"
                          hide-details="auto"
                          rows="1"
                          resize
                          auto-grow
                          class="auto-grow-textarea"
                        ></v-textarea>
                      </div> -->
                      <div class="item-content" style="width: 9%;">
                        <v-text-field
                          v-model="material.materialCount"
                          label="数量"
                          persistent-placeholder
                          variant="outlined"
                          density="compact"
                          hide-details="auto"
                          type="number"
                          @input="handleQuantityInput(material,index)"
                        >
                          <!-- <template v-slot:append-inner>
                            <span>{{ material.materialUnit }}</span>
                          </template> -->
                        </v-text-field>
                      </div>
                      <div class="item-content" style="width: 100px;">
                        <v-select
                          v-model="material.unit"
                          :items="getUnitListByBigClassOrSmallClass(material.bigClass, material.smallClass)"
                          label="单位"
                          persistent-placeholder
                          variant="outlined"
                          density="compact"
                          hide-details="auto"
                          item-title="unitName"
                          item-value="unitName"
                          return-object
                          :readonly="!!(material._originalMaterialUnit)" 
                          :class="!!(material._originalMaterialUnit) ? 'v-field--readonly' : ''"
                        />
                      </div>
                      <div class="item-content" style="width: 9%;">
                        <v-text-field
                          v-model="material.materialPrice"
                          label="单价"
                          persistent-placeholder
                          variant="outlined"
                          density="compact"
                          hide-details
                          type="number"
                          @input="handlePriceInput(material,index)"
                        />
                      </div>
                      
                      <!-- class="v-field--readonly"
                          readonly -->
                      <div class="item-content" style="width: 13%;">
                        <v-text-field
                          :model-value="calculateTotalPrice(material.materialPrice, material.materialCount)"
                          label="金额"
                          persistent-placeholder
                          variant="outlined"
                          density="compact"
                          hide-details="auto"
                          type="number"
                          class="v-field--readonly"
                          readonly
                        />
                      </div>
                      <div class="item-content">
                        <v-textarea
                          v-model="material.remark"
                          label="物料备注"
                          persistent-placeholder
                          variant="outlined"
                          density="compact"
                          hide-details
                          rows="1"
                          resize
                          auto-grow
                          maxlength="100"
                        ></v-textarea>
                      </div>
                      <div class="item-content" style="width: 180px;position:relative">
                        <v-text-field
                          v-model="material.plannedDeliveryDate"
                          label="计划交货"
                          persistent-placeholder
                          variant="outlined"
                          density="compact"
                          hide-details="auto"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          class="native-date-field"
                          @click="openMaterialDatePicker(index)"
                        />
                        <!-- 隐藏的原生日期输入框 
                          :rules="[v => !!v || '请选择日期']"-->
                        <input
                          :ref="el => setMaterialDateInputRef(el, index)"
                          type="date"
                          :value="material.plannedDeliveryDate"
                          :min="getTodayDate()"
                          style="position: absolute; left: 0; top: 100%; opacity: 0; pointer-events: none; width: 100%; height: 1px; z-index: 9999;"
                          @change="(e) => onMaterialDateChange(e, index)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </v-form>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn
                color="error"
                variant="tonal"
                @click="closePurchaseDialog"
              >
                取消
              </v-btn>
              <v-btn
                color="primary"
                variant="flat"
                @click="submitPurchase"
              >
                确定
                <!-- :loading="purchaseLoading" -->
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </div>
  </div>

  <!-- 图片预览对话框 -->
  <ImagePreviewDialog
    v-model="showPreview"
    :image-list="previewImage"
    :initial-index="selectedIndex"
    :current-material-index="currentParentIndex"
    :is-delete="isDelete"
    :type="type"
    @close="handleClosePreview"
  />

  <PurchasePdfPreviewDialog
    v-model="previewPdfDialog"
    :is-exporting-pdf="isExportingPdf"
    :item-list="previewItemList"
    :preview-pdf-data="previewPdfData"
    :jf-logo="jfLogo"
    :format-pdf-date="formatPdfDate"
    :format-pdf-number="formatPdfNumber"
    :get-payment-method-label="getPaymentMethodLabel"
    @confirm-export="handleExportFromPreview"
  />

  <!-- 统一发起采购弹窗（复用组件，不删除旧实现） -->
  <PurchaseDialog
    ref="purchaseDialogRef"
    :warehouse-options="formattedWarehouseList"
    :allow-warehouse-select="true"
    :contract-id="contractId"
    :contract-code="contractInfo.code"
    :project-name="contractInfo.project"
    @success="handlePurchaseSuccessFromDialog"
  />
  <AddPurchaseItemDialog
    v-model="showAddPurchaseItemDialog"
    :rows="addPurchaseDialogRows"
    :project-name="contractInfo.project"
    :contract-code="contractInfo.code"
    :contract-id="contractId"
    :warehouse-no="addPurchaseWarehouseNo"
    @success="handleAddPurchaseItemsSuccess"
  />
  <ProductionOrderPdfExport
    ref="pdfExportRef"
    :items="exportProductionList"
    :contract-info="contractInfo"
    :total-count="productionTotalCount"
    :export-date-time="productionExportDateTime"
    :assign-time-display="'/'"
    @success="() => showSuccess('生产单PDF导出成功')"
    @error="(msg) => showError(msg)"
  />
  </div>
</template>

<script setup lang="ts">
import { ref, onUnmounted, onMounted, computed, nextTick, watch } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'
import { useRouter, useRoute } from 'vue-router'
import { contractApi, purchaseApi, uploadApi, goodsManageApi } from '@/services/api'
import { id } from 'vuetify/lib/locale/index.mjs'
import { bigClassOptions, getMaterialTypeOptions, materialUnitOptions, processStatusOptions } from '@/constants/contract'
import MaterialImagePreview from '@/components/MaterialImagePreview.vue'
import ImagePreviewDialog from '@/components/ImagePreviewDialog.vue'
import UploadImgDialog from '@/components/UploadImg.vue'
import ImportExcel from '@/components/ImportMaterialExcel.vue'
import UploadExcelImgDialog from '@/components/UploadExcelImg.vue'
import PurchaseDialog from '@/components/PurchaseDialog.vue'
import AddPurchaseItemDialog from '@/components/AddPurchaseItemDialog.vue'
import PurchasePdfPreviewDialog from '@/components/PurchasePdfPreviewDialog.vue'
import ProductionOrderPdfExport from '@/components/ProductionOrderPdfExport.vue'
import { printPurchaseOrderByContentId } from '@/utils/printPurchaseOrder'
import jsPDF from 'jspdf'
// @ts-ignore
import html2canvas from 'html2canvas'

import delBg from '@/assets/delBg.png'
import leftBtn from '@/assets/leftBtn.png'
import rightBtn from '@/assets/rightBtn.png'
import pdfTop from '@/assets/pdfTop.png'
import jfLogo from '@/assets/jf.png'
import allotOneImg from '@/assets/allotOne.png'
import allotTwoImg from '@/assets/allotTwo.png'
import allotThreeImg from '@/assets/allotThree.png'
import allotFourImg from '@/assets/allotFour.png'

import yijiagouImg from '@/assets/yijiagou.png'
import purchaseCaseImg from '@/assets/purchaseCase.png'
import purchaseCarImg from '@/assets/purchaseCar.png'
interface PurchaseListItem {
  id: number
  purchaseOrderNo: string
  supplierName: string
  totalAmount: number
  paymentType: string
}

interface MaterialItem {
  id?: number
  name: string
  code: string
  specification: string
  salesmanRemark: string
  // supplier: string
  materialDescription: string
  kind: string, // 种类
  bigClass: string, // 大类
  type: string
  image: File | null
  price: number
  count: number
  materialUnit: string, // 物料单位
  unit: string, // 单位
  total: number
  images?: { url: string; name: string }[]
  materialCustomerNo?: string, // 客户号
  finishedComponent?: string, // 成品组件
  component?: string, // 组件
  materialCode: string
  materialType: string
  specDesc: string
  smallClass: string
  totalQuantity: string
  totalUsage: string
  totalUsageWithProductCount: string
  totalUsageUnit: string
  currentInventory: string
  purchasedQuantity: string
  quantity: number,
  wuliaoStatus: number,
  productCodes: string[]
}

interface MaterialBomItem {
  id: number
  sequenceNo: number
  packageNo: string
  finishedComponentName: string
  componentName: string
  partName: string
  materialName: string
  materialCode: string
  materialSpec: string
  materialUsage: string
  width: number
  depth: number
  height: number
  count: number
  bend: number
  unit: string
  frontArea: string
  frontFinish: string
  frontFinishMaterial: string
  frontMaterial: string
  backFinish: string
  backFinishMaterial: string
  backMaterial: string
  backArea: string
  edgeDepth: number
  edgeMaterial: string
  edgeWidth: number
  remark: string
  paintMethod: string
  paintFaces: string
  paintArea: string
}

interface TitleList {
  title: string
  isChoosed: boolean
}

interface ContractInfo {
  id: number
  code: string
  name: string
  description: string
  createTime: string
  updateTime: string
  wuliaoOwner: string
}

interface WarehouseItem {
  warehouseName: string
  warehouseNo: string
}

interface WarehouseItemOptions {
  warehouseNo: string
  warehouseName: string
  warehouseAddress: string
}

const router = useRouter()
const route = useRoute()
const originId = ref('')
const { showSuccess, showError } = useSnackbar()
const form = ref()
const valid = ref(false)
const loading = ref(false)
const isEdit = ref<'edit' | 'estimate' | 'see' | 'materialControl' | 'new' | null>(null)
const tempMaterialCode = ref('')

const showCommonLoading = ref(false)
const commonLoadingText = ref('')

const keywordSearchProduct = ref('')
const keywordSearchMaterial = ref('')
const keywordSearchMetal = ref('')

// PDF预览相关变量
const previewPdfDialog = ref(false)
const isExportingPdf = ref(false)
const previewPdfData = ref<any>({})
const previewItemList = ref<any[]>([])

const contractInfo = ref<any>({ })

// 生产单批量导出相关
const exportProductionList = ref<any[]>([])
const pdfExportRef = ref<InstanceType<typeof ProductionOrderPdfExport> | null>(null)
const productionTotalCount = computed(() => {
  if (!exportProductionList.value.length) return 0
  return exportProductionList.value.reduce((total: number, item: any) => {
    return total + (Number(item.count) || 0)
  }, 0)
})
const productionExportDateTime = computed(() => {
  const now = new Date()
  const yy = String(now.getFullYear()).slice(-2)
  const m = now.getMonth() + 1
  const d = now.getDate()
  const h = String(now.getHours()).padStart(2, '0')
  const min = String(now.getMinutes()).padStart(2, '0')
  return `${yy}/${m}/${d} ${h}:${min}`
})

// 图片索引状态管理
const productImageIndexes = ref<{ [key: number]: number }>({})
const materialImageIndexes = ref<{ [key: number]: number }>({}) // 物料图片索引状态管理

// 放大缩小状态
const zoomLevel = ref(1) // 1: 正常, 2: 放大
const zoomedRows = ref<{ [key: number]: boolean }>({}) // 记录哪些行被放大了，兼容Safari
const materialZoomedRows = ref<{ [key: number]: boolean }>({}) // 记录哪些物料行被放大了
const materialZoomLevel = ref(1) // 1: 正常, 2: 放大

const isAddBySelf = ref(true)

const titleList = ref<TitleList[]>([
  { title: '生产单', isChoosed: true },
  { title: '物控汇总', isChoosed: false },
  { title: '常规材料', isChoosed: false },
  { title: '定制&五金', isChoosed: false },
  { title: '采购单', isChoosed: false },
  // { title: '估价', isChoosed: false }
])

// 生产单表格列配置
const productionOrderHeaders = [
  { title: '产品', key: 'productImageUrls', align: 'center', width: '110px' },
  { title: '编码', key: 'contractCode', align: 'center', width: '100px' },
  { title: '名称', key: 'nameShort', align: 'center', width: '80px' },
  { title: '尺寸', key: 'size', align: 'center', width: '80px' },
  { title: '区域', key: 'area', align: 'center', width: '120px' },
  { title: '数量', key: 'count', align: 'center', width: '70px' },
  { title: '生产状态', key: 'toProductionStatus', align: 'center', width: '95px' },
  { title: '产品描述', key: 'description', align: 'center', width: '200px' },
  // { title: '业务员', key: 'salesmanName', align: 'center', width: '80px' },
  { title: '交期', key: 'deliveryTime', align: 'center', width: '70px' },
  { title: '分配时间', key: 'assignTime', align: 'center', width: '75px' },
  { title: '工艺', key: 'productionNode', align: 'center', width: '100px' },
  { title: '操作', key: 'actions', align: 'center', width: '180px' }
]

// 生产单列表数据
const productCount = ref(null)
const productCountSum = ref(null)

const productionOrderList = ref<any[]>([])
const productionOrderLoading = ref(false)
const productionOrderTotal = ref(0)
const productionOrderPage = ref(1)
const productionOrderPageSize = ref(30)
const productionOrderTotalPages = computed(() => Math.max(1, Math.ceil(productionOrderTotal.value / productionOrderPageSize.value)))
const productionOrderTypeOfOptions = ['一厂', '二厂', '三厂', '四厂']
const productionOrderSearchForm = ref<{ typeOf: string[] }>({
  typeOf: []
})

/** 区域列筛选 */
const productAreaFilterMenuOpen = ref(false)
const productAreaFilterForm = ref({
  building: '',
  roomType: '',
  floor: '',
  areaRoomType: '',
})
const productBuildingFilterOptions = ref<string[]>([])
const productRoomTypeFilterOptions = ref<string[]>([])
const productFloorFilterOptions = ref<string[]>([])
const productAreaRoomTypeFilterOptions = ref<string[]>([])
const hasProductAreaFilter = computed(() => {
  return !!(
    productAreaFilterForm.value.building ||
    productAreaFilterForm.value.roomType ||
    productAreaFilterForm.value.floor ||
    productAreaFilterForm.value.areaRoomType
  )
})

const clearProductAreaFilter = () => {
  productAreaFilterForm.value.building = ''
  productAreaFilterForm.value.roomType = ''
  productAreaFilterForm.value.floor = ''
  productAreaFilterForm.value.areaRoomType = ''
  productAreaFilterMenuOpen.value = false
  productionOrderPage.value = 1
  loadProductionOrderList()
}

const confirmProductAreaFilter = () => {
  productAreaFilterMenuOpen.value = false
  productionOrderPage.value = 1
  loadProductionOrderList()
}

const triggerProductionOrderSearch = async () => {
  productionOrderPage.value = 1
  await loadProductionOrderList()
}

const handleProductionOrderSearch = (field: 'typeOf', value: string, checked: any) => {
  const arr = productionOrderSearchForm.value[field]
  if (checked) {
    if (!arr.includes(value)) {
      arr.push(value)
    }
  } else {
    const index = arr.indexOf(value)
    if (index > -1) {
      arr.splice(index, 1)
    }
  }
  triggerProductionOrderSearch()
}

const setProductionOrderTypeOfSelection = (values: string[]) => {
  productionOrderSearchForm.value.typeOf = [...values]
  triggerProductionOrderSearch()
}

// 生产单表格用日期格式化
const formatIntDateProduction = (date: string) => {
  if (!date) return '/'
  const d = new Date(date)
  const year = d.getFullYear().toString().slice(-2)  // 2026 只显示26年
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${year}/${parseInt(month)}/${parseInt(day)}`
}

// 生产单工艺状态图标
const getProcessImage = (processName: string): string | undefined => {
  const process = processStatusOptions?.find((item: any) => item.title === processName)
  return process?.image
}

// 加载生产单列表
const loadProductionOrderList = async () => {
  if (!contractId.value) return
  try {
    productionOrderLoading.value = true
    const params: any = {
      ignoreFactoryFilter: 1,
      page: productionOrderPage.value,
      pageSize: productionOrderPageSize.value,
      orderBy: 'id',
      sort: 'desc',
      hideRoomNumber: 1,
      contractId: Number(contractId.value)
    }
    if (productionOrderSearchForm.value.typeOf.length > 0) {
      params.typeOf = productionOrderSearchForm.value.typeOf.join(',')
    }
    if (keywordSearchProduct.value) {
      params.keyword = keywordSearchProduct.value
    }
    if (productAreaFilterForm.value.building) {
      params.building = productAreaFilterForm.value.building
    }
    if (productAreaFilterForm.value.roomType) {
      params.roomType = productAreaFilterForm.value.roomType
    }
    if (productAreaFilterForm.value.floor) {
      params.floor = productAreaFilterForm.value.floor
    }
    if (productAreaFilterForm.value.areaRoomType) {
      params.areaRoomType = productAreaFilterForm.value.areaRoomType
    }
    const res = await contractApi.getFactoryProductList(params)
    if (res?.code === 0 && res.data) {
      productCount.value = Number(res.data.productCount || 0)
      productCountSum.value = Number(res.data.productCountSum || 0)
      const filterValues = res.data.records?.[0]?.filterValues || {}
      productBuildingFilterOptions.value = Array.isArray(filterValues.building)
        ? filterValues.building.map((x: any) => String(x))
        : []
      productRoomTypeFilterOptions.value = Array.isArray(filterValues.roomType)
        ? filterValues.roomType.map((x: any) => String(x))
        : []
      productFloorFilterOptions.value = Array.isArray(filterValues.floor)
        ? filterValues.floor.map((x: any) => String(x))
        : []
      productAreaRoomTypeFilterOptions.value = Array.isArray(filterValues.areaRoomType)
        ? filterValues.areaRoomType.map((x: any) => String(x))
        : []
      productionOrderList.value = (res.data.records || []).map((item: any) => ({
        area: item.area || '/',
        productionInvalidStatus: Number(item.productionInvalidStatus) || 0,
        description: item.description || '/',
        id: item.id,
        originId: item.originId,
        code: item.code,
        batch: item.batch,
        contractCode: item.contractCode,
        project: item.project,
        syscode: item.syscode,
        nameShort: item.nameShort,
        name: item.name,
        preProduction: Number(item.preProduction) || 0,
        qtyUpdateNoticeId: item.qtyUpdateNoticeId, // 最新数量变更通知ID
        qtyUpdateOldTotal: item.qtyUpdateOldTotal, // 数量变更通知中的旧数量总和
        count: item.count,
        deliveryTime: item.deliveryTime,
        toProductionStatus: Number(item.toProductionStatus) || 0,
        currentType: item.currentType || '',
        salesmanName: item.salesmanName || '/',
        productionAssignTime: item.productionAssignTime,
        productionNode: item.productionNode ? (typeof item.productionNode === 'string' ? item.productionNode.split(',') : item.productionNode) : [],
        productionBomId: item.productionBomId || null,
        imageUrls: item.imageUrls ? (typeof item.imageUrls === 'string' ? JSON.parse(item.imageUrls) : item.imageUrls) : [],
        typeOf: item.typeOf || '',
        productCodes: item.productCodes || [],
        width: item.width || '/',
        depth: item.depth || '/',
        height: item.height || '/'
      }))
      productionOrderTotal.value = res.data.total || 0
      syncProductSelectAllByCurrentPage()
    } else {
      productionOrderList.value = []
      productionOrderTotal.value = 0
      isProductSelectAll.value = false
    }
  } catch (error: any) {
    console.error('加载生产单列表失败:', error)
    showError(error?.message || '加载生产单列表失败')
    productionOrderList.value = []
    productionOrderTotal.value = 0
    isProductSelectAll.value = false
  } finally {
    productionOrderLoading.value = false
  }
}

// 生产单 - 图纸
const handleProductionToDesign = (item: any) => {
  const url = `/design-draft/${contractId.value}/product/${item.originId || item.id}/design/see`
  window.open(url, '_blank')
}

// 生产单 - 物控
const handleProductionToMaterialControl = (item: any) => {
  const url = `/contract/materiallist?productCode=${item.originId || item.id}&mode=see&saerchtype=sales`
  window.open(url, '_blank')
}

// 常规材料 - 图纸
const handleProductionManufactureToDesign = (item: any) => {
  const url = `/design-draft/${contractId.value}/product/${item.originId}/design/see`
  window.open(url, '_blank')
}

// 生产单 - 料单
const handleProductionMaterial = (item: any) => {
  const url = `/contract/materiallistProduct?productCode=${item.id}&mode=edit`
  window.open(url, '_blank')
}

// 生产单 - 导出打印（占位，与 factory 一致可后续接入完整导出逻辑）
const handleProductionExportPdf = (item: any) => {
  if (!item.productionBomId) {
    showError('该产品暂无料单数据')
    return
  }
  showError('导出打印功能请至生产单页面操作')
}

// 仓库列表
// const warehouseList = ref<WarehouseItem[]>([])
// const warehouseListOptions = ref<WarehouseItemOptions[]>([
//   { warehouseNo: '上海市闵行区北翟路1630弄51号', warehouseName: '三厂203' },
//   { warehouseNo: '江苏省昆山市盛晞路48号', warehouseName: '昆山一厂' },
//   { warehouseNo: '江苏省昆山市盛晞路28号', warehouseName: '昆山二厂' },
//   { warehouseNo: '江苏省苏州市昆山市昆山开发区三巷路108号', warehouseName: '三号厂房' }
// ])

const warehouseList = ref<WarehouseItemOptions[]>([])
// 格式化仓库名称
const formattedWarehouseList = computed(() => {
  return warehouseList.value.map(warehouse => ({
    ...warehouse,
    warehouseName: `${warehouse.warehouseName}`
  }))
})

// 获取仓库列表
const loadWarehouseList = async () => {
  try {
    const res = await goodsManageApi.getWarehouseList()
    if (res.code === 0) {
      warehouseList.value = res.data || []
    } else {
      warehouseList.value = []
    }
  } catch (error) {
    const err = error as Error
    warehouseList.value = []
  }
}

const loadingPurchaseSummary = ref(false)
const purchaseSummaryList = ref<PurchaseListItem[]>([])

const getStatusWuliaoColor = (status: number) => {
  const colorMap: Record<number, string> = {
    0: 'status-default',
    1: 'status-waiting',
    2: 'status-process',
    3: 'status-success',
    4: 'status-process',
    5: 'status-default',
  }
  return colorMap[status] || 'status-waiting'
}

const getStatusWuliaoText = (status: number) => {
  const option = [
    { value: 0, title: '未转物控' },
    { value: 1, title: '待领取' },
    { value: 2, title: '物控中' },
    { value: 3, title: '已物控' },
    { value: 4, title: '业务拒绝' },
    { value: 5, title: '业务待确认' },
  ].find(opt => opt.value === status)
  return option?.title || '-'
}

/**
 * 格式化数字，解决浮点数精度问题
 * - 最多保留指定小数位数（默认8位）
 * - 自动去除尾部多余的0（如 0.200 → 0.2）
 */
const formatNumberUse = (num: number | string | null | undefined, decimals: number = 4): string => {
  if (num === null || num === undefined || num === '') {
    return ''
  }
  const n = typeof num === 'string' ? parseFloat(num) : num
  if (isNaN(n)) {
    return ''
  }
  return parseFloat(n.toFixed(decimals)).toString()
}

// 获取当前产品的图片索引
const getCurrentImageIndex = (productIndex: number): number => {
  return productImageIndexes.value[productIndex] || 0
}

interface MaterialFileItem {
  id?: number
  url: string
  name: string
}

const showMaterialBookContent = ref(false);
const materialFileList = ref<MaterialFileItem[]>([])
const materialFileStatus = ref(0)
const materialFileAllList = ref<MaterialFileItem[]>([])
const showBook = () => {
  showMaterialBookContent.value = !showMaterialBookContent.value;
}

const previewMaterialBook = (doc: any) => {
  window.open(doc, '_blank')
}

// 物料汇总数据
const mergeProductionBomSummaryItems = ref<any[]>([])
// 按品项汇总数据
const materialSummaryProductList = ref<any[]>([])
const materialSummarySearchType = ref('materialSummaryProduct')

// 获取产品展示名称（按优先级兜底）
const getProductDisplayName = (product: any) => {
  if (!product) return '/'
  return (
    product.nameShort ||
    product.productName ||
    product.name ||
    product.code ||
    '/'
  )
}
// 定制&五金汇总数据（按项目）
const mergeProductionMetalSummaryItems = ref<any[]>([])
// 定制&五金汇总数据（按品项）
const mergeProductionMetalSummaryProductItems = ref<any[]>([])
const metalSummarySearchType = ref('metalSummaryProduct')

const materialproductNamesSummaryOptions = ref<string[]>([])
const materialfinishedComponentNamesSummaryOptions = ref<string[]>([])
const materialpartNamesSummaryOptions = ref<string[]>([])
const materialcomponentNamesSummaryOptions = ref<string[]>([])
const materialmaterialNamesSummaryOptions = ref<string[]>([])
const materialmaterialSpecsSummaryOptions = ref<string[]>([])
const materialmaterialCodesSummaryOptions = ref<string[]>([])
const materialCodeSummaryFilterKeyword = ref('')
const filteredMaterialCodesSummaryOptions = computed(() => {
  if (!materialCodeSummaryFilterKeyword.value) {
    return materialmaterialCodesSummaryOptions.value
  }
  const keyword = materialCodeSummaryFilterKeyword.value.toLowerCase()
  return materialmaterialCodesSummaryOptions.value.filter(option =>
    String(option).toLowerCase().includes(keyword)
  )
})
// 定制&五金汇总筛选项
const metalSummaryPartNamesOptions = ref<string[]>([])
const metalSummaryMaterialNamesOptions = ref<string[]>([])
const metalSummaryMaterialSpecsOptions = ref<string[]>([])
const metalSummaryMetalSpecFilterKeyword = ref('')
const filteredMetalSummaryMetalSpecsOptions = computed(() => {
  if (!metalSummaryMetalSpecFilterKeyword.value) {
    return metalSummaryMaterialSpecsOptions.value
  }
  const keyword = metalSummaryMetalSpecFilterKeyword.value.toLowerCase()
  return metalSummaryMaterialSpecsOptions.value.filter(option =>
    option.toLowerCase().includes(keyword)
  )
})
const metalSummaryBigClassesOptions = ref<string[]>([])
const metalSummarySmallClassesOptions = ref<string[]>([])
const metalSummaryMaterialCodesOptions = ref<string[]>([])
const metalSummaryMaterialCodeFilterKeyword = ref('')
const filteredMetalSummaryMaterialCodesOptions = computed(() => {
  if (!metalSummaryMaterialCodeFilterKeyword.value) {
    return metalSummaryMaterialCodesOptions.value
  }
  const keyword = metalSummaryMaterialCodeFilterKeyword.value.toLowerCase()
  return metalSummaryMaterialCodesOptions.value.filter(option =>
    String(option).toLowerCase().includes(keyword)
  )
})
const materialSpecSummaryFilterKeyword = ref('')
const filteredMaterialSpecsSummaryOptions = computed(() => {
  if (!materialSpecSummaryFilterKeyword.value) {
    return materialmaterialSpecsSummaryOptions.value
  }
  const keyword = materialSpecSummaryFilterKeyword.value.toLowerCase()
  return materialmaterialSpecsSummaryOptions.value.filter(option => 
    option.toLowerCase().includes(keyword)
  )
})
const materialbigClassesSummaryOptions = ref<string[]>([])
const materialsmallClassesSummaryOptions = ref<string[]>([])

// 物料
const mergeProductionBomItems = ref<any[]>([])
const materialproductNamesOptions = ref<string[]>([])
const materialfinishedComponentNamesOptions = ref<string[]>([])
const materialpartNamesOptions = ref<string[]>([])
const materialcomponentNamesOptions = ref<string[]>([])
const materialmaterialNamesOptions = ref<string[]>([])
const materialmaterialSpecsOptions = ref<string[]>([])
const materialSpecFilterKeyword = ref('')
const filteredMaterialSpecsOptions = computed(() => {
  if (!materialSpecFilterKeyword.value) {
    return materialmaterialSpecsOptions.value
  }
  const keyword = materialSpecFilterKeyword.value.toLowerCase()
  return materialmaterialSpecsOptions.value.filter(option => 
    option.toLowerCase().includes(keyword)
  )
})
const materialmaterialCodesOptions = ref<string[]>([])
const materialCodeFilterKeyword = ref('')
const filteredMaterialCodesOptions = computed(() => {
  if (!materialCodeFilterKeyword.value) {
    return materialmaterialCodesOptions.value
  }
  const keyword = materialCodeFilterKeyword.value.toLowerCase()
  return materialmaterialCodesOptions.value.filter(option =>
    String(option).toLowerCase().includes(keyword)
  )
})
const materialbigClassesOptions = ref<string[]>([])
const materialsmallClassesOptions = ref<string[]>([])
// 五金
const mergeProductionWareMetalItems = ref<any[]>([])
const metalproductNamesOptions = ref<string[]>([])
const metalfinishedComponentNamesOptions = ref<string[]>([])
const metalpartNamesOptions = ref<string[]>([])
const metalcomponentNamesOptions = ref<string[]>([])
const metalmaterialNamesOptions = ref<string[]>([])
const metalmaterialSpecsOptions = ref<string[]>([])
const metalSpecFilterKeyword = ref('')
const filteredMetalSpecsOptions = computed(() => {
  if (!metalSpecFilterKeyword.value) {
    return metalmaterialSpecsOptions.value
  }
  const keyword = metalSpecFilterKeyword.value.toLowerCase()
  return metalmaterialSpecsOptions.value.filter(option => 
    option.toLowerCase().includes(keyword)
  )
})
const metalmaterialCodesOptions = ref<string[]>([])
const metalMaterialCodeFilterKeyword = ref('')
const filteredMetalMaterialCodesOptions = computed(() => {
  if (!metalMaterialCodeFilterKeyword.value) {
    return metalmaterialCodesOptions.value
  }
  const keyword = metalMaterialCodeFilterKeyword.value.toLowerCase()
  return metalmaterialCodesOptions.value.filter(option =>
    String(option).toLowerCase().includes(keyword)
  )
})
const metalbigClassesOptions = ref<string[]>([])
const metalsmallClassesOptions = ref<string[]>([])

// 常规材料分页
const materialPagination = ref({
  page: 1,
  pageSize: 20,
  total: 0
})

// 常规材料汇总分页
const materialSummaryPagination = ref({
  page: 1,
  pageSize: 20,
  total: 0
})

// 定制&五金分页
const metalPagination = ref({
  page: 1,
  pageSize: 20,
  total: 0
})

// 定制&五金汇总分页
const metalSummaryPagination = ref({
  page: 1,
  pageSize: 20,
  total: 0
})

// 常规材料分页页数计算
const materialTotalPages = computed(() => {
  return Math.ceil(materialPagination.value.total / materialPagination.value.pageSize) || 1
})

// 常规材料汇总分页页数计算
const materialSummaryTotalPages = computed(() => {
  return Math.ceil(materialSummaryPagination.value.total / materialSummaryPagination.value.pageSize) || 1
})

// 定制&五金分页页数计算
const metalTotalPages = computed(() => {
  return Math.ceil(metalPagination.value.total / metalPagination.value.pageSize) || 1
})

// 定制&五金汇总分页页数计算
const metalSummaryTotalPages = computed(() => {
  return Math.ceil(metalSummaryPagination.value.total / metalSummaryPagination.value.pageSize) || 1
})

// 常规材料筛选表单（明细）
interface MaterialSearchForm {
  productName: string[]
  finishedComponentName: string[]
  componentName: string[]
  partName: string[]
  materialName: string[]
  materialSpec: string[]
  materialCode: string[]
  bigClass: string[]
  smallClass: string[]
}

// 常规材料汇总筛选表单（新的，避免复用明细字段）
interface MaterialSummarySearchForm {
  productName: string[]
  materialName: string[]
  materialSpec: string[]
  materialCode: string[]
  bigClass: string[]
  smallClass: string[]
}

// 定制&五金汇总筛选表单
interface MetalSummarySearchForm {
  productName: string[]
  partName: string[]
  materialName: string[]
  materialSpec: string[]
  materialCode: string[]
  bigClass: string[]
  smallClass: string[]
}

// 定制&五金筛选表单
interface MetalSearchForm {
  productName: string[]
  finishedComponentName: string[]
  componentName: string[]
  partName: string[]
  materialName: string[]
  materialSpec: string[]
  materialCode: string[]
  bigClass: string[]
  smallClass: string[]
}

// 常规材料筛选表单（明细）
const materialSearchForm = ref<MaterialSearchForm>({
  productName: [],
  finishedComponentName: [],
  componentName: [],
  partName: [],
  materialName: [],
  materialSpec: [],
  materialCode: [],
  bigClass: [],
  smallClass: []
})

// 常规材料汇总筛选表单
const materialSummarySearchForm = ref<MaterialSummarySearchForm>({
  productName: [],
  materialName: [],
  materialSpec: [],
  materialCode: [],
  bigClass: [],
  smallClass: []
})

// 定制&五金汇总筛选表单
const metalSummarySearchForm = ref<MetalSummarySearchForm>({
  productName: [],
  partName: [],
  materialName: [],
  materialSpec: [],
  materialCode: [],
  bigClass: [],
  smallClass: []
})

// 定制&五金筛选表单
const metalSearchForm = ref<MetalSearchForm>({
  productName: [],
  finishedComponentName: [],
  componentName: [],
  partName: [],
  materialName: [],
  materialSpec: [],
  materialCode: [],
  bigClass: [],
  smallClass: []
})

// 常规材料筛选搜索（明细）
const handleMaterialSearch = () => {
  materialPagination.value.page = 1  // 搜索时重置到第一页
  mergeProductionBomItems.value = []
  resetMaterialSummary()
  loadMaterialSummary()
}

// 常规材料汇总筛选搜索
const handleMaterialSummarySearch = () => {
  materialSummaryPagination.value.page = 1
  mergeProductionBomSummaryItems.value = []
  materialSummaryProductList.value = []
  resetMaterialSummary()
  loadMaterialSummaryMerge()
}

// 处理常规材料筛选复选框变化（明细）
const handleCheckboxChange = (field: keyof MaterialSearchForm, value: string, checked: any) => {
  const arr = materialSearchForm.value[field]
  if (checked) {
    if (!arr.includes(value)) {
      arr.push(value)
    }
  } else {
    const index = arr.indexOf(value)
    if (index > -1) {
      arr.splice(index, 1)
    }
  }
  handleMaterialSearch()
}

// 处理常规材料汇总筛选复选框变化
const handleSummaryCheckboxChange = (field: keyof MaterialSummarySearchForm, value: string, checked: any) => {
  const arr = materialSummarySearchForm.value[field]
  if (checked) {
    if (!arr.includes(value)) {
      arr.push(value)
    }
  } else {
    const index = arr.indexOf(value)
    if (index > -1) {
      arr.splice(index, 1)
    }
  }
  handleMaterialSummarySearch()
}

// 定制&五金汇总筛选搜索
const handleMetalSummarySearch = () => {
  metalSummaryPagination.value.page = 1
  mergeProductionMetalSummaryItems.value = []
  mergeProductionMetalSummaryProductItems.value = []
  loadMetalSummaryMerge()
}

// 处理定制&五金汇总筛选复选框变化
const handleMetalSummaryCheckboxChange = (field: keyof MetalSummarySearchForm, value: string, checked: any) => {
  const arr = metalSummarySearchForm.value[field]
  if (checked) {
    if (!arr.includes(value)) {
      arr.push(value)
    }
  } else {
    const index = arr.indexOf(value)
    if (index > -1) {
      arr.splice(index, 1)
    }
  }
  handleMetalSummarySearch()
}

// 移除筛选标签
const removeFilterTag = (field: keyof MaterialSearchForm, value: string) => {
  const arr = materialSearchForm.value[field]
  const index = arr.indexOf(value)
  if (index > -1) {
    arr.splice(index, 1)
  }
  handleMaterialSearch()
}

// 常规材料分页切换
const handleMaterialPageChange = (newPage: number) => {
  materialPagination.value.page = newPage
  mergeProductionBomItems.value = []
  resetMaterialSummary()
  loadMaterialSummary()
}

// 常规材料汇总分页切换
const handleMaterialSummaryPageChange = (newPage: number) => {
  materialSummaryPagination.value.page = newPage
  materialSummaryProductList.value = []
  loadMaterialSummaryMerge()
}

// 定制&五金筛选搜索
const handleMetalSearch = () => {
  metalPagination.value.page = 1  // 搜索时重置到第一页
  mergeProductionWareMetalItems.value = []
  resetMaterialSummary()
  loadMaterialSummaryHardware()
}

// 处理五金筛选复选框变化
const handleMetalCheckboxChange = (field: keyof MetalSearchForm, value: string, checked: any) => {
  const arr = metalSearchForm.value[field]
  if (checked) {
    if (!arr.includes(value)) {
      arr.push(value)
    }
  } else {
    const index = arr.indexOf(value)
    if (index > -1) {
      arr.splice(index, 1)
    }
  }
  handleMetalSearch()
}

// 移除五金筛选标签
const removeMetalFilterTag = (field: keyof MetalSearchForm, value: string) => {
  const arr = metalSearchForm.value[field]
  const index = arr.indexOf(value)
  if (index > -1) {
    arr.splice(index, 1)
  }
  handleMetalSearch()
}

// 定制&五金分页切换
const handleMetalPageChange = (newPage: number) => {
  metalPagination.value.page = newPage
  mergeProductionWareMetalItems.value = []
  resetMaterialSummary()
  loadMaterialSummaryHardware()
}

// 定制&五金汇总分页切换
const handleMetalSummaryPageChange = (newPage: number) => {
  metalSummaryPagination.value.page = newPage
  mergeProductionMetalSummaryProductItems.value = []
  loadMetalSummaryMerge()
}

// 添加自定义物料
const showAddCustomMaterialDialog = ref(false)
const customMaterialImageUrls = ref<{ url: string; name: string }[]>([])
const customMaterialName = ref('')
const customMaterialSpecDesc = ref('')
const customMaterialBigClass = ref('')
const customMaterialType = ref('')
const customMaterialPrice = ref(null)
const showUploadDialog = ref(false)
const uploadType = ref('')
const addResultContent = ref('')
const addResultErrorContent = ref('')

const editMaterialIndex = ref(-1)
const oldEditMaterialIndex = ref(-1)
// 切换到上一张图片
const prevImage = (productIndex: number) => {
  const currentIndex = getCurrentImageIndex(productIndex)
  if (currentIndex > 0) {
    productImageIndexes.value[productIndex] = currentIndex - 1
  }
}

// 切换到下一张图片
const nextImage = (productIndex: number) => {
  const currentIndex = getCurrentImageIndex(productIndex)
  const product = productInfo.value.productImageUrls
  if (product && product.length > 0 && currentIndex < product.length - 1) {
    productImageIndexes.value[productIndex] = currentIndex + 1
  }
}

// 重置产品图片索引
const resetProductImageIndex = (productIndex: number) => {
  productImageIndexes.value[productIndex] = 0
}

// 放大图片和行高
const zoomIn = (productIndex: number) => {
  zoomedRows.value[productIndex] = true
  zoomLevel.value = 2
}

// 缩小图片和行高
const zoomOut = (productIndex: number) => {
  delete zoomedRows.value[productIndex]
  zoomLevel.value = 1
}

// 检查行是否被放大
const isRowZoomed = (productIndex: number): boolean => {
  return !!zoomedRows.value[productIndex]
}

// 删除物料图片
const handleDeleteMaterialImage = (parentIndex: number, imageIndex: number) => {
  console.log('删除物料图片', parentIndex, imageIndex)
  // 调用通用的删除图片方法
  handleDeleteImage(parentIndex, imageIndex, 'wuliao')
}

// 物料图相关的放大缩小方法
const getCurrentMaterialImageIndex = (materialIndex: number): number => {
  return materialImageIndexes.value[materialIndex] || 0
}

const updateMaterialImageIndex = (materialIndex: number, imageIndex: number) => {
  materialImageIndexes.value[materialIndex] = imageIndex
}

// 放大物料图片和行高
const zoomMaterialIn = (materialIndex: number) => {
  materialZoomedRows.value[materialIndex] = true
  materialZoomLevel.value = 2
}

// 缩小物料图片和行高
const zoomMaterialOut = (materialIndex: number) => {
  delete materialZoomedRows.value[materialIndex]
  materialZoomLevel.value = 1
}

// 检查物料行是否被放大
const isMaterialRowZoomed = (materialIndex: number): boolean => {
  return !!materialZoomedRows.value[materialIndex]
}

// // 获取当前物料的图片索引
// const getCurrentMaterialImageIndex = (materialIndex: number): number => {
//   if (!materialImageIndexes.value || typeof materialImageIndexes.value !== 'object') {
//     console.warn('materialImageIndexes.value is undefined, reinitializing...');
//     materialImageIndexes.value = {};
//   }
//   return materialImageIndexes.value[materialIndex] || 0
// }

// 切换到上一张物料图片
const prevMaterialImage = (materialIndex: number) => {
  const currentIndex = getCurrentMaterialImageIndex(materialIndex)
  if (currentIndex > 0) {
    if (!materialImageIndexes.value || typeof materialImageIndexes.value !== 'object') {
      materialImageIndexes.value = {};
    }
    materialImageIndexes.value[materialIndex] = currentIndex - 1
  }
}

// 切换到下一张物料图片
const nextMaterialImage = (materialIndex: number) => {
  const currentIndex = getCurrentMaterialImageIndex(materialIndex)
  const material = materialList.value[materialIndex]
  if (material?.images && material.images.length > 0 && currentIndex < material.images.length - 1) {
    if (!materialImageIndexes.value || typeof materialImageIndexes.value !== 'object') {
      materialImageIndexes.value = {};
    }
    materialImageIndexes.value[materialIndex] = currentIndex + 1
  }
}

// 重置物料图片索引
const resetMaterialImageIndex = (materialIndex: number) => {
  if (!materialImageIndexes.value || typeof materialImageIndexes.value !== 'object') {
    materialImageIndexes.value = {};
  }
  materialImageIndexes.value[materialIndex] = 0
}

// 产品信息表头
const productHeaders = [
  { title: '产品图', key: 'imageUrls', align: 'center', minWidth: '120px' },
  { title: '产品信息', key: 'info', align: 'center', minWidth: '115px' },
  { title: '尺寸', key: 'size', align: 'center', minWidth: '60px' },
  { title: '估价', key: 'evaluate', align: 'center', minWidth: '90px' },
  { title: '估价明细', key: 'evaluateDetail', align: 'center', minWidth: '788px' },
  { title: '估价备注', key: 'description', align: 'center', minWidth: '165px' }
]

// 估价明细表头
const priceHeaders = [
  { title: '成本估价', key: 'cost', align: 'center', minWidth: '110px' },
  { title: '材料估价', key: 'materialTotal', align: 'center', minWidth: '110px' },
  { title: '调整系数', key: 'adjustment', align: 'center', minWidth: '70px' },
  { title: '基材', key: 'baseMaterial', align: 'center', minWidth: '70px' },
  { title: '油漆', key: 'paint', align: 'center', minWidth: '70px' },
  { title: '差价', key: 'difference', align: 'center', minWidth: '70px' },
  { title: '小五金', key: 'smallHardware', align: 'center', minWidth: '70px' },
  { title: '玻璃', key: 'glass', align: 'center', minWidth: '70px' },
  { title: '石材', key: 'stone', align: 'center', minWidth: '70px' },
  { title: '面料', key: 'fabric', align: 'center', minWidth: '70px' },
  { title: '外购件', key: 'purchase', align: 'center', minWidth: '70px' },
  { title: '大五金', key: 'bigHardware', align: 'center', minWidth: '70px' },
  { title: '运费', key: 'freight', align: 'center', minWidth: '110px' },
  { title: '安装费', key: 'installationFee', align: 'center', minWidth: '70px' },
  { title: '面料用量', key: 'fabricUsage', align: 'center', minWidth: '70px' },
  { title: '人工', key: 'labor', align: 'center', minWidth: '110px' },
  { title: '制费', key: 'labor', align: 'center', minWidth: '110px' },
  { title: '利润', key: 'profit', align: 'center', minWidth: '110px' },
  { title: '税费', key: 'tax', align: 'center', minWidth: '110px' }
]

// 物料清单表头
const materialListHeaders = [
  { title: '序号', key: 'sequenceNo', align: 'center', minWidth: '50', filterable: false },
  { title: '包装序号', key: 'packageNo', align: 'center', minWidth: '70', filterable: false },
  { title: '成品组件', key: 'finishedComponentName', align: 'left', minWidth: '90', filterable: true },
  { title: '组件', key: 'componentName', align: 'left', minWidth: '70', filterable: true },
  { title: '零件', key: 'partName', align: 'left', minWidth: '60', filterable: false },
  { title: '材料', key: 'materialName', align: 'left', minWidth: '150', filterable: false },
  { title: '尺寸', key: 'size', align: 'left', minWidth: '60', filterable: false },
  { title: '数量', key: 'count', align: 'left', minWidth: '60', filterable: false },
  { title: '弯', key: 'bend', align: 'left', minWidth: '40', filterable: false },
  { title: '正面饰面', key: 'frontFinish', align: 'left', minWidth: '150', filterable: false },
  { title: '反面饰面', key: 'backFinish', align: 'left', minWidth: '150', filterable: false },
  { title: '封边条', key: 'edgeMaterial', align: 'left', minWidth: '100', filterable: false },
  { title: '备注', key: 'remark', align: 'left', minWidth: '100', filterable: false },
  { title: '油漆', key: 'paintMethod', align: 'left', minWidth: '100', filterable: false }
]

// 物料汇总表头
// const materialSummarizeHeaders = [
//   { title: '', key: 'sequenceNo', align: 'center', minWidth: '20', filterable: false },
//   { title: '物料', key: 'name', align: 'left', minWidth: '200', filterable: false },
//   { title: '大类', key: 'bigClass', align: 'center', minWidth: '110', filterable: true },
//   { title: '小类', key: 'type', align: 'center', minWidth: '110', filterable: true },
//   // { title: '数量', key: 'totalQuantity', align: 'center', minWidth: '110', filterable: false },
//   { title: '项目总用量', key: 'count', align: 'center', minWidth: '110', filterable: false },
//   { title: '库存', key: 'stock', align: 'center', minWidth: '110', filterable: false },
//   { title: '已采购', key: 'purchased', align: 'center', minWidth: '110', filterable: false },
//   { title: '操作', key: 'actions', align: 'center', minWidth: '110', filterable: false }
// ]
  // 常规材料表头
  const projectMaterialHeaders = [
    { title: '', key: 'nothing', align: 'center', minWidth: '10' },
    { title: '产品', key: 'productName', align: 'left',minWidth: '115' },
    { title: '序号', key: 'sequenceNo', align: 'center',minWidth: '70' },
    { title: '成品组件', key: 'finishedComponentName', align: 'center',minWidth: '80' },
    { title: '组件', key: 'componentName', align: 'center',minWidth: '80' },
    { title: '零件', key: 'partName', align: 'center',minWidth: '80' },
    { title: '物料名称', key: 'materialName', align: 'center',minWidth: '120' },
    { title: '物料规格', key: 'materialSpec', align: 'center',minWidth: '120' },
    { title: '物料编号', key: 'materialCode', align: 'center',minWidth: '120' },
    { title: '尺寸', key: 'width', align: 'center',minWidth: '120' },
    { title: '数量', key: 'quantity', align: 'center',minWidth: '80' },
    { title: '备注', key: 'remark', align: 'center',minWidth: '120' },
    { title: '大类', key: 'bigClass', align: 'center',minWidth: '120' },
    { title: '小类', key: 'smallClass', align: 'center',minWidth: '120' },
    { title: '单件用量', key: 'materialUsage', align: 'center',minWidth: '120' },
    { title: '总用量', key: 'totalUsage', align: 'center',minWidth: '120' },
    { title: '操作', key: 'actions', align: 'center', minWidth: '90' }
  ]

  // 常规材料汇总表头（按项目）
  const projectMaterialSummaryHeaders = [
    { title: '', key: 'nothing', align: 'center', minWidth: '10' },
    { title: '物料名称', key: 'materialName', align: 'center',minWidth: '120' },
    { title: '物料规格', key: 'materialSpec', align: 'center',minWidth: '120' },
    { title: '物料编号', key: 'materialCode', align: 'center',minWidth: '120' },
    { title: '大类', key: 'bigClass', align: 'center',minWidth: '120' },
    { title: '小类', key: 'smallClass', align: 'center',minWidth: '120' },
    { title: '用量', key: 'factoryUsageMap', align: 'center',minWidth: '120' },
    { title: '总用量', key: 'totalUsage', align: 'center',minWidth: '120' },
    { title: '关联采购', key: 'purchaseNum', align: 'center',minWidth: '120' },
    { title: '操作', key: 'actions', align: 'center', minWidth: '90' }
  ]
  
  // 常规材料汇总表头（按品项）
  const projectMaterialSummaryProductHeaders = [
    { title: '产品图', key: 'productImage', align: 'center', minWidth: '100' },
    { title: '产品', key: 'product', align: 'left', minWidth: '160' },
    // { title: '零件', key: 'partName', align: 'center', minWidth: '80' },
    { title: '物料名称', key: 'materialName', align: 'center', minWidth: '150' },
    { title: '物料规格', key: 'materialSpec', align: 'center', minWidth: '150' },
    { title: '物料编号', key: 'materialCode', align: 'center', minWidth: '150' },
    { title: '大类', key: 'bigClass', align: 'center', minWidth: '90' },
    { title: '小类', key: 'smallClass', align: 'center', minWidth: '90' },
    // { title: '用量', key: 'factoryUsageMap', align: 'center', minWidth: '120' },
    { title: '单件用量', key: 'totalUsage', align: 'center', minWidth: '150' },
    { title: '总用量', key: 'productTotalUsage', align: 'center', minWidth: '150' },
    { title: '关联采购', key: 'purchaseNum', align: 'center', minWidth: '90' },
    { title: '操作', key: 'actions', align: 'center', minWidth: '90' }
  ]
  
  // 定制&五金表头
  const projectFiveMetalHeaders = [
    { title: '', key: 'nothing', align: 'center', minWidth: '10' },
    { title: '产品', key: 'productName', align: 'left',minWidth: '115' },
    { title: '序号', key: 'sequenceNo', align: 'center',minWidth: '70' },
    { title: '成品组件', key: 'finishedComponentName', align: 'center',minWidth: '80' },
    { title: '组件', key: 'componentName', align: 'center',minWidth: '80' },
    { title: '零件', key: 'partName', align: 'center',minWidth: '80' },
    { title: '物料名称', key: 'materialName', align: 'center',minWidth: '120' },
    { title: '物料规格', key: 'materialSpec', align: 'center',minWidth: '120' },
    { title: '物料编号', key: 'materialCode', align: 'center',minWidth: '120' },
    { title: '尺寸', key: 'width', align: 'center',minWidth: '120' },
    { title: '数量', key: 'quantity', align: 'center',minWidth: '80' },
    { title: '备注', key: 'remark', align: 'center',minWidth: '120' },
    { title: '大类', key: 'bigClass', align: 'center',minWidth: '120' },
    { title: '小类', key: 'smallClass', align: 'center',minWidth: '120' },
    { title: '单件用量', key: 'materialUsage', align: 'center',minWidth: '120' },
    { title: '总用量', key: 'totalUsage', align: 'center',minWidth: '120' },
    { title: '操作', key: 'actions', align: 'center', minWidth: '90' }
  ]

  // 定制&五金汇总表头（按项目）
  const projectFiveMetalSummaryHeaders = [
    { title: '', key: 'nothing', align: 'center', minWidth: '10' },
    { title: '零件', key: 'partName', align: 'center',minWidth: '80' },
    { title: '物料名称', key: 'materialName', align: 'center',minWidth: '120' },
    { title: '物料规格', key: 'materialSpec', align: 'center',minWidth: '120' },
    { title: '物料编号', key: 'materialCode', align: 'center',minWidth: '120' },
    { title: '尺寸', key: 'width', align: 'center',minWidth: '120' },
    { title: '备注', key: 'remark', align: 'center',minWidth: '80' },
    { title: '大类', key: 'bigClass', align: 'center',minWidth: '80' },
    { title: '小类', key: 'smallClass', align: 'center',minWidth: '80' },
    { title: '用量', key: 'factoryUsageMap', align: 'center',minWidth: '120' },
    { title: '总用量', key: 'totalUsage', align: 'center',minWidth: '120' },
    { title: '关联采购', key: 'purchaseNum', align: 'center',minWidth: '120' },
    { title: '操作', key: 'actions', align: 'center', minWidth: '90' }
  ]

  // 定制&五金汇总表头（按品项）
  const projectFiveMetalSummaryProductHeaders = [
    { title: '产品图', key: 'productImage', align: 'center', minWidth: '100' },
    { title: '产品', key: 'product', align: 'left', minWidth: '100' },
    { title: '零件', key: 'partName', align: 'center',minWidth: '80' },
    { title: '物料名称', key: 'materialName', align: 'center',minWidth: '120' },
    { title: '物料规格', key: 'materialSpec', align: 'center',minWidth: '120' },
    { title: '物料编号', key: 'materialCode', align: 'center',minWidth: '120' },
    { title: '尺寸', key: 'width', align: 'center',minWidth: '100' },
    { title: '备注', key: 'remark', align: 'center',minWidth: '80' },
    { title: '大类', key: 'bigClass', align: 'center',minWidth: '80' },
    { title: '小类', key: 'smallClass', align: 'center',minWidth: '80' },
    // { title: '用量', key: 'factoryUsageMap', align: 'center',minWidth: '120' },
    { title: '单件用量', key: 'totalUsage', align: 'center',minWidth: '80' },
    { title: '总用量', key: 'productTotalUsage', align: 'center',minWidth: '80' },
    { title: '关联采购', key: 'purchaseNum', align: 'center',minWidth: '80' },
    { title: '操作', key: 'actions', align: 'center', minWidth: '90' }
  ]
// 估价表头
const materialHeaders = [
  { title: '物料参考', key: 'materialImageUrls', align: 'center', minWidth: '100px' },
  // { title: '', key: 'nothing', align: 'center', minWidth: '14px', filterable: false },
  { title: '物料', key: 'materialName', align: 'left', minWidth: '150px' },
  { title: '物料描述', key: 'materialDescription', align: 'left', minWidth: '150px' },
  // { title: '物控状态', key: 'wuliaoStatus', align: 'center', minWidth: '80px' },
  { title: '大类', key: 'bigClass', align: 'center', minWidth: '60px', filterable: true },
  { title: '小类', key: 'materialType', align: 'center', minWidth: '60px', filterable: true },
  { title: '物料编号', key: 'materialCustomerNo', align: 'center', minWidth: '110px' },
  // { title: '数量', key: 'materialCount', align: 'center', minWidth: '60px' },
  // { title: '单价', key: 'materialPrice', align: 'center', minWidth: '60px' },
  // { title: '单位', key: 'materialUnit', align: 'center', minWidth: '60px' },
  // { title: '总价', key: 'materialTotal', align: 'center', minWidth: '70px' },
  // { title: '库存', key: 'stock', align: 'center', minWidth: '70px' },
  // { title: '已采购', key: 'purchased', align: 'center', minWidth: '70px' },
  { title: '物控状态', key: 'wuliaoStatus', align: 'center', minWidth: '110px' },
  { title: '物控传图', key: 'materialImageUrlsConfirmed', align: 'center', minWidth: '100px' },
  // { title: '物控员', key: 'wuliaoName', align: 'center', minWidth: '70px' },
  { title: '物控备注', key: 'wuliaoRemark', align: 'center', minWidth: '120px' },
  { title: '操作', key: 'actions', align: 'center', minWidth: '80px' },
]


// 采购单表头
const purchaseSummaryHeaders = [
  { title: '采购单号', align: 'start', key: 'purchaseOrderNo', width: '90px' },
  { title: '关联项目', align: 'start', key: 'projectName', width: '100px' },
  // { title: '采购类型', align: 'center', key: 'purchaseType', width: '90px' },
  { title: '供应商', align: 'start', key: 'supplierName', width: '190px' },
  { title: '付款公司', align: 'start', key: 'paymentCompany', width: '70px' },
  // { title: '税率', align: 'center', key: 'taxRate', width: '55px' },
  // { title: '税额', align: 'center', key: 'taxAmount', width: '85px' },
  // { title: '合计金额', align: 'center', key: 'totalAmount', width: '90px' },
  { title: '含税总金额', align: 'center', key: 'totalAmountWithTax', width: '100px' },
  { title: '付款类型', align: 'center', key: 'paymentType', width: '90px' },
  // { title: '采购标准', align: 'center', key: 'purchaseStandard', width: '180px' },
  { title: '收货仓库', align: 'center', key: 'warehouseName', width: '100px' },
  { title: '下单人', align: 'center', key: 'createUserName', width: '65px' },
  { title: '已付', align: 'center', key: 'paidAmount', width: '90px' },
  { title: '操作', align: 'center', key: 'actions', width: '150px' }
]

const page = ref(1)
const pageSize = ref(20)

const unitOptions = ref<any[]>([])
// 物料列表数据
const materialList = ref<MaterialItem[]>([])
// 物料清单
const materialBomList = ref<MaterialBomItem[]>([])
const materialAllBomList = ref<MaterialBomItem[]>([])
// 常规材料
const loadingMaterialSummary = ref(false)
const materialSummaryList = ref<MaterialItem[]>([])
// 定制&五金
const loadingMaterialSummaryHardware = ref(false)
const materialSummaryHardwareList = ref<MaterialItem[]>([])
// 定制&五金汇总
const loadingMetalSummary = ref(false)
// 物控汇总
const loadingMaterialControlSummary = ref(false)
const materialControlSummaryList = ref<MaterialItem[]>([])
const materialAllSummaryList = ref<MaterialItem[]>([])

// 物料分页数据
const pagination = ref({
  page: 1,
  pageSize: 20,
  total: 0
})

// 物料清单筛选器
const finishedComponentFilter = ref(null)
const componentFilter = ref(null)

const finishedComponentOptions = ref<string[]>([])
const componentOptions = ref<string[]>([])

// 物控汇总筛选
const materialTypePriceFilter = ref(null)
const bigClassPriceFilter = ref(null)
const materialTypePriceOptions = ref<string[]>([])
const bigClassPriceOptions = ref<string[]>([])

// 物料汇总筛选器
const kindFilter = ref(null)
const bigClassFilter = ref(null)
const typeFilter = ref(null)
const bigClassSummaryOptions = ref<string[]>([])
const smallClassSummaryOptions = ref<string[]>([])

// 定制&五金筛选器
const bigClassHardwareFilter = ref(null)
const typeHardwareFilter = ref(null)
const bigClassSummaryHardwareOptions = ref<string[]>([])
const smallClassSummaryHardwareOptions = ref<string[]>([])

const contractId = ref(0)
const statusPricing = ref(0)
const isCanEdit = ref(true)

const fileInput = ref<HTMLInputElement | null>(null)

const getPaymentMethod = (paymentType: string) => {
  let paymentMethod = {
    value: paymentType,
    label: Number(paymentType) === 0 ? '预付' : Number(paymentType) === 1 ? '现付' : Number(paymentType) === 2 ? '月结' : Number(paymentType) === 3 ? '次月结' : ''
  }
  return paymentMethod
}

const getRateValue = (rate: string) => {
  return rate.replace('%', '')
}
// 处理时间
const formatYMDate = (date: string | number) => {
  if (!date) return '/'
  const d = new Date(date)
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  const hours = String(d.getHours()).padStart(2, '0')
  const minutes = String(d.getMinutes()).padStart(2, '0')
  return `${year}/${month}/${day}`
}

// 估价
// const handleSeeMaterial = (item: any, index: number) => {
//   let url = `/contract/MaterialSummaryDetail?productCode=${item.id}&mode=see`
//   window.open(url, '_blank')
// }
const handleSeeMaterial = (item: any, index: number) => {
  let url = `/contract/materialcontrollist?productCode=${item.id}&mode=see`
  window.open(url, '_blank')
}

// 料单
const handleSeeBomMaterial = (item: any, index: number) => {
  let url = `/contract/BomMaterialSummaryDetail?contractId=${contractId.value}&materialCode=${item.materialCode}&mode=see`
  window.open(url, '_blank')
}

const handleSeePurchase = (item: any) => {
  let url = `/purchase/detail/${item.id}/purchase`
  window.open(url, '_blank')
}

const handleSeeMaterialPurchaseList = (item: any, type: 'material' | 'hardware', groupByProduct?: number) => {
  const contractIdParam = contractId.value
  const bomKey = item.bomKey
  const jinshu = type === 'hardware' ? 1 : 0
  const url = `/contract/materialPurchaseList?contractId=${contractIdParam}&bomKey=${encodeURIComponent(
    bomKey ?? ''
  )}&jinshu=${jinshu}${
    groupByProduct !== undefined ? `&groupByProduct=${groupByProduct}` : ''
  }`
  window.open(url, '_blank')
}

// 使用html2canvas将中文文本渲染为图片并添加到PDF
// 返回文本宽度（mm）
const addChineseTextAsImage = async (
  pdf: jsPDF,
  text: string,
  x: number,
  y: number,
  fontSize: number,
  color: [number, number, number],
  fontWeight: 'normal' | 'bold' = 'normal',
  align: 'left' | 'center' | 'right' = 'left'
): Promise<number> => {
  // 创建临时div元素
  const tempDiv = document.createElement('div')
  tempDiv.style.position = 'absolute'
  tempDiv.style.left = '-9999px'
  tempDiv.style.top = '-9999px'
  tempDiv.style.fontSize = `${fontSize}px`
  tempDiv.style.fontWeight = fontWeight
  tempDiv.style.color = `rgb(${color[0]}, ${color[1]}, ${color[2]})`
  tempDiv.style.fontFamily = 'Arial, "Microsoft YaHei", "SimHei", sans-serif'
  tempDiv.style.whiteSpace = 'nowrap'
  tempDiv.style.lineHeight = '1.4'
  tempDiv.style.padding = '0'
  tempDiv.style.margin = '0'
  tempDiv.textContent = text
  document.body.appendChild(tempDiv)
  
  try {
    // 等待DOM更新
    await nextTick()
    
    // 使用html2canvas渲染，scale根据字体大小调整
    const scale = fontSize >= 12 ? 2 : 3 // 小字体使用更高的scale保证清晰度
    const canvas = await html2canvas(tempDiv, {
      backgroundColor: null,
      scale: scale,
      logging: false,
      useCORS: true,
      width: tempDiv.offsetWidth || tempDiv.scrollWidth,
      height: tempDiv.offsetHeight || tempDiv.scrollHeight
    })
    
    // 转换为图片数据
    const imgData = canvas.toDataURL('image/png')
    
    // 计算图片尺寸（mm）- 需要考虑scale
    // 1mm = 3.779527559px (96 DPI), 但html2canvas的scale会影响实际尺寸
    const pxToMm = 0.264583 // 1px = 0.264583mm (96 DPI)
    const imgWidth = (canvas.width / scale) * pxToMm
    const imgHeight = (canvas.height / scale) * pxToMm
    
    // 根据对齐方式调整x坐标
    let adjustedX = x
    if (align === 'center') {
      adjustedX = x - imgWidth / 2
    } else if (align === 'right') {
      adjustedX = x - imgWidth
    }
    
    // 添加到PDF
    pdf.addImage(imgData, 'PNG', adjustedX, y - imgHeight, imgWidth, imgHeight)
    
    // 返回文本宽度
    return imgWidth
  } catch (error) {
    console.error('渲染中文文本失败:', error)
    // 降级方案：使用英文或数字
    pdf.setFontSize(fontSize)
    pdf.setFont('helvetica', fontWeight)
    pdf.setTextColor(color[0], color[1], color[2])
    pdf.text(text.replace(/[^\x00-\x7F]/g, '?'), x, y, { align })
    
    // 估算宽度（使用jsPDF的getTextWidth方法）
    const estimatedWidth = pdf.getTextWidth(text.replace(/[^\x00-\x7F]/g, '?')) * (fontSize / pdf.getFontSize())
    return estimatedWidth
  } finally {
    // 清理临时元素
    if (document.body.contains(tempDiv)) {
      document.body.removeChild(tempDiv)
    }
  }
}

// 导出PDF
const handleExportPdf = async (item: any) => {
  try {
    showCommonLoading.value = true
    commonLoadingText.value = '正在导出PDF...'
    
    // 获取采购单详情
    const response = await purchaseApi.getPurchaseDetail(item.id)
    
    if (response.code !== 0 || !response.data) {
      showError('获取采购单详情失败')
      return
    }
    
    const purchaseDetail = response.data.order
    const itemList = response.data.itemList || []
    
    // 创建PDF，设置编码为UTF-8，横向A4
    const pdf = new jsPDF('landscape', 'mm', 'a4')
    
    // 设置字体编码支持中文
    pdf.setLanguage('zh-CN')
    
    const pageWidth = pdf.internal.pageSize.getWidth()
    const pageHeight = pdf.internal.pageSize.getHeight()
    
    // 设置颜色
    const redColor: [number, number, number] = [210, 71, 93] // #D2475D
    const lightRedColor: [number, number, number] = [255, 240, 242] // 浅红色背景
    const textColor: [number, number, number] = [0, 0, 0]
    const grayTextColor: [number, number, number] = [137, 137, 137] // #898989
    
    // 加载顶部背景图片
    const topBgHeight = 50 // 顶部背景高度（mm）
    const loadTopBgImage = (): Promise<{ data: string; width: number; height: number }> => {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.crossOrigin = 'anonymous'
        img.onload = () => {
          const canvas = document.createElement('canvas')
          canvas.width = img.width
          canvas.height = img.height
          const ctx = canvas.getContext('2d')
          if (ctx) {
            ctx.drawImage(img, 0, 0)
            resolve({
              data: canvas.toDataURL('image/png'),
              width: img.width,
              height: img.height
            })
          } else {
            reject(new Error('无法创建canvas上下文'))
          }
        }
        img.onerror = () => reject(new Error('加载顶部背景图片失败'))
        img.src = pdfTop
      })
    }
    
    // 添加顶部背景图片
    try {
      const topBg = await loadTopBgImage()
      // 计算图片尺寸以适应页面宽度，保持宽高比
      const imgAspectRatio = topBg.width / topBg.height
      const bgWidth = pageWidth
      const bgHeight = bgWidth / imgAspectRatio
      // 如果高度超过50mm，则按高度缩放
      const finalHeight = bgHeight > topBgHeight ? topBgHeight : bgHeight
      const finalWidth = finalHeight * imgAspectRatio
      pdf.addImage(topBg.data, 'PNG', 0, 0, finalWidth, finalHeight)
    } catch (error) {
      console.error('加载顶部背景图片失败，使用默认背景:', error)
      // 降级方案：使用深灰色背景
      const darkGrayColor: [number, number, number] = [54, 56, 61]
      pdf.setFillColor(darkGrayColor[0], darkGrayColor[1], darkGrayColor[2])
      pdf.rect(0, 0, pageWidth, topBgHeight, 'F')
    }
    
    // 白色内容区域
    pdf.setFillColor(255, 255, 255)
    pdf.rect(0, topBgHeight, pageWidth, pageHeight - topBgHeight, 'F')
    
    // Logo区域 - 使用jf.png图片
    const logoSize = 12
    const logoX = 15
    const logoY = 8
    let logoWidth = logoSize // 默认logo宽度
    
    // 加载JF logo图片
    const loadJfLogo = (): Promise<{ data: string; width: number; height: number }> => {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.crossOrigin = 'anonymous'
        img.onload = () => {
          const canvas = document.createElement('canvas')
          canvas.width = img.width
          canvas.height = img.height
          const ctx = canvas.getContext('2d')
          if (ctx) {
            ctx.drawImage(img, 0, 0)
            resolve({
              data: canvas.toDataURL('image/png'),
              width: img.width,
              height: img.height
            })
          } else {
            reject(new Error('无法创建canvas上下文'))
          }
        }
        img.onerror = () => reject(new Error('加载JF logo图片失败'))
        img.src = jfLogo
      })
    }
    
    // 添加JF logo图片
    try {
      const logo = await loadJfLogo()
      // 保持logo的宽高比，高度设为logoSize
      const logoAspectRatio = logo.width / logo.height
      const logoHeight = logoSize
      logoWidth = logoHeight * logoAspectRatio
      pdf.addImage(logo.data, 'PNG', logoX, logoY, logoWidth, logoHeight)
    } catch (error) {
      console.error('加载JF logo图片失败，使用默认logo:', error)
      // 降级方案：使用红色方块和JF文字
      pdf.setFillColor(redColor[0], redColor[1], redColor[2])
      pdf.rect(logoX, logoY, logoSize, logoSize, 'F')
      pdf.setTextColor(255, 255, 255)
      pdf.setFontSize(10)
      pdf.setFont('helvetica', 'bold')
      pdf.text('JF', logoX + 3, logoY + 8)
      logoWidth = logoSize
    }
    
    // 公司名称和单号区域 - 在logo右边，左对齐
    const textStartX = logoX + logoWidth + 3 // 文字起始x坐标（logo右边3mm）
    
    // 计算文字Y坐标，使其与logo顶部对齐
    // 由于addChineseTextAsImage的y参数是文字底部，需要加上文字高度才能让文字顶部对齐
    const companyNameFontSize = 16
    const estimatedTextHeight = (companyNameFontSize * 0.264583) * 1.2 // 估算文字高度（mm），考虑行高
    const companyNameY = logoY + estimatedTextHeight // 文字底部位置，使文字顶部与logo顶部对齐
    
    // 公司名称 - 使用html2canvas渲染中文文本为图片，16px
    const companyName = previewPdfData.value.order?.paymentCompany === '优罗莎' ? '优罗莎家具(昆山)有限公司' : '上海江丰家具集团有限公司'
    const companyNameWidth = await addChineseTextAsImage(pdf, companyName, textStartX, companyNameY, companyNameFontSize, textColor, 'bold')
    
    // 采购单标签 - 显示在公司名称后面，距离8px（约3mm），黑色描边，无背景
    const tagSpacing = 3 // 8px约等于3mm
    const tagText = '采购单'
    const tagFontSize = 12
    const tagEstimatedHeight = (tagFontSize * 0.264583) * 1.2
    // 标签文字Y坐标与公司名称对齐（顶部对齐）
    const tagTextY = companyNameY // 使用与公司名称相同的Y坐标，使顶部对齐
    
    // 先渲染文字获取尺寸
    const tagX = textStartX + companyNameWidth + tagSpacing
    const tagTextWidth = await addChineseTextAsImage(pdf, tagText, tagX, tagTextY - 0.8, tagFontSize, redColor, 'bold')
    
    // 添加黑色描边（在文字周围绘制边框，无背景色）
    // 由于addChineseTextAsImage的y参数是文字底部，文字顶部在 tagTextY - tagEstimatedHeight
    // 文字中心在 tagTextY - tagEstimatedHeight / 2
    const borderPadding = 1 // 边框内边距（mm）
    const tagHeight = 6 // 标签高度（mm）
    const tagTextTop = tagTextY - tagEstimatedHeight // 文字顶部位置
    const tagTextCenter = tagTextTop + tagEstimatedHeight / 2 // 文字中心位置
    const tagBorderY = tagTextCenter - tagHeight / 2 // 边框顶部位置，使边框以文字为中心
    pdf.setDrawColor(0, 0, 0) // 黑色描边
    pdf.setLineWidth(0.3) // 描边宽度
    // 不设置填充色，只绘制描边（使用'D'而不是'FD'）
    pdf.roundedRect(tagX - borderPadding, tagBorderY - 0.8, tagTextWidth + borderPadding * 2, tagHeight, 1, 1, 'D') // D = Draw only (no fill)
    
    // 单号 - 12px，与公司名称左对齐，在公司名称下方
    const orderNoFontSize = 12
    const orderNoEstimatedHeight = (orderNoFontSize * 0.264583) * 1.2
    const orderNoY = companyNameY + 6 // 在公司名称下方6mm
    await addChineseTextAsImage(pdf, `单号 ${purchaseDetail.purchaseOrderNo || '-'}`, textStartX, orderNoY, orderNoFontSize, textColor, 'normal')
    
    // 订单详情区域（从Y=30开始）
    let currentY = 30
    const labelValueSpacing = 3 // 标签和值之间的间距（mm）
    
    // 订单详情三列布局
    const col1X = 15
    const col2X = pageWidth / 2 - 30
    const col3X = pageWidth / 2 + 30
    const detailRowHeight = 6 // 每行高度（mm）
    
    // 第一行：供应商名称、下单时间、收货仓库
    let labelWidth = await addChineseTextAsImage(pdf, '供应商名称', col1X, currentY, 12, grayTextColor, 'normal')
    await addChineseTextAsImage(pdf, purchaseDetail.supplierName || '/', col1X + labelWidth + labelValueSpacing, currentY, 14, textColor, 'normal')
    
    labelWidth = await addChineseTextAsImage(pdf, '下单时间', col2X, currentY, 12, grayTextColor, 'normal')
    const orderDate = purchaseDetail.createTime ? formatDateForPdf(purchaseDetail.createTime) : '/'
    await addChineseTextAsImage(pdf, orderDate, col2X + labelWidth + labelValueSpacing, currentY, 14, textColor, 'normal')
    
    labelWidth = await addChineseTextAsImage(pdf, '收货仓库', col3X, currentY, 12, grayTextColor, 'normal')
    await addChineseTextAsImage(pdf, purchaseDetail.warehouseName || '/', col3X + labelWidth + labelValueSpacing, currentY, 14, textColor, 'normal')
    currentY += detailRowHeight
    
    // 第二行：供应商编号、计划交货、采购总额
    labelWidth = await addChineseTextAsImage(pdf, '供应商编号', col1X, currentY, 12, grayTextColor, 'normal')
    await addChineseTextAsImage(pdf, purchaseDetail.supplierNo || '/', col1X + labelWidth + labelValueSpacing, currentY, 14, textColor, 'normal')
    
    labelWidth = await addChineseTextAsImage(pdf, '计划交货', col2X, currentY, 12, grayTextColor, 'normal')
    const deliveryDate = purchaseDetail.schDate ? formatDateForPdf(purchaseDetail.schDate) : '/'
    await addChineseTextAsImage(pdf, deliveryDate, col2X + labelWidth + labelValueSpacing, currentY, 14, textColor, 'normal')
    
    labelWidth = await addChineseTextAsImage(pdf, '采购总额', col3X, currentY, 12, grayTextColor, 'normal')
    await addChineseTextAsImage(pdf, formatNumberForPdf(purchaseDetail.totalPrice || 0), col3X + labelWidth + labelValueSpacing, currentY, 14, textColor, 'bold')
    
    // 物料列表表格（从Y=50开始）
    currentY = 50
    
    // 表格标题行
    const tableHeaders = ['物料', '规格', '数量', '单位', '品牌', '采购备注', '单价', '总价']
    const colWidths = [55, 45, 15, 15, 40, 40, 15, 30]
    let tableX = 15
    const rowHeight = 16
    const headerHeight = 16
    
    // 记录表格开始位置
    let tableStartY = currentY
    
    // 表头背景（浅灰色）
    pdf.setFillColor(240, 240, 240)
    pdf.rect(tableX, currentY, pageWidth - 30, headerHeight, 'F')
    
    // 绘制表头
    pdf.setFontSize(16)
    pdf.setFont('helvetica', 'bold')
    pdf.setTextColor(textColor[0], textColor[1], textColor[2])
    // 计算表头文字垂直居中位置（行高16，14号字体高度约4.44mm）
    const headerFontSize = 14
    const headerTextHeight = (headerFontSize * 0.264583) * 1.2 // 估算文字高度（mm）
    const headerTextY = currentY + headerHeight / 2 + headerTextHeight / 2 // 文字底部位置，使文字垂直居中
    let headerX = tableX
    for (let index = 0; index < tableHeaders.length; index++) {
      // 计算列的中心位置，使用居中对齐
      const colCenterX = headerX + colWidths[index] / 2
      await addChineseTextAsImage(pdf, tableHeaders[index], colCenterX, headerTextY, headerFontSize, textColor, 'bold', 'center')
      headerX += colWidths[index]
    }
    
    currentY += headerHeight
    
    // 表格数据行
    pdf.setFont('helvetica', 'normal')
    pdf.setFontSize(16)
    
    for (let index = 0; index < itemList.length; index++) {
      const item = itemList[index]
      // 检查是否需要新页面
      if (currentY + rowHeight > pageHeight - 20) {
        // 绘制上一页表格的圆角边框
        const pageTableHeight = currentY - tableStartY
        pdf.setDrawColor(200, 200, 200)
        pdf.setLineWidth(0.3)
        pdf.roundedRect(tableX, tableStartY, pageWidth - 30, pageTableHeight, 1, 1, 'D') // D = Draw only (no fill)
        
        pdf.addPage()
        currentY = 20
        // 记录新页面的表格开始位置
        tableStartY = currentY
        // 重新绘制表头
        pdf.setFillColor(240, 240, 240)
        pdf.rect(tableX, currentY, pageWidth - 30, headerHeight, 'F')
        pdf.setFont('helvetica', 'bold')
        // 计算表头文字垂直居中位置（行高16，14号字体高度约4.44mm）
        const newPageHeaderFontSize = 14
        const newPageHeaderTextHeight = (newPageHeaderFontSize * 0.264583) * 1.2 // 估算文字高度（mm）
        const newPageHeaderTextY = currentY + headerHeight / 2 + newPageHeaderTextHeight / 2 // 文字底部位置，使文字垂直居中
        headerX = tableX
        for (let idx = 0; idx < tableHeaders.length; idx++) {
          // 计算列的中心位置，使用居中对齐
          const colCenterX = headerX + colWidths[idx] / 2
          await addChineseTextAsImage(pdf, tableHeaders[idx], colCenterX, newPageHeaderTextY, newPageHeaderFontSize, textColor, 'bold', 'center')
          headerX += colWidths[idx]
        }
        currentY += headerHeight
        pdf.setFont('helvetica', 'normal')
      }
      
      // 数据行背景（白色，偶数行可加浅灰）
      if (index % 2 === 0) {
        pdf.setFillColor(255, 255, 255)
      } else {
        pdf.setFillColor(250, 250, 250)
      }
      pdf.rect(tableX, currentY, pageWidth - 30, rowHeight, 'F')
      
      // 绘制数据
      // 计算数据行文字垂直居中位置（行高16，14号字体高度约4.44mm）
      const dataFontSize = 14
      const dataTextHeight = (dataFontSize * 0.264583) * 1.2 // 估算文字高度（mm）
      const dataTextY = currentY + rowHeight / 2 + dataTextHeight / 2 // 文字底部位置，使文字垂直居中
      let dataX = tableX
      const rowData = [
        item.goodsName || '/',
        item.goodsSpec || '/',
        String(item.quantity || '/'),
        item.unit || '/',
        item.brand || '/',
        item.remark || '/',
        item.price ? formatNumberForPdf(item.price) : '/',
        item.totalPrice ? formatNumberForPdf(item.totalPrice) : '/'
      ]
      
      for (let colIndex = 0; colIndex < rowData.length; colIndex++) {
        const data = rowData[colIndex]
        // 限制文本长度
        const maxWidth = colWidths[colIndex] - 2
        const text = truncateText(pdf, data, maxWidth)
        // 计算列的中心位置，使用居中对齐
        const colCenterX = dataX + colWidths[colIndex] / 2
        await addChineseTextAsImage(pdf, text, colCenterX, dataTextY, dataFontSize, textColor, 'normal', 'center')
        dataX += colWidths[colIndex]
      }
      
      currentY += rowHeight
    }
    
    // 绘制整个表格的圆角边框
    const tableTotalHeight = currentY - tableStartY
    pdf.setDrawColor(200, 200, 200)
    pdf.setLineWidth(0.3)
    pdf.roundedRect(tableX, tableStartY, pageWidth - 30, tableTotalHeight, 1, 1, 'D') // D = Draw only (no fill)
    
    // 保存PDF
    const fileName = `采购单_${purchaseDetail.purchaseOrderNo || item.id}.pdf`
    pdf.save(fileName)
    
    showSuccess('PDF导出成功')
  } catch (error: any) {
    console.error('导出PDF失败:', error)
    showError(error.message || '导出PDF失败')
  } finally {
    showCommonLoading.value = false
    commonLoadingText.value = ''
  }
}


// 格式化日期为MM/DD格式
const formatDateForPdf = (timestamp: number | string) => {
  if (!timestamp) return '/'
  const date = new Date(Number(timestamp))
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${month}/${day}`
}

// 格式化数字（添加千分位）- PDF专用
const formatNumberForPdf = (num: number | string) => {
  if (!num && num !== 0) return '/'
  return Number(num).toLocaleString('zh-CN')
}

// 截断文本以适应宽度
const truncateText = (pdf: any, text: string, maxWidth: number) => {
  // 简单截断，基于字符数估算（中文字符约等于2个英文字符宽度）
  const estimatedWidth = text.length * (text.match(/[\u4e00-\u9fa5]/g) ? 2 : 1) * 0.5
  if (estimatedWidth <= maxWidth) {
    return text
  }
  // 简单截断
  let truncated = text
  while (truncated.length > 0 && (truncated.length * 0.5) > maxWidth) {
    truncated = truncated.slice(0, -1)
  }
  return truncated + (truncated.length < text.length ? '...' : '')
}

const loadMaterialFile = async (conntractId: number,syscode: string) => {
  try {
    const res = await contractApi.getMaterialFileBySyscode({
      syscode: syscode,
      productOrderId: Number(conntractId)
    })
    console.log('res', res)
    if (res?.code === 0) {
      materialFileList.value = res.data.items
      materialFileStatus.value = res.data.status
    }else{
      showError(res?.message)
    }
  } catch (error) {
    
  }
}

// 加载物料书
const loadMaterialFileList = async (conntractId: number) => {
  try {
    const res = (await contractApi.getMaterialFile({
      id: Number(conntractId)
    }))
    if (res?.code === 0) {
      materialFileAllList.value = res.data
    }else{
      showError(res?.message)
    }
  } catch (error) {
    showError(error.message || error.msg)
  }
}

const loadWuliaoListFilter = async () => {
  const res = (await contractApi.getWuliaoListPage({
    id: Number(contractId.value),
    page: 1,
    pageSize: 200,
    fromPurchase: 1,
  }))
  if (res?.code === 0) {
    materialTypePriceOptions.value = [...new Set(
      res.data.records
        .map(item => item.materialType)
        .filter(val => val !== null && val !== undefined && val !== '')
    )]
    bigClassPriceOptions.value = [...new Set(
      res.data.records
        .map(item => item.bigClass)
        .filter(val => val !== null && val !== undefined && val !== '')
    )]
  }else{
    materialTypePriceOptions.value = []
    bigClassPriceOptions.value = [] 
  }
}
// 物控汇总
const loadWuliaoList = async () => {
  loadingMaterialControlSummary.value = true
  try {
    const res = (await contractApi.getWuliaoListPage({
      id: Number(contractId.value),
      page: 1,
      pageSize: 200,
      // fromPurchase: 1,
      materialType: materialTypePriceFilter.value,
      bigClass: bigClassPriceFilter.value
    }))
    if (res?.code === 0) {
      // materialControlSummaryList.value = res.data.records
      materialControlSummaryList.value = res.data.records.map((wuliao: any) => ({
        productCodes: wuliao.productCodes,
        id: wuliao.id,
        toWuliaoTime: wuliao.toWuliaoTime,
        isDelete: wuliao.isDelete,
        // isTurnWuliao: wuliao.wuliaoStatus && Number(wuliao.wuliaoStatus) != 0 ? true : false,
        isTurnWuliao: false,
        materialType: wuliao.materialType,
        bigClass: wuliao.bigClass,
        materialName: wuliao.materialName,
        materialCode: wuliao.materialCode,
        materialUnit: wuliao.materialUnit,
        unit: wuliao.unit,
        specDesc: wuliao.specDesc,
        materialDescription: wuliao.materialDescription || '/',
        materialDescriptionMerge: wuliao.materialDescriptionMerge,
        materialPrice: wuliao.materialPrice || 0,  
        materialTotal: wuliao.materialTotal || 0,
        materialCount: wuliao.materialCount || 0,
        materialPriceConfirmed: wuliao.materialPriceConfirmed,
        // wuliaoStatus: statusWuLiaoOptions.find(option => option.value === wuliao.wuliaoStatus)?.title || '',
        wuliaoStatus: Number(wuliao.wuliaoStatus),
        materialImageUrls: wuliao.materialImageUrls ? JSON.parse(wuliao.materialImageUrls) : [],
        materialImageUrlsConfirmed: wuliao.wuliaoItem.materialImageUrls ? JSON.parse(wuliao.wuliaoItem.materialImageUrls) : [],
        wuliaoName: wuliao.wuliaoItem.wuliaoName || '',
        wuliaoRemark: wuliao.wuliaoItem.wuliaoRemark || '',
        materialNameConfirmed: wuliao.materialNameConfirmed || '',
        materialTypeConfirmed: wuliao.materialTypeConfirmed || '',
        createTime: wuliao.wuliaoItem.createTime,
        wuliaoItem: wuliao.wuliaoItem,
        salesmanRemark: wuliao.salesmanRemark || '',
        // materialImageUrls: wuliao.wuliaoItem.materialImageUrls,
        salesmanReviewStatus: wuliao.wuliaoItem.salesmanReviewStatus,
        materialCustomerNo: wuliao.materialCustomerNo || '/',
        currentInventory: wuliao.currentInventory,
        purchasedQuantity: wuliao.purchasedQuantity,
        productCodes: wuliao.productCodes || [],
        // updateTime: wuliao.wuliaoItem.updateTime,
        // wuliaoName: wuliao.wuliaoItem.wuliaoName,
        // wuliaoRemark: wuliao.wuliaoItem.wuliaoRemark,
        // wuliaoUid: wuliao.wuliaoItem.wuliaoUid
      }))
    }
  } finally {
    loadingMaterialControlSummary.value = false
  }
}

// 常规材料
const loadProductionBomItems = async () => {
  if(!route.query.productCode || route.query.productCode === 'undefined' || route.query.productCode === 'null' || route.query.productCode === '' || route.query.productCode === null){
    return
  }
  const res = await contractApi.loadMaterialBomItems({
    productOrderItemId: route.query.productCode,
    finishedComponentName: finishedComponentFilter.value,
    componentName: componentFilter.value,
    // partName
    // materialName
  })
  if(res.code === 0 && res?.data){
    console.log('res', res.data)
    materialBomList.value = res.data.items
    finishedComponentOptions.value = res.data.filterValues.finishedComponentNames
    componentOptions.value = res.data.filterValues.componentNames
  }
}

// 物料汇总
const loadMaterialSummaryFilter = async () => {
  if(!route.query.productCode || route.query.productCode === 'undefined' || route.query.productCode === 'null' || route.query.productCode === '' || route.query.productCode === null){
    return
  }
  const res = await contractApi.loadMaterialSummary({
    productOrderItemId: route.query.productCode,
    bigClass: bigClassFilter.value,
    smallClass: kindFilter.value,
  })
  if(res.code === 0 && res?.data){
    console.log('res', res.data)
    materialSummaryList.value = res.data
    materialAllSummaryList.value = res.data
  }
}

// 常规材料汇总
const loadMaterialSummaryMerge = async () => {
  if (!route.query.productCode || route.query.productCode === 'undefined' || route.query.productCode === 'null' || route.query.productCode === '' || route.query.productCode === null) {
    return
  }
  loadingMaterialSummary.value = true
  try {
    const params: any = {
      contractId: contractId.value,
      from: 0,
      jinshu: 0,
      page: materialSummaryPagination.value.page,
      pageSize: materialSummaryPagination.value.pageSize
    }
    // 按品项 / 按项目 切换
    params.groupByProduct = materialSummarySearchType.value === 'materialSummaryProduct' ? 1 : 0
    // 添加常规材料汇总筛选参数（数组转逗号分隔字符串）
    if (materialSummarySearchForm.value.materialName.length > 0) {
      params.materialName = materialSummarySearchForm.value.materialName.join(',')
    }
    if (materialSummarySearchForm.value.materialSpec.length > 0) {
      params.materialSpec = materialSummarySearchForm.value.materialSpec.join(',')
    }
    if (materialSummarySearchForm.value.bigClass.length > 0) {
      params.bigClass = materialSummarySearchForm.value.bigClass.join(',')
    }
    if (materialSummarySearchForm.value.smallClass.length > 0) {
      params.smallClass = materialSummarySearchForm.value.smallClass.join(',')
    }
    if (materialSummarySearchForm.value.productName.length > 0) {
      params.productName = materialSummarySearchForm.value.productName.join(',')
    }
    if (materialSummarySearchForm.value.materialCode.length > 0) {
      params.materialCode = materialSummarySearchForm.value.materialCode.join(',')
    }
    if (keywordSearchMaterial.value) {
      params.keyword = keywordSearchMaterial.value
    }
    const res = await contractApi.loadMaterialSummaryMerge(params)
    if (res.code === 0 && res?.data) {
      if (materialSummarySearchType.value === 'materialSummaryProduct') {
        // 接口返回：products 为按品项聚合数据
        materialSummaryProductList.value = res.data.products || []
        mergeProductionBomSummaryItems.value = []
      } else {
        // 接口返回：items 为按项目聚合数据
        mergeProductionBomSummaryItems.value = res.data.items || []
        materialSummaryProductList.value = []
      }
      materialSummaryPagination.value.total = res.data.pagination?.total || 0
      // 筛选项
      materialproductNamesSummaryOptions.value = res.data.filterValues.productNames
      materialfinishedComponentNamesSummaryOptions.value = res.data.filterValues.finishedComponentNames
      materialpartNamesSummaryOptions.value = res.data.filterValues.partNames
      materialcomponentNamesSummaryOptions.value = res.data.filterValues.componentNames
      materialmaterialNamesSummaryOptions.value = res.data.filterValues.materialNames
      materialmaterialSpecsSummaryOptions.value = res.data.filterValues.materialSpecs
      materialmaterialCodesSummaryOptions.value = res.data.filterValues.materialCodes || []
      materialbigClassesSummaryOptions.value = res.data.filterValues.bigClasses
      materialsmallClassesSummaryOptions.value = res.data.filterValues.smallClasses
    } else {
      showError(res?.message)
    }
  } finally {
    loadingMaterialSummary.value = false
  }
}

// 定制&五金汇总
const loadMetalSummaryMerge = async () => {
  if (!route.query.productCode || route.query.productCode === 'undefined' || route.query.productCode === 'null' || route.query.productCode === '' || route.query.productCode === null) {
    return
  }
  loadingMetalSummary.value = true
  try {
    const params: any = {
      contractId: contractId.value,
      from: 0,
      jinshu: 1,
      page: metalSummaryPagination.value.page,
      pageSize: metalSummaryPagination.value.pageSize
    }
    // 按品项 / 按项目 切换
    params.groupByProduct = metalSummarySearchType.value === 'metalSummaryProduct' ? 1 : 0
    // 添加定制&五金汇总筛选参数（数组转逗号分隔字符串）
    if (metalSummarySearchForm.value.productName.length > 0) {
      params.productName = metalSummarySearchForm.value.productName.join(',')
    }
    if (metalSummarySearchForm.value.partName.length > 0) {
      params.partName = metalSummarySearchForm.value.partName.join(',')
    }
    if (metalSummarySearchForm.value.materialName.length > 0) {
      params.materialName = metalSummarySearchForm.value.materialName.join(',')
    }
    if (metalSummarySearchForm.value.materialSpec.length > 0) {
      params.materialSpec = metalSummarySearchForm.value.materialSpec.join(',')
    }
    if (metalSummarySearchForm.value.bigClass.length > 0) {
      params.bigClass = metalSummarySearchForm.value.bigClass.join(',')
    }
    if (metalSummarySearchForm.value.smallClass.length > 0) {
      params.smallClass = metalSummarySearchForm.value.smallClass.join(',')
    }
    if (metalSummarySearchForm.value.materialCode.length > 0) {
      params.materialCode = metalSummarySearchForm.value.materialCode.join(',')
    }
    if (keywordSearchMetal.value) {
      params.keyword = keywordSearchMetal.value
    }
    const res = await contractApi.loadMaterialSummaryMerge(params)
    if (res.code === 0 && res?.data) {
      if (metalSummarySearchType.value === 'metalSummaryProduct') {
        mergeProductionMetalSummaryProductItems.value = res.data.products || []
        mergeProductionMetalSummaryItems.value = []
      } else {
        mergeProductionMetalSummaryItems.value = res.data.items || []
        mergeProductionMetalSummaryProductItems.value = []
      }
      metalSummaryPagination.value.total = res.data.pagination.total || 0
      // 筛选项
      metalproductNamesOptions.value = res.data.filterValues.productNames || []
      metalSummaryPartNamesOptions.value = res.data.filterValues.partNames || []
      metalSummaryMaterialNamesOptions.value = res.data.filterValues.materialNames || []
      metalSummaryMaterialSpecsOptions.value = res.data.filterValues.materialSpecs || []
      metalSummaryMaterialCodesOptions.value = res.data.filterValues.materialCodes || []
      metalSummaryBigClassesOptions.value = res.data.filterValues.bigClasses || []
      metalSummarySmallClassesOptions.value = res.data.filterValues.smallClasses || []
    } else {
      showError(res?.message)
    }
  } finally {
    loadingMetalSummary.value = false
  }
}

// 常规材料
const loadMaterialSummary = async () => {
  if(!route.query.productCode || route.query.productCode === 'undefined' || route.query.productCode === 'null' || route.query.productCode === '' || route.query.productCode === null){
    return
  }
  loadingMaterialSummary.value = true
  try {
    const params: any = {
      contractId: contractId.value,
      from: 0,
      jinshu: 0,
      page: materialPagination.value.page,
      pageSize: materialPagination.value.pageSize
    }
    // 添加筛选参数（数组转逗号分隔字符串）
    if (materialSearchForm.value.productName.length > 0) {
      params.productName = materialSearchForm.value.productName.join(',')
    }
    if (materialSearchForm.value.finishedComponentName.length > 0) {
      params.finishedComponentName = materialSearchForm.value.finishedComponentName.join(',')
    }
    if (materialSearchForm.value.componentName.length > 0) {
      params.componentName = materialSearchForm.value.componentName.join(',')
    }
    if (materialSearchForm.value.partName.length > 0) {
      params.partName = materialSearchForm.value.partName.join(',')
    }
    if (materialSearchForm.value.materialName.length > 0) {
      params.materialName = materialSearchForm.value.materialName.join(',')
    }
    if (materialSearchForm.value.materialSpec.length > 0) {
      params.materialSpec = materialSearchForm.value.materialSpec.join(',')
    }
    if (materialSearchForm.value.materialCode.length > 0) {
      params.materialCode = materialSearchForm.value.materialCode.join(',')
    }
    if (materialSearchForm.value.bigClass.length > 0) {
      params.bigClass = materialSearchForm.value.bigClass.join(',')
    }
    if (materialSearchForm.value.smallClass.length > 0) {
      params.smallClass = materialSearchForm.value.smallClass.join(',')
    }
    const res = await contractApi.mergeProductionBomItems(params)
    if(res.code === 0 && res?.data){
      mergeProductionBomItems.value = res.data.items
      // 更新分页总数
      materialPagination.value.total = res.data.pagination.total || 0
      // 筛选项
      materialproductNamesOptions.value = res.data.filterValues.productNames
      materialfinishedComponentNamesOptions.value = res.data.filterValues.finishedComponentNames
      materialpartNamesOptions.value = res.data.filterValues.partNames
      materialcomponentNamesOptions.value = res.data.filterValues.componentNames
      materialmaterialNamesOptions.value = res.data.filterValues.materialNames
      materialmaterialSpecsOptions.value = res.data.filterValues.materialSpecs
      materialmaterialCodesOptions.value = res.data.filterValues.materialCodes || []
      materialbigClassesOptions.value = res.data.filterValues.bigClasses
      materialsmallClassesOptions.value = res.data.filterValues.smallClasses
    }else{
      showError(res?.message)
    }
  } finally {
    loadingMaterialSummary.value = false
  }
}

const resetMaterialSummary = () => {
  showChoosePurchase.value = false
  showFactoryChoosePurchase.value = false
  showFactoryChoosePurchaseHardware.value = false
  showPurchaseDialog.value = false
  showProductChoosePurchase.value = false
  currentChooseAction.value = ''
  selectedMaterials.value = []
  isSelectAll.value = false
  selectedProducts.value = []
  selectedProductDetails.value = []
  isProductSelectAll.value = false
  selectedFactoryMaterials.value = []
  isFactorySelectAll.value = false
  selectedHardwareMaterials.value = []
  isHardwareSelectAll.value = false
  selectedMaterialDetails.value = []
  materialSummaryProductList.value = []
}
// 定制&五金
// const loadMaterialSummaryHardware = async () => {
//   console.log('loadMaterialSummaryHardware')
//   if(!route.query.productCode || route.query.productCode === 'undefined' || route.query.productCode === 'null' || route.query.productCode === '' || route.query.productCode === null){
//     return
//   }
//   const res = await purchaseApi.liaodanSummary({
//     contractId: contractId.value,
//     bigClass: bigClassHardwareFilter.value,
//     smallClass: typeHardwareFilter.value,
//     fromPurchase: 1,
//     jinshu: 1
//   })
//   if(res.code === 0 && res?.data){
//     console.log('res', res.data)
//     materialSummaryHardwareList.value = res.data.summaryList
//     bigClassSummaryHardwareOptions.value = res.data.filterValues.bigClasses
//     smallClassSummaryHardwareOptions.value = res.data.filterValues.smallClasses
//   }
// }
const loadMaterialSummaryHardware = async () => {
  if(!route.query.productCode || route.query.productCode === 'undefined' || route.query.productCode === 'null' || route.query.productCode === '' || route.query.productCode === null){
    return
  }
  loadingMaterialSummaryHardware.value = true
  try {
    const params: any = {
      contractId: contractId.value,
      from: 0,
      jinshu: 1,
      page: metalPagination.value.page,
      pageSize: metalPagination.value.pageSize
    }
    // 添加筛选参数（数组转逗号分隔字符串）
    if (metalSearchForm.value.productName.length > 0) {
      params.productName = metalSearchForm.value.productName.join(',')
    }
    if (metalSearchForm.value.finishedComponentName.length > 0) {
      params.finishedComponentName = metalSearchForm.value.finishedComponentName.join(',')
    }
    if (metalSearchForm.value.componentName.length > 0) {
      params.componentName = metalSearchForm.value.componentName.join(',')
    }
    if (metalSearchForm.value.partName.length > 0) {
      params.partName = metalSearchForm.value.partName.join(',')
    }
    if (metalSearchForm.value.materialName.length > 0) {
      params.materialName = metalSearchForm.value.materialName.join(',')
    }
    if (metalSearchForm.value.materialSpec.length > 0) {
      params.materialSpec = metalSearchForm.value.materialSpec.join(',')
    }
    if (metalSearchForm.value.materialCode.length > 0) {
      params.materialCode = metalSearchForm.value.materialCode.join(',')
    }
    if (metalSearchForm.value.bigClass.length > 0) {
      params.bigClass = metalSearchForm.value.bigClass.join(',')
    }
    if (metalSearchForm.value.smallClass.length > 0) {
      params.smallClass = metalSearchForm.value.smallClass.join(',')
    }
    const res = await contractApi.mergeProductionBomItems(params)
    if(res.code === 0 && res?.data){
      mergeProductionWareMetalItems.value = res.data.items
      // 更新分页总数
      metalPagination.value.total = res.data.pagination.total || 0
      // 筛选项
      metalproductNamesOptions.value = res.data.filterValues.productNames
      metalfinishedComponentNamesOptions.value = res.data.filterValues.finishedComponentNames
      metalpartNamesOptions.value = res.data.filterValues.partNames
      metalcomponentNamesOptions.value = res.data.filterValues.componentNames
      metalmaterialNamesOptions.value = res.data.filterValues.materialNames
      metalmaterialSpecsOptions.value = res.data.filterValues.materialSpecs
      metalmaterialCodesOptions.value = res.data.filterValues.materialCodes || []
      metalbigClassesOptions.value = res.data.filterValues.bigClasses
      metalsmallClassesOptions.value = res.data.filterValues.smallClasses
    }else{
      showError(res?.message)
    }
  } finally {
    loadingMaterialSummaryHardware.value = false
  }
}
// 物控汇总
const loadWuliaoSummaryList = async () => {
  try {
    loading.value = true
    const res = await contractApi.getWuliaoListPage({
      productOrderItemId: route.query.productCode,
      page: 1,
      pageSize: 100
    })
  if(res.code === 0 && res?.data){
    console.log('res', res.data)
    materialControlSummaryList.value = res.data.records
  }
  } catch (error: any) {
    console.error('获取物控汇总失败:', error)
    showError(error.message || error.msg)
  } finally {
    loading.value = false
  }
}

// 获取合同信息
const loadContractInfo = async () => {
  if (!contractId.value || contractId.value === 'undefined' || contractId.value === 'null' || contractId.value === '' || contractId.value === null) {
    return
  }
  try {
    const res = (await contractApi.getDetail(Number(contractId.value))) as unknown as ApiResponse
    if (res?.code === 0) {
      const contract = res.data
      contractInfo.value = contract
      if(contract.project){
        document.title = contract.project
      }else{
        document.title = '采购汇总'
      }
    }else{
      showError(res?.message)
    }
  } catch (error: any) {
    console.error('获取合同信息失败:', error)
    showError(error.message || error.msg)
  }
}
// 添加预览相关的状态变量
const showPreview = ref(false)
const previewImage = ref<string[]>([])
const currentParentIndex = ref(0)
const selectedIndex = ref(0)
const isDelete = ref(false)
const type = ref('wuliao')

// 添加预览相关的方法
const handleImagePreview = (images: { url: string; name: string }[], materialIndex: number, index: number, canDelete: boolean, isType: 'product' | 'wuliao' | 'voucher') => {
  console.log('images', images, materialIndex, index, canDelete, isType)
  const urls = images.map(image => image.url)
  previewImage.value = urls
  showPreview.value = true
  currentParentIndex.value = materialIndex
  selectedIndex.value = index
  isDelete.value = canDelete
}

const handleClosePreview = () => {
  showPreview.value = false
  previewImage.value = []
  currentParentIndex.value = 0
  selectedIndex.value = 0
}

// 采购弹窗相关变量
const showChoosePurchase = ref(false)
const showFactoryChoosePurchase = ref(false)
const showPurchaseDialog = ref(false)
const showProductChoosePurchase = ref(false)
const purchaseDialogRef = ref<InstanceType<typeof PurchaseDialog> | null>(null)
const showAddPurchaseItemDialog = ref(false)
const addPurchaseDialogRows = ref<any[]>([])
const currentChooseAction = ref<'direct' | 'add' | ''>('')
const addPurchaseWarehouseNo = computed(() => warehouseList.value[0]?.warehouseNo ?? '')
const PurchaseRequisitionItemType = {
  Material: 0,
  Product: 1,
} as const
type PurchaseEntryKey = 'estimate' | 'product' | 'factoryMaterial' | 'factoryHardware'
const purchaseEntryConfig: Record<PurchaseEntryKey, { defaultItemType: number }> = {
  estimate: { defaultItemType: 1 },
  product: { defaultItemType: 2 },
  factoryMaterial: { defaultItemType: 1 },
  factoryHardware: { defaultItemType: 0 },
}

const selectedMaterials = ref<any[]>([])  // 选中的物料ID列表（物控汇总）
const isSelectAll = ref(false)  // 是否全选（物控汇总）
const selectedProducts = ref<any[]>([])  // 选中的成品ID列表（生产单）
const selectedProductDetails = ref<any[]>([])  // 选中的成品详情（生产单，支持跨分页保留）
const isProductSelectAll = ref(false)  // 是否全选（生产单）
const selectedFactoryMaterials = ref<any[]>([])  // 选中的物料ID列表（常规材料）
const isFactorySelectAll = ref(false)  // 是否全选（常规材料）
const showFactoryChoosePurchaseHardware = ref(false)  // 定制&五金采购选择模式
const selectedHardwareMaterials = ref<any[]>([])  // 选中的物料ID列表（定制&五金）
const isHardwareSelectAll = ref(false)  // 是否全选（定制&五金）
const selectedMaterialDetails = ref<any[]>([])  // 选中物料的详细信息列表
const purchaseForm = ref()
const purchaseValid = ref(false)
const purchaseLoading = ref(false)
const vendorList = ref<any[]>([])
const vendorLoading = ref(false)
const vendorSearchText = ref('')
const materialDateInputRefs = ref<Record<number, HTMLInputElement | null>>({})
const purchaseData = ref({
  vendor: null as any,
  quantity: null as number | null,
  price: null as number | null,
  purchaseOrderNo: null as string | null,
  paymentMethod: {value: '0', label: '预付'},
  paymentCompany: null as any,
  paymentDate: null as string | null,
  id: null as number | null,
  totalAmount: 0,
  tax: {value: "0", label: "不含税"},
  taxRate: {value: "0", label: "0%"} as any,
  taxAmount: 0,
  totalAmountWithTax: 0,
  warehouse: {warehouseNo: '', warehouseName: ''} as any,
  purchaseStandard: null as string | null,
    remark: '1、贵公司提供产品保质期最少不得低于二年\n2、凡因供货厂商质量上与我司要求标准有所差异造成的后果，除扣除货款之外还需要负起我司其它之一切损失\n3、供货厂商未依规定期间交货，若因此造成我司所有经济及其名誉上的损失，我司将追究一切之责任\n4、收到清单请及时确认交货期并回传\n5、每周六提供所有订单的交货排程',
  // remark: '' as string,
})
// 当前编辑的采购订单索引
const currentPurchaseIndex = ref<number>(-1)

const paymentCompanys = [
  {value: "优罗莎", label: "优罗莎"},
  {value: "上海江丰", label: "上海江丰"}
]

const paymentMethods = [
  {value: "0", label: "预付"},
  {value: "1", label: "现付"},
  {value: "2", label: "月结"},
  {value: "3", label: "次月结"},
]

const purchaseStandardList = [
  'GB/T16799-2018',
  'GB 18401-2010中B级规范',
  'GB 18583-2008有害物质限量',
  '符合39600-2021(EO)(ENF)甲醛释放量',
  'GB/T10802-2023(视产品订定)华为卡座S级其它家具A级',
  'GB/T8624-2012',
  'GB/T9846-2015标准和GB/T14732-2017(环保)',
  'GB/T41919-2020',
  'GB 18581-2020',
  'GB/T44437-2024'
]

const taxs = [
  {value: "0", label: "不含税"},
  {value: "1", label: "含税"},
]

const taxRates = [
  {value: "0", label: "0%"},
  {value: "3", label: "3%"},
  {value: "6", label: "6%"},
  {value: "9", label: "9%"},
  {value: "13", label: "13%"},
]

// 计算采购单总金额、税额和含税总金额
const calculatePurchaseTotalAmount = () => {
  const total = selectedMaterialDetails.value.reduce((sum, material) => {
    const quantity = Number(material.materialCount) || 0
    const price = Number(material.materialPrice) || 0
    return sum + (quantity * price)
  }, 0)
  purchaseData.value.totalAmount = Number(total.toFixed(2))
  
  // 计算税额和含税总金额
  calculateTaxAmount()
}

// 计算税额和含税总金额
const calculateTaxAmount = () => {
  const totalAmount = purchaseData.value.totalAmount || 0
  const taxRateValue = Number(purchaseData.value.taxRate?.value) || 0
  
  // // 税额 = 合计金额 * 税率 / 100 不含税
  // const taxAmount = totalAmount * taxRateValue / 100
  // purchaseData.value.taxAmount = Number(taxAmount.toFixed(2))
  // // 税额 = 总价 - 总价/(1+税率/100) 含税

  // // 含税总金额 = 合计金额 + 税额  不含税
  // purchaseData.value.totalAmountWithTax = Number((totalAmount + taxAmount).toFixed(2))
  // // 含税总金额 = 合计金额 含税
  // purchaseData.value.totalAmountWithTax = Number(totalAmount)
  if(Number(purchaseData.value.tax?.value ?? "0") === 0){
    const taxAmount = totalAmount * taxRateValue / 100
    purchaseData.value.taxAmount = Number(taxAmount.toFixed(2))
    purchaseData.value.totalAmountWithTax = Number((totalAmount + taxAmount).toFixed(2))
  }else{
    const taxAmount = totalAmount - totalAmount / (1 + taxRateValue / 100)
    purchaseData.value.taxAmount = Number(taxAmount.toFixed(2))
    purchaseData.value.totalAmountWithTax = Number(totalAmount)
  }
  
}

// 获取今天的日期字符串（用于日期选择器的min属性）
const getTodayDate = () => {
  const today = new Date()
  const year = today.getFullYear()
  const month = String(today.getMonth() + 1).padStart(2, '0')
  const day = String(today.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

// 设置物料日期输入框引用
const setMaterialDateInputRef = (el: HTMLInputElement | null, index: number) => {
  if (el) {
    materialDateInputRefs.value[index] = el
  }
}

// 打开物料的日期选择器
const openMaterialDatePicker = (index: number) => {
  nextTick(() => {
    const input = materialDateInputRefs.value[index]
    if (input) {
      if (typeof input.showPicker === 'function') {
        input.showPicker()
      } else {
        input.click()
      }
    }
  })
}

// 物料日期选择变化处理
const onMaterialDateChange = (event: Event, index: number) => {
  const target = event.target as HTMLInputElement
  const newDate = target.value
  
  try {
    if (newDate && typeof newDate === 'string') {
      const material = selectedMaterialDetails.value[index]
      if (material) {
        material.plannedDeliveryDate = newDate
      }
    }
  } catch (error) {
    console.error('物料日期处理失败:', error)
  }
}

// 监听物料详情变化，自动计算总金额
watch(
  selectedMaterialDetails,
  () => {
    calculatePurchaseTotalAmount()
  },
  { deep: true }
)

// 监听税率变化，自动计算税额和含税总金额
watch(
  () => purchaseData.value.taxRate,
  () => {
    calculateTaxAmount()
  },
  { deep: true }
)

watch(
  () => purchaseData.value.tax,
  () => {
    calculateTaxAmount()
  },
  { deep: true }
)
// 监听供应商选择变化，设置默认付款方式
watch(
  () => purchaseData.value.vendor,
  (newVendor) => {
    if (newVendor && newVendor.paymentType !== undefined && newVendor.paymentType !== null) {
      const paymentTypeValue = String(newVendor.paymentType)
      const matchedPaymentMethod = paymentMethods.find(item => item.value === paymentTypeValue)
      if (matchedPaymentMethod) {
        purchaseData.value.paymentMethod = matchedPaymentMethod
      }
    }
    if (newVendor && newVendor.rate !== undefined && newVendor.rate !== null) {
      const rateValue = String(newVendor.rate)
      const matchedRate = taxRates.find(item => item.value === rateValue)
      if (matchedRate) {
        purchaseData.value.taxRate = matchedRate
      }
    }
  }
)

// 切换常规材料汇总查询类型时，重新请求数据
watch(
  materialSummarySearchType,
  () => {
    materialSummaryPagination.value.page = 1
    mergeProductionBomSummaryItems.value = []
    materialSummaryProductList.value = []
    // 重置“发起采购”相关选择状态
    showFactoryChoosePurchase.value = false
    selectedMaterials.value = []
    isSelectAll.value = false
    selectedMaterialDetails.value = []
    currentChooseAction.value = ''
    loadMaterialSummaryMerge()
  }
)

// 切换定制&五金汇总查询类型时，重新请求数据
watch(
  metalSummarySearchType,
  () => {
    metalSummaryPagination.value.page = 1
    mergeProductionMetalSummaryItems.value = []
    mergeProductionMetalSummaryProductItems.value = []
    // 重置“发起采购”相关选择状态
    showFactoryChoosePurchaseHardware.value = false
    selectedHardwareMaterials.value = []
    isHardwareSelectAll.value = false
    selectedMaterialDetails.value = []   
    currentChooseAction.value = ''
    loadMetalSummaryMerge()
  }
)

// 打开原生日期选择器
const nativeDateInput = ref<HTMLInputElement>()
const openNativeDatePicker = () => {
  if (nativeDateInput.value) {
    nativeDateInput.value.showPicker?.() || nativeDateInput.value.click()
  }
}

// 原生 HTML5 日期输入框变化处理
const onNativeDateChange = (event: Event) => {
  const target = event.target as HTMLInputElement
  const newDate = target.value
  
  console.log('原生日期输入框变化:', newDate)
  
  try {
    if (newDate && typeof newDate === 'string') {
      // HTML5 date 输入框返回的是 YYYY-MM-DD 格式，直接使用
      purchaseData.value.paymentDate = newDate
      console.log('设置交货时间:', newDate)
    } else {
      purchaseData.value.paymentDate = ''
      console.log('日期已清空')
    }
  } catch (error) {
    console.error('日期处理失败:', error)
    purchaseData.value.paymentDate = ''
  }
  
  console.log('当前表单数据 paymentDate:', purchaseData.value.paymentDate)
}

const calculateTotalPrice = (price: number, quantity: number) => {
  if (!price || !quantity) {
    return '0.00'
  }
  const total = Number(price) * Number(quantity)
  return total.toFixed(2)
}

// 处理数量输入，只允许正整数，不允许小数点
const handleQuantityInput = (material: any) => {
  // 获取输入值并转为字符串
  let value = String(material.materialCount || '').trim()
  
  // 严格过滤：只保留数字，移除所有其他字符（包括小数点、负号、字母等）
  value = value.replace(/[^\d]/g, '')
  
  // 如果为空，清空数量
  if (value === '') {
    material.materialCount = ''
    return
  }
  
  // 移除前导零（例如：007 -> 7，但 0 保持为 0）
  value = value.replace(/^0+(\d)/, '$1')
  
  // 转换为正整数
  const num = parseInt(value, 10)
  
  // 只接受大于 0 的正整数
  if (!isNaN(num) && num > 0) {
    material.materialCount = num
  } else {
    // 不接受 0 和负数
    material.materialCount = ''
  }
}

// 处理单价输入，只允许正数，最多两位小数
const handlePriceInput = (material: any) => {
  // 获取输入值
  let value = String(material.materialPrice || '')
  
  // 允许数字和一个小数点
  value = value.replace(/[^\d.]/g, '')
  
  // 如果为空或只有小数点，设置为空字符串
  if (value === '' || value === '.') {
    material.materialPrice = ''
    return
  }
  
  // 确保只有一个小数点
  const parts = value.split('.')
  if (parts.length > 2) {
    value = parts[0] + '.' + parts.slice(1).join('')
  }
  
  // 限制小数点后只有两位
  if (parts.length === 2) {
    if (parts[1].length > 2) {
      value = parts[0] + '.' + parts[1].substring(0, 2)
    }
  }
  
  // 移除整数部分的前导零（但保留小数前的0）
  if (parts[0].length > 1 && parts[0].startsWith('0')) {
    parts[0] = parts[0].replace(/^0+/, '')
    value = parts.length === 2 ? parts[0] + '.' + parts[1].substring(0, 2) : parts[0]
  }
  
  // 转换为数字验证
  const num = parseFloat(value)
  if (!isNaN(num) && num >= 0) {
    material.materialPrice = value
  } else {
    material.materialPrice = ''
  }
}

// 采购相关方法
const handleToPurchase = () => {
  showChoosePurchase.value = true
  selectedMaterials.value = []
  isSelectAll.value = false
}

// 成品（生产单）发起采购
const handleToProductPurchase = () => {
  showProductChoosePurchase.value = true
  selectedProducts.value = []
  selectedProductDetails.value = []
  isProductSelectAll.value = false
}

const handleToFactoryPurchase = () => {
  showFactoryChoosePurchase.value = true
  selectedFactoryMaterials.value = []
  isFactorySelectAll.value = false
  selectedMaterialDetails.value = []
}

// 全选/取消全选（物控汇总）
const handleSelectAll = () => {
  if (isSelectAll.value) {
    selectedMaterials.value = materialControlSummaryList.value.map(item => item.id)
    selectedMaterialDetails.value = materialControlSummaryList.value.map(item => ({
      ...item,
      materialCount: item.materialCount || null,
      purchasePrice: null,
    }))
  } else {
    selectedMaterials.value = []
    selectedMaterialDetails.value = []
  }
}

const syncProductSelectAllByCurrentPage = () => {
  const currentPageSelectableIds = productionOrderList.value
    .filter((item: any) => item.productionInvalidStatus !== Number(1))
    .map((item: any) => item.id)
  if (currentPageSelectableIds.length === 0) {
    isProductSelectAll.value = false
    return
  }
  isProductSelectAll.value = currentPageSelectableIds.every((id: any) => selectedProducts.value.includes(id))
}

// 全选/取消全选（生产单/成品，按当前页增量处理，保留其他页已选）
const handleProductSelectAll = () => {
  const currentPageRows = productionOrderList.value.filter((item: any) => item.productionInvalidStatus !== Number(1))
  const currentPageIds = currentPageRows.map((item: any) => item.id)

  if (isProductSelectAll.value) {
    currentPageIds.forEach((id: any) => {
      if (!selectedProducts.value.includes(id)) {
        selectedProducts.value.push(id)
      }
    })
    currentPageRows.forEach((row: any) => {
      if (!selectedProductDetails.value.some((item: any) => item.id === row.id)) {
        selectedProductDetails.value.push({ ...row })
      }
    })
  } else {
    selectedProducts.value = selectedProducts.value.filter((id: any) => !currentPageIds.includes(id))
    selectedProductDetails.value = selectedProductDetails.value.filter((item: any) => !currentPageIds.includes(item.id))
  }
}

// 单选成品（生产单）
const handleSelectProduct = (item: any) => {
  const index = selectedProducts.value.indexOf(item.id)
  if (index > -1) {
    selectedProducts.value.splice(index, 1)
    const detailIndex = selectedProductDetails.value.findIndex((it: any) => it.id === item.id)
    if (detailIndex > -1) {
      selectedProductDetails.value.splice(detailIndex, 1)
    }
  } else {
    selectedProducts.value.push(item.id)
    if (!selectedProductDetails.value.some((it: any) => it.id === item.id)) {
      selectedProductDetails.value.push({ ...item })
    }
  }

  // 更新当前页全选状态
  syncProductSelectAllByCurrentPage()
}

// 单选物料（物控汇总）
const handleSelectMaterial = (item: any) => {
  const index = selectedMaterials.value.indexOf(item.id)
  if (index > -1) {
    selectedMaterials.value.splice(index, 1)
    const detailIndex = selectedMaterialDetails.value.findIndex((m: any) => m.id === item.id)
    if (detailIndex > -1) selectedMaterialDetails.value.splice(detailIndex, 1)
  } else {
    selectedMaterials.value.push(item.id)
    selectedMaterialDetails.value.push({
      ...item,
      materialCount: item.materialCount || null,
      purchasePrice: null,
    })
  }

  // 更新全选状态
  isSelectAll.value = selectedMaterials.value.length === materialControlSummaryList.value.length
}

// 全选/取消全选（常规材料）
const handleFactorySelectAll = () => {
  if (isFactorySelectAll.value) {
    // 使用 index 作为标识符
    selectedFactoryMaterials.value = mergeProductionBomItems.value.map((_, index) => index)
    // 全选时，将所有物料添加到 selectedMaterialDetails
    selectedMaterialDetails.value = mergeProductionBomItems.value.map((item, index) => ({
      ...item,
      _selectedIndex: index,
      _originalMaterialUnit: item.unit, // 记录原始单位值
      materialCount: item.quantity || null,
      purchasePrice: null,
    }))
  } else {
    selectedFactoryMaterials.value = []
    selectedMaterialDetails.value = []
  }
  // 计算总金额
  calculatePurchaseTotalAmount()
}

// 全选/取消全选（常规材料汇总）
const handleFactorySummarySelectAll = () => {
  if (isFactorySelectAll.value) {
    // 使用 index 作为标识符
    selectedFactoryMaterials.value = mergeProductionBomSummaryItems.value.map((_, index) => index)
    // 全选时，将所有物料添加到 selectedMaterialDetails
    selectedMaterialDetails.value = mergeProductionBomSummaryItems.value.map((item, index) => ({
      ...item,
      _selectedIndex: index,
      _originalMaterialUnit: item.unit,
      materialCount: item.totalUsage || item.totalUsageWithProductCount || null,
      purchasePrice: null,
    }))
  } else {
    selectedFactoryMaterials.value = []
    selectedMaterialDetails.value = []
  }
  // 计算总金额
  calculatePurchaseTotalAmount()
}

// 单选物料（料单汇总）
const handleSelectFactoryMaterial = (item: any) => {
  const index = selectedFactoryMaterials.value.indexOf(item.id)
  if (index > -1) {
    selectedFactoryMaterials.value.splice(index, 1)
  } else {
    selectedFactoryMaterials.value.push(item.id)
  }
  // 更新全选状态
  isFactorySelectAll.value = selectedFactoryMaterials.value.length === materialSummaryList.value.length
}

// 单选物料（常规材料）
const handleChooseFactoryMaterial = (item: any, itemIndex: number) => {
  console.log('handleChooseFactoryMaterial', item, itemIndex)
  const idx = selectedFactoryMaterials.value.indexOf(itemIndex)
  if (idx > -1) {
    selectedFactoryMaterials.value.splice(idx, 1)
    // 从 selectedMaterialDetails 中移除（使用 _selectedIndex 标识）
    const detailIndex = selectedMaterialDetails.value.findIndex((m: any) => m._selectedIndex === itemIndex)
    if (detailIndex > -1) {
      selectedMaterialDetails.value.splice(detailIndex, 1)
    }
  } else {
    selectedFactoryMaterials.value.push(itemIndex)
    // 添加到 selectedMaterialDetails，附加 _selectedIndex 用于后续查找
    selectedMaterialDetails.value.push({
      ...item,
      _selectedIndex: itemIndex,
      _originalMaterialUnit: item.unit, // 记录原始单位值
      materialCount: item.quantity|| null,
      purchasePrice: null,
    })
  }
  // 更新全选状态
  isFactorySelectAll.value = selectedFactoryMaterials.value.length === mergeProductionBomItems.value.length
  // 计算总金额
  calculatePurchaseTotalAmount()
}

const buildFactorySummaryKey = (item: any, productItem?: any) => {
  const bomKey = item?.bomKey ?? ''
  const batch = productItem?.product?.batch ?? productItem?.batch ?? ''
  return `${bomKey}_${batch}`
}

// 单选物料（常规材料汇总）
const handleChooseFactorySummaryMaterial = (item: any, itemIndex: number, productItem?: any) => {
  const key = buildFactorySummaryKey(item, productItem)
  const idx = selectedFactoryMaterials.value.indexOf(key)
  if (idx > -1) {
    selectedFactoryMaterials.value.splice(idx, 1)
    const detailIndex = selectedMaterialDetails.value.findIndex((m: any) => m._selectedKey === key)
    if (detailIndex > -1) {
      selectedMaterialDetails.value.splice(detailIndex, 1)
    }
  } else {
    selectedFactoryMaterials.value.push(key)
    selectedMaterialDetails.value.push({
      ...item,
      _selectedKey: key,
      _originalMaterialUnit: item.unit,
      materialCount: item.totalUsage || item.totalUsageWithProductCount || null,
      purchasePrice: null,
    })
  }
  isFactorySelectAll.value = selectedFactoryMaterials.value.length === mergeProductionBomSummaryItems.value.length
  calculatePurchaseTotalAmount()
}

// 定制&五金发起采购
const handleToFactoryPurchaseHardware = () => {
  showFactoryChoosePurchaseHardware.value = true
  selectedHardwareMaterials.value = []
  isHardwareSelectAll.value = false
  selectedMaterialDetails.value = []
}

const normalizeSpecForRequisitionItem = (row: any) => {
  return (
    row?.materialSpec ??
    row?.specDesc ??
    row?.materialDescriptionMerge ??
    row?.materialDescription ??
    row?.specification ??
    row?.materialSpecConfirmed ??
    ''
  )
}

const normalizeUnitForRequisitionItem = (row: any) => {
  return row?.unit ?? row?.materialUnit ?? row?.materialUnitConfirmed ?? ''
}

/** 定制&五金：与列表「尺寸」列一致，拼成 W/D/H 文案写入采购备注 */
const buildHardwareSizeRemarkForPurchase = (row: any): string => {
  const parts: string[] = []
  if (row?.remark) parts.push(`${row.remark}`)
  if (row?.width != null && row?.width !== '') parts.push(`W:${row.width}`)
  if (row?.depth != null && row?.depth !== '') parts.push(`D:${row.depth}`)
  if (row?.height != null && row?.height !== '') parts.push(`H:${row.height}`)
  return parts.join(' ')
}

const buildTempRequisitionForPurchaseDialog = (entry: PurchaseEntryKey) => {
  const itemType = purchaseEntryConfig[entry].defaultItemType

  let rows: any[] = []
  if (entry === 'estimate') {
    if (selectedMaterials.value.length === 0) {
      showError('请至少选择一个物料')
      return null
    }
    rows = materialControlSummaryList.value.filter((it: any) => selectedMaterials.value.includes(it.id))
  } else if (entry === 'product') {
    if (selectedProducts.value.length === 0) {
      showError('请至少选择一个成品')
      return null
    }
    rows = selectedProductDetails.value.length > 0
      ? [...selectedProductDetails.value]
      : productionOrderList.value.filter((it: any) => selectedProducts.value.includes(it.id))
  } else {
    // 常规材料 / 定制&五金：选择时已实时维护 selectedMaterialDetails
    if (selectedMaterialDetails.value.length === 0) {
      showError('请至少选择一个物料')
      return null
    }
    rows = [...selectedMaterialDetails.value]
  }

  const isProductEntry = entry === 'product'
  const isFactoryHardware = entry === 'factoryHardware'
  const items = rows.map((row: any, idx: number) => ({
    id: row?.id ?? idx + 1,
    requisitionId: null,
    materialCode: row?.materialCode ?? row?.code ?? '',
    contractCode: row?.contractCode,
    materialName: row?.materialName ?? row?.partName ?? row?.name ?? row?.nameShort ??  '',
    materialSpec: normalizeSpecForRequisitionItem(row),
    unit: isProductEntry ? 'PCS' : normalizeUnitForRequisitionItem(row),
    materialTotalCount: row.productUsageSum || null,
    _originalMaterialUnit: isProductEntry ? 'PCS' : normalizeUnitForRequisitionItem(row),
    brand: row?.brand ?? '',
    quantity:
      row?.materialCount ??
      row?.purchaseQuantity ??
      row?.totalUsageWithProductCount ??
      row?.quantity ??
      row?.count ??
      null,
    remark: isFactoryHardware
      ? (buildHardwareSizeRemarkForPurchase(row) || (row?.remark ?? row?.materialRemark ?? ''))
      : (row?.remark ?? row?.materialRemark ?? ''),
    plannedDeliveryDate: row?.plannedDeliveryDate ?? '',
    warehouseNo: row?.warehouseNo ?? '',
    warehouseName: row?.warehouseName ?? '',
    batch: row?.batch,
    syscode: row?.syscode,
    type: isProductEntry ? 1 : row?.type,
    itemType: row?.itemType ?? itemType,
    materialRemark: row?.materialRemark,
    materialType: row?.materialType,
    bigClass: row?.bigClass,
    smallClass: row?.smallClass,
    bomKey: row?.bomKey,
    partName: row?.partName,
    productCodes: row?.productCodes || [],
  }))

  return {
    id: null,
    requisitionNo: '',
    warehouseNo: '',
    warehouseName: '',
    items,
    /** 采购弹窗内用于区分入口：常规材料列表发起时关联产品列用图标 + 悬浮展示 */
    _purchaseEntry: entry,
  }
}

const openPurchaseDialogByEntry = (entry: PurchaseEntryKey) => {
  const temp = buildTempRequisitionForPurchaseDialog(entry)
  console.log('temp', temp)
  if (!temp) return
  purchaseDialogRef.value?.openForRequisition(temp, -1)
}

// 全选/取消全选（定制&五金）
const handleHardwareSelectAll = () => {
  if (isHardwareSelectAll.value) {
    // 使用 index 作为标识符
    selectedHardwareMaterials.value = mergeProductionWareMetalItems.value.map((_, index) => index)
    // 全选时，将所有物料添加到 selectedMaterialDetails
    selectedMaterialDetails.value = mergeProductionWareMetalItems.value.map((item, index) => ({
      ...item,
      _selectedIndex: index,
      _originalMaterialUnit: item.unit, // 记录原始单位值
      purchaseQuantity: item.totalUsageWithProductCount || null,
      // materialCount: item.quantity || null,
      materialCount: item.productUsageSum || null,
      purchasePrice: null,
    }))
  } else {
    selectedHardwareMaterials.value = []
    selectedMaterialDetails.value = []
  }
  // 计算总金额
  calculatePurchaseTotalAmount()
}

// 单选物料（定制&五金 - 料单汇总风格）
const handleSelectHardwareMaterial = (item: any, itemIndex: number) => {
  const idx = selectedHardwareMaterials.value.indexOf(itemIndex)
  if (idx > -1) {
    selectedHardwareMaterials.value.splice(idx, 1)
  } else {
    selectedHardwareMaterials.value.push(itemIndex)
  }
  
  // 更新全选状态
  isHardwareSelectAll.value = selectedHardwareMaterials.value.length === materialSummaryHardwareList.value.length
}

const handleChooseHardwareMaterial = (item: any, itemIndex: number) => {
  console.log('handleChooseHardwareMaterial', item, itemIndex)
  const idx = selectedHardwareMaterials.value.indexOf(itemIndex)
  if (idx > -1) {
    selectedHardwareMaterials.value.splice(idx, 1)
    // 从 selectedMaterialDetails 中移除（使用 _selectedIndex 标识）
    const detailIndex = selectedMaterialDetails.value.findIndex((m: any) => m._selectedIndex === itemIndex)
    if (detailIndex > -1) {
      selectedMaterialDetails.value.splice(detailIndex, 1)
    }
  } else {
    selectedHardwareMaterials.value.push(itemIndex)
    // 添加到 selectedMaterialDetails，附加 _selectedIndex 用于后续查找
    selectedMaterialDetails.value.push({
      ...item,
      _selectedIndex: itemIndex,
      _originalMaterialUnit: item.unit, // 记录原始单位值
      materialCount: item.quantity || null,
      purchasePrice: null,
    })
  }
  // 更新全选状态
  isHardwareSelectAll.value = selectedHardwareMaterials.value.length === mergeProductionWareMetalItems.value.length
  // 计算总金额
  calculatePurchaseTotalAmount()
}

const buildHardwareSummaryKey = (item: any, productItem?: any) => {
  const bomKey = item?.bomKey ?? ''
  // 优先取 productItem.product.batch，其次取 productItem.batch，最后为空字符串
  const batch = productItem?.product?.batch ?? productItem?.batch ?? ''
  return `${bomKey}_${batch}`
}

// 单选物料（定制&五金汇总）
const handleChooseHardwareSummaryMaterial = (item: any, itemIndex: number, productItem?: any) => {
  const key = buildHardwareSummaryKey(item, productItem)
  const idx = selectedHardwareMaterials.value.indexOf(key)
  if (idx > -1) {
    selectedHardwareMaterials.value.splice(idx, 1)
    const detailIndex = selectedMaterialDetails.value.findIndex((m: any) => m._selectedKey === key)
    if (detailIndex > -1) {
      selectedMaterialDetails.value.splice(detailIndex, 1)
    }
  } else {
    selectedHardwareMaterials.value.push(key)
    selectedMaterialDetails.value.push({
      ...item,
      _selectedKey: key,
      _originalMaterialUnit: item.unit,
      // 定制&五金汇总：使用汇总用量作为默认采购数量
      materialCount: item.totalUsage || item.totalUsageWithProductCount || null,
      purchasePrice: null,
    })
  }
  // 这里不使用 isHardwareSelectAll 更新逻辑，避免和明细表全选冲突
  calculatePurchaseTotalAmount()
}

// 采购弹窗提交成功（新 PurchaseDialog）
const handlePurchaseSuccessFromDialog = async () => {
  resetMaterialSummary()
  // 刷新常规材料 / 定制&五金汇总与合同下采购单
  await loadMaterialSummaryMerge()
  await loadMetalSummaryMerge()
  await loadPurchaseListContract()
}

function handleAddPurchaseItemsSuccess() {
  loadMaterialSummaryMerge()
  loadMetalSummaryMerge()
  loadWuliaoList()
  loadProductionOrderList()
}

function handleAddPurchase() {
  if (titleList.value[0].isChoosed && !showProductChoosePurchase.value) {
    showProductChoosePurchase.value = true
    showChoosePurchase.value = false
    showFactoryChoosePurchase.value = false
    showFactoryChoosePurchaseHardware.value = false
    currentChooseAction.value = 'add'
    selectedProducts.value = []
    selectedProductDetails.value = []
    isProductSelectAll.value = false
    return
  }
  if (titleList.value[1].isChoosed && !showChoosePurchase.value) {
    showChoosePurchase.value = true
    showProductChoosePurchase.value = false
    showFactoryChoosePurchase.value = false
    showFactoryChoosePurchaseHardware.value = false
    currentChooseAction.value = 'add'
    selectedMaterials.value = []
    selectedMaterialDetails.value = []
    isSelectAll.value = false
    return
  }
  if (titleList.value[2].isChoosed && !showFactoryChoosePurchase.value) {
    showFactoryChoosePurchase.value = true
    showChoosePurchase.value = false
    showProductChoosePurchase.value = false
    showFactoryChoosePurchaseHardware.value = false
    currentChooseAction.value = 'add'
    selectedFactoryMaterials.value = []
    selectedMaterialDetails.value = []
    isFactorySelectAll.value = false
    return
  }
  if (titleList.value[3].isChoosed && !showFactoryChoosePurchaseHardware.value) {
    showFactoryChoosePurchaseHardware.value = true
    showChoosePurchase.value = false
    showProductChoosePurchase.value = false
    showFactoryChoosePurchase.value = false
    currentChooseAction.value = 'add'
    selectedHardwareMaterials.value = []
    selectedMaterialDetails.value = []
    isHardwareSelectAll.value = false
    return
  }
  if (currentChooseAction.value !== 'add') {
    showError('当前为直接采购选择状态，请先完成或切换')
    return
  }

  let rows: any[] = []
  if (titleList.value[0].isChoosed) {
    rows = selectedProductDetails.value.length > 0
      ? [...selectedProductDetails.value]
      : productionOrderList.value.filter((it: any) => selectedProducts.value.includes(it.id))
    rows = rows.map((row: any) => ({
      ...row,
      materialCode: row.code || '',
      materialName: row.name || row.nameShort || '',
      materialSpec: '',
      unit: 'PCS',
      materialUnit: 'PCS',
      materialCount: row.productUsageSum ?? row.materialCount ?? row.count ?? '',
      contractCode: row.contractCode || '',
      batch: row.batch || '',
      syscode: row.syscode || '',
      type: 1,
      itemType: 2,
      purchaseItemType: 1,
    }))
  } else if (titleList.value[1].isChoosed) {
    rows = selectedMaterialDetails.value.length > 0
      ? [...selectedMaterialDetails.value]
      : materialControlSummaryList.value.filter((it: any) => selectedMaterials.value.includes(it.id))
    rows = rows.map((row: any) => ({
      ...row,
      itemType: 1,
      purchaseItemType: 0,
      materialCount: row.productUsageSum ?? row.materialCount ?? row.count ?? '',
    }))
  } else if (titleList.value[2].isChoosed) {
    rows = selectedMaterialDetails.value.map((row: any) => ({
      ...row,
      itemType: 1,
      purchaseItemType: 0,
      materialCount: row.productUsageSum ?? row.materialCount ?? row.count ?? '',
    }))
  } else {
    rows = selectedMaterialDetails.value.map((row: any) => ({
      ...row,
      itemType: 0,
      purchaseItemType: 0,
      materialCount: row.productUsageSum ?? row.materialCount ?? row.count ?? '',
      remark: buildHardwareSizeRemarkForPurchase(row) || (row?.remark ?? row?.materialRemark ?? ''),
    }))
  }

  if (!rows.length) {
    showError('请至少选择一个物料')
    return
  }

  addPurchaseDialogRows.value = rows
  showChoosePurchase.value = false
  showProductChoosePurchase.value = false
  showFactoryChoosePurchase.value = false
  showFactoryChoosePurchaseHardware.value = false
  selectedMaterials.value = []
  selectedProducts.value = []
  selectedProductDetails.value = []
  selectedFactoryMaterials.value = []
  selectedHardwareMaterials.value = []
  selectedMaterialDetails.value = []
  isSelectAll.value = false
  isProductSelectAll.value = false
  isFactorySelectAll.value = false
  isHardwareSelectAll.value = false
  currentChooseAction.value = ''
  showAddPurchaseItemDialog.value = true
}

function handleDirectPurchase() {
  if (titleList.value[0].isChoosed && !showProductChoosePurchase.value) {
    showProductChoosePurchase.value = true
    showChoosePurchase.value = false
    showFactoryChoosePurchase.value = false
    showFactoryChoosePurchaseHardware.value = false
    currentChooseAction.value = 'direct'
    selectedProducts.value = []
    selectedProductDetails.value = []
    isProductSelectAll.value = false
    return
  }
  if (titleList.value[1].isChoosed && !showChoosePurchase.value) {
    showChoosePurchase.value = true
    showProductChoosePurchase.value = false
    showFactoryChoosePurchase.value = false
    showFactoryChoosePurchaseHardware.value = false
    currentChooseAction.value = 'direct'
    selectedMaterials.value = []
    selectedMaterialDetails.value = []
    isSelectAll.value = false
    return
  }
  if (titleList.value[2].isChoosed && !showFactoryChoosePurchase.value) {
    showFactoryChoosePurchase.value = true
    showChoosePurchase.value = false
    showProductChoosePurchase.value = false
    showFactoryChoosePurchaseHardware.value = false
    currentChooseAction.value = 'direct'
    selectedFactoryMaterials.value = []
    selectedMaterialDetails.value = []
    isFactorySelectAll.value = false
    return
  }
  if (titleList.value[3].isChoosed && !showFactoryChoosePurchaseHardware.value) {
    showFactoryChoosePurchaseHardware.value = true
    showChoosePurchase.value = false
    showProductChoosePurchase.value = false
    showFactoryChoosePurchase.value = false
    currentChooseAction.value = 'direct'
    selectedHardwareMaterials.value = []
    selectedMaterialDetails.value = []
    isHardwareSelectAll.value = false
    return
  }
  if (currentChooseAction.value !== 'direct') {
    showError('当前为加采购项选择状态，请先完成或切换')
    return
  }
  const entry: PurchaseEntryKey = titleList.value[0].isChoosed
    ? 'product'
    : titleList.value[1].isChoosed
    ? 'estimate'
    : titleList.value[2].isChoosed
    ? 'factoryMaterial'
    : 'factoryHardware'
  const temp = buildTempRequisitionForPurchaseDialog(entry)
  if (!temp) return
  purchaseDialogRef.value?.openForRequisition(temp, -1)
}

function handleCancelPurchase() {
  showChoosePurchase.value = false
  showProductChoosePurchase.value = false
  showFactoryChoosePurchase.value = false
  showFactoryChoosePurchaseHardware.value = false
  currentChooseAction.value = ''
  selectedMaterials.value = []
  selectedProducts.value = []
  selectedProductDetails.value = []
  selectedFactoryMaterials.value = []
  selectedHardwareMaterials.value = []
  selectedMaterialDetails.value = []
  isSelectAll.value = false
  isProductSelectAll.value = false
  isFactorySelectAll.value = false
  isHardwareSelectAll.value = false
}

function startDirectPurchase() {
  currentChooseAction.value = 'direct'
  if (titleList.value[0].isChoosed) {
    showProductChoosePurchase.value = true
    showChoosePurchase.value = false
    showFactoryChoosePurchase.value = false
    showFactoryChoosePurchaseHardware.value = false
  } else if (titleList.value[1].isChoosed) {
    showChoosePurchase.value = true
    showProductChoosePurchase.value = false
    showFactoryChoosePurchase.value = false
    showFactoryChoosePurchaseHardware.value = false
  } else if (titleList.value[2].isChoosed) {
    showFactoryChoosePurchase.value = true
    showChoosePurchase.value = false
    showProductChoosePurchase.value = false
    showFactoryChoosePurchaseHardware.value = false
  } else if (titleList.value[3].isChoosed) {
    showFactoryChoosePurchaseHardware.value = true
    showChoosePurchase.value = false
    showProductChoosePurchase.value = false
    showFactoryChoosePurchase.value = false
  }
}

function startAddPurchase() {
  currentChooseAction.value = 'add'
  if (titleList.value[0].isChoosed) {
    showProductChoosePurchase.value = true
    showChoosePurchase.value = false
    showFactoryChoosePurchase.value = false
    showFactoryChoosePurchaseHardware.value = false
  } else if (titleList.value[1].isChoosed) {
    showChoosePurchase.value = true
    showProductChoosePurchase.value = false
    showFactoryChoosePurchase.value = false
    showFactoryChoosePurchaseHardware.value = false
  } else if (titleList.value[2].isChoosed) {
    showFactoryChoosePurchase.value = true
    showChoosePurchase.value = false
    showProductChoosePurchase.value = false
    showFactoryChoosePurchaseHardware.value = false
  } else if (titleList.value[3].isChoosed) {
    showFactoryChoosePurchaseHardware.value = true
    showChoosePurchase.value = false
    showProductChoosePurchase.value = false
    showFactoryChoosePurchase.value = false
  }
}

// 重置采购数据为默认值
const resetPurchaseData = () => {
  purchaseData.value = {
    vendor: null,
    quantity: null,
    price: null,
    purchaseOrderNo: null,
    paymentMethod: {value: '0', label: '预付'},
    paymentCompany: null,
    paymentDate: null,
    id: null,
    totalAmount: 0,
    tax: {value: "0", label: "不含税"},
    taxRate: {value: "0", label: "0%"},
    taxAmount: 0,
    totalAmountWithTax: 0,
    warehouse: {warehouseNo: '', warehouseName: ''} as any,
    purchaseStandard: null,
    remark: '1、贵公司提供产品保质期最少不得低于二年\n2、凡因供货厂商质量上与我司要求标准有所差异造成的后果，除扣除货款之外还需要负起我司其它之一切损失\n3、供货厂商未依规定期间交货，若因此造成我司所有经济及其名誉上的损失，我司将追究一切之责任\n4、收到清单请及时确认交货期并回传\n5、每周六提供所有订单的交货排程',
  }
  materialDateInputRefs.value = {}
  currentPurchaseIndex.value = -1
  vendorSearchText.value = ''
}

const getMaterialInfo = async(materialCode: string) => {
  const res = await purchaseApi.purchaseProductQuantityInfo({
    materialCodes: materialCode,
    warehouseNo: purchaseData.value.warehouse.warehouseNo
  })
  if (res?.code === 0 && res.data) {
    selectedMaterialDetails.value.forEach((item: any) => {
      if(res.data.find((m: any) => m.materialCode === item.materialCode)){
        const temp = res.data.find((m: any) => m.materialCode === item.materialCode)
        item.bomEstimate = temp.bomEstimate
        item.bomEstimateUnit = temp.bomEstimateUnit
        item.inventory = temp.inventory
        item.inventoryUnit = temp.inventoryUnit
        item.purchasing = temp.purchasing
        item.purchasingUnit = temp.purchasingUnit
        item.materialPrice = temp.price
      }
    })
  }
}

// 处理送货地址变化
const handleWarehouseChange = async () => {
  // 检查是否已选择送货地址且有选中的物料
  if (purchaseData.value.warehouse && selectedMaterialDetails.value.length > 0) {
    // 收集所有物料的 materialCode
    const materialCodes = selectedMaterialDetails.value
      .map((item: any) => item.materialCode)
      .filter((code: string) => code) // 过滤掉空值
      .join(',')
    
    if (materialCodes) {
      await getMaterialInfo(materialCodes)
    }
  }
}

// 定制&五金创建采购单
const handleCreatePurchaseHardware = async() => {
  // 新流程：统一走 PurchaseDialog 组件
  openPurchaseDialogByEntry('factoryHardware')
}

// 成品创建采购单（生产单 -> 采购）
const handleCreateProductPurchase = async() => {
  // 新流程：成品统一走 PurchaseDialog，物料类型为成品
  openPurchaseDialogByEntry('product')
}

// 保留旧流程代码（不删除），如需回滚可重新挂回按钮
const handleCreatePurchaseHardwareLegacy = async() => {
  if (selectedHardwareMaterials.value.length === 0) {
    showError('请至少选择一个物料')
    return
  }
  resetPurchaseData()
  selectedMaterialDetails.value.forEach((item: any) => {
    if(!item.specDesc){
      item.specDesc = item.materialSpec
    }
    if(!item.materialName){
      item.materialName = item.partName
    }
  })
  showPurchaseDialog.value = true
  console.log('selectedMaterialDetails', selectedMaterialDetails.value)
}

// 打开采购弹窗
const handleCreatePurchase = async() => {
  // 新流程：物控汇总 / 常规材料统一走 PurchaseDialog
  const entry: PurchaseEntryKey = titleList.value[1].isChoosed ? 'estimate' : 'factoryMaterial'
  openPurchaseDialogByEntry(entry)
}

// 保留旧流程代码（不删除），如需回滚可重新挂回按钮
const handleCreatePurchaseLegacy = async() => {
  // 物控汇总
  const isEstimate = titleList.value[1].isChoosed
  // 生产单
  const isFactory = titleList.value[0].isChoosed
  console.log('selectedMaterials.value', selectedMaterials.value)
  if (isEstimate) {
    if (selectedMaterials.value.length === 0) {
      showError('请至少选择一个物料')
      return
    }
    selectedMaterialDetails.value = materialControlSummaryList.value
      .filter(item => selectedMaterials.value.includes(item.id))
      .map((item: any) => ({
        ...item,
        _originalMaterialUnit: item.unit,
        purchaseQuantity: item.materialCount || null,
        purchasePrice: item.materialPrice || null,
      }))
    calculatePurchaseTotalAmount()
  } else if (isFactory) {
    if (selectedFactoryMaterials.value.length === 0) {
      showError('请至少选择一个物料')
      return
    }
  }
  resetPurchaseData()
  selectedMaterialDetails.value.forEach((item: any) => {
    if(!item.materialName){
      item.materialName = item.partName
    }
    if(!item.specDesc){
      item.specDesc = item.materialSpec
    }
    if(!item.unit && isEstimate){
      item.unit = item.materialUnit
    }
  })
  console.log('selectedMaterialDetails', selectedMaterialDetails.value)
  showPurchaseDialog.value = true
}

// 关闭采购弹窗
const closePurchaseDialog = () => {
  showPurchaseDialog.value = false
  // 重置采购数据
  resetPurchaseData()

  showChoosePurchase.value = false
  showFactoryChoosePurchase.value = false
  showFactoryChoosePurchaseHardware.value = false
  showProductChoosePurchase.value = false
  currentChooseAction.value = ''
  selectedMaterials.value = []
  isSelectAll.value = false
  selectedProducts.value = []
  selectedProductDetails.value = []
  isProductSelectAll.value = false
  selectedFactoryMaterials.value = []
  isFactorySelectAll.value = false
  selectedHardwareMaterials.value = []
  isHardwareSelectAll.value = false
  selectedMaterialDetails.value = []
}

// 加载供应商列表
const loadVendorList = async () => {
  if(vendorSearchText.value === '' || vendorSearchText.value === null){
    return
  }
  try {
    vendorLoading.value = true
    const res = await purchaseApi.vendorList({
      page: 1,
      pageSize: 1000,
      keyword: vendorSearchText.value || ''
    })
    if (res?.code === 0 && res.data) {
      vendorList.value = res.data.records
      console.log('vendorList', vendorList.value)
    }
  } catch (error: any) {
    console.error('加载供应商列表失败:', error)
    showError(error.message || '加载供应商列表失败')
  } finally {
    vendorLoading.value = false
  }
}

// 合同下的采购单
const loadPurchaseListContract = async () => {
  loadingPurchaseSummary.value = true
  try {
    const res = await purchaseApi.purchaseListContract({
      contractId: contractId.value,
      page: 1,
      pageSize: 100
    })
    if (res?.code === 0 && res.data) {
      purchaseSummaryList.value = res.data.records
      console.log('purchaseSummaryList', purchaseSummaryList.value)
    }
  } catch (error: any) {
    console.error('加载合同下的采购单失败:', error)
    showError(error.message || '加载合同下的采购单失败')
  } finally {
    loadingPurchaseSummary.value = false
  }
}
// 监听供应商搜索文本变化
const vendorSearchDebounce = (() => {
  let timer: number | null = null
  
  return () => {
    if (timer) {
      clearTimeout(timer)
    }
    
    timer = setTimeout(() => {
      loadVendorList()
      timer = null
    }, 300)
  }
})()

// 监听vendorSearchText变化
watch(vendorSearchText, () => {
  if(purchaseData.value.id !== null || vendorSearchText.value === ''){
    return
  }
  vendorSearchDebounce()
})

// 编辑采购
// const handleEditPurchase = (item: any, index: number) => {
//   console.log('item', item)
//   if(item.paymentApplyTime !== null && item.paymentApplyTime > 0) {
//     showError('已有付款申请，无法修改')
//     return
//   }
//   showPurchaseDialog.value = true
//   purchaseData.value = {
//     vendor: {
//       id: item.vendorId,
//       companyName: item.supplierName
//     },
//     quantity: item.quantity,
//     price: item.price,
//     purchaseOrderNo: item.purchaseOrderNo,
//     paymentMethod: getPaymentMethod(item.paymentType) || null,
//     paymentDate: formatDateForNativeInput(item.schDate) || null,
//     id: item.id,
//     totalAmount: 0
//   }
//   vendorList.value = []
//   currentPurchaseIndex.value = index
// }

// 提交采购
const submitPurchase = async () => {
  console.log('purchaseData', purchaseData.value)
  if(!purchaseData.value.vendor) {
    showError('请选择供应商')
    return
  }
  if(purchaseData.value.paymentCompany === '' || purchaseData.value.paymentCompany === null) {
    showError('请选择付款公司')
    return
  }
  if(purchaseData.value.warehouse.warehouseNo === '' || purchaseData.value.warehouse.warehouseNo === null) {
    showError('请选择送货地址')
    return
  }
  for(let i = 0; i<selectedMaterialDetails.value.length;i++){
    if(selectedMaterialDetails.value[i].materialCount == null || selectedMaterialDetails.value[i].materialCount === '' || selectedMaterialDetails.value[i].materialCount <= 0){
      showError('请输入物料数量')
      return
    }
    if(selectedMaterialDetails.value[i].materialPrice == null || selectedMaterialDetails.value[i].materialPrice === '' || selectedMaterialDetails.value[i].materialPrice <= 0){
      showError('请输入物料单价')
      return
    }
    if(selectedMaterialDetails.value[i].unit == null || selectedMaterialDetails.value[i].unit === ''){
      showError('请选择物料单位')
      return
    }
  }
  let tempMaterialList = selectedMaterialDetails.value
  let materialList = []
  for(let i = 0; i<tempMaterialList.length;i++){
    materialList.push({
      materialCode: tempMaterialList[i].materialCode,
      quantity: tempMaterialList[i].materialCount,
      price: tempMaterialList[i].materialPrice,
      remark: tempMaterialList[i].remark,
      brand: tempMaterialList[i].brand,
      materialName: tempMaterialList[i].materialName,
      specDesc: tempMaterialList[i].specDesc,
      materialRemark: tempMaterialList[i].materialRemark,
      materialUnit: tempMaterialList[i].unit,
      materialType: tempMaterialList[i].materialType,
      bigClass: tempMaterialList[i].bigClass,
      smallClass: tempMaterialList[i].smallClass,
      plannedDeliveryDate: tempMaterialList[i].plannedDeliveryDate,
      bomEstimate: tempMaterialList[i].bomEstimate,
      bomEstimateUnit: tempMaterialList[i].bomEstimateUnit,
      inventory: tempMaterialList[i].inventory,
      inventoryUnit: tempMaterialList[i].inventoryUnit,
      purchasing: tempMaterialList[i].purchasing,
      purchasingUnit: tempMaterialList[i].purchasingUnit,
      // plannedDeliveryDate: dateTimestamp(tempMaterialList[i].plannedDeliveryDate),
    })
  }
  try {
    purchaseLoading.value = true
    const submitData = {
      contractId: Number(contractId.value),
      // id: purchaseData.value.id && purchaseData.value.id != null ? purchaseData.value.id : null,
      vendorId: purchaseData.value.vendor?.id,
      warehouseNo: purchaseData.value.warehouse?.warehouseNo,
      warehouseName: purchaseData.value.warehouse?.warehouseName,
      paymentCompany: purchaseData.value.paymentCompany.value,
      totalAmount: purchaseData.value.totalAmount,
      taxAmount: purchaseData.value.taxAmount,
      totalAmountWithTax: purchaseData.value.totalAmountWithTax,
      tax: purchaseData.value.tax.value,
      taxRate: purchaseData.value.taxRate.value,
      purchaseStandard: purchaseData.value.purchaseStandard,
      materialList: materialList,
      // quantity: purchaseData.value.quantity,
      // price: purchaseData.value.price,
      // contractId: productInfo.value?.contract?.id,
      // materialCode: materialInfo.value?.materialCode,
      schDate: dateTimestamp(purchaseData.value.paymentDate),
      paymentType: typeof(purchaseData.value.paymentMethod) === 'string' ? purchaseData.value.paymentMethod : purchaseData.value.paymentMethod.value,
      remark: purchaseData.value.remark || ''
    }
    console.log('submitData', submitData)
    const res = await purchaseApi.purchaseInitiate(submitData)
    if (res?.code === 0) {
      showSuccess(purchaseData.value.id ? '采购单修改成功' : '采购单创建成功')
      console.log('采购数据:', submitData)
      // let newPurchaseOrder = {
      //   id: res.data.id,
      //   createTime: res.data.createTime,
      //   purchaseOrderNo: res.data.purchaseOrderNo,
      //   supplierName: res.data.supplierName,
      //   guardStatus: res.data.guardStatus,
      //   warehouseStatus: res.data.warehouseStatus,
      //   qualityStatus: res.data.qualityStatus,
      //   vendorId: res.data.vendorId,
      //   quantity: purchaseData.value.quantity,
      //   price: purchaseData.value.price,
      //   schDate: purchaseData.value.paymentDate,
      //   paymentType: getPaymentMethod(res.data.paymentType),
      //   paymentMethod: getPaymentMethod(res.data.paymentType)
      // }
      // console.log('newPurchaseOrder', newPurchaseOrder,currentPurchaseIndex.value)
      // if(currentPurchaseIndex.value != -1){
      //   productInfo.value.purchaseOrders[currentPurchaseIndex.value] = newPurchaseOrder
      // }else{
      //   // productInfo.value.purchaseOrders.push(newPurchaseOrder)
      //   productInfo.value.purchaseOrders.unshift(newPurchaseOrder)
      // }
      closePurchaseDialog()
    } else {
      showError(res?.message)
    }
    // 刷新采购列表
    // await loadPurchaseList()
    
  } catch (error: any) {
    console.error('创建采购单失败:', error)
    showError(error.message || '创建采购单失败')
  } finally {
    purchaseLoading.value = false
  }
}

// 获取仓库列表
const getWarehouseList = async () => {
  const res = await goodsManageApi.getWarehouseList()
  console.log('res',res)
  if(res.code === 0 && res.data){
    warehouseList.value = res.data
  }else{
    warehouseList.value = []
  }
}
// 初始化
onMounted(async () => {
  loadWarehouseList()
  // 页面进入时滚动到顶部
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
  contractId.value = Number(route.query.productCode)
  isEdit.value = route.query.mode as 'edit' | 'estimate' | 'see' | 'materialControl' | 'new'
  // if (isEdit.value === 'edit' || isEdit.value === 'estimate') {

  // }else{
  //   materialHeaders.splice(-1, 1)
  // }
  loadContractInfo()
  loadProductionOrderList()
  // 常规材料
  // loadMaterialSummary()
  // 常规材料汇总
  loadMaterialSummaryMerge()
  // 定制&五金汇总
  loadMetalSummaryMerge()
  // 定制&五金
  // loadMaterialSummaryHardware()
  loadWuliaoListFilter()
  // 物控汇总
  loadWuliaoList()
  // 采购单
  loadPurchaseListContract()
  // getWarehouseList()
  // loadProductionBomItems()
  // loadWuliaoSummaryList()
  loadUnitList()
})

// 加载单位列表
const loadUnitList = async () => {
  const res = await contractApi.getUnitList()
  console.log('res',res)
  if(res.code === 0 && res.data){
    unitOptions.value = res.data
  }
}

// 根据大类或小类获取可使用的单位，返回unitOptions下面的unitName
// 没有匹配的返回所有的unitName
const getUnitListByBigClassOrSmallClass = (bigClass: string, smallClass: string) => {
  // const unitList = unitOptions.value.filter((item: any) => item.availableCategories.includes(bigClass) || item.availableCategories.includes(smallClass)).map((item: any) => item.unitName)
  // if(unitList.length === 0){
  //   return unitOptions.value.map((item: any) => item.unitName)
  // }
  // return unitList
  return unitOptions.value.map((item: any) => item.unitName)
}

// 清理滚动监听
onUnmounted(() => {
  // window.removeEventListener('scroll', handleProductInfoScroll)
})

// tab切换
const handleTitleClick = (index: number,title:string) => {
  console.log('handleTitleClick',index,title)
  titleList.value.forEach((item, i) => {
    item.isChoosed = i === index
  })
  showChoosePurchase.value = false
  showFactoryChoosePurchase.value = false
  showFactoryChoosePurchaseHardware.value = false
  showPurchaseDialog.value = false
  showProductChoosePurchase.value = false
  currentChooseAction.value = ''
  selectedMaterials.value = []
  isSelectAll.value = false
  selectedProducts.value = []
  selectedProductDetails.value = []
  isProductSelectAll.value = false
  selectedFactoryMaterials.value = []
  isFactorySelectAll.value = false
  selectedHardwareMaterials.value = []
  isHardwareSelectAll.value = false
  selectedMaterialDetails.value = []
  if (index === 0) {
    // 生产单
    loadProductionOrderList()
  }
  if(index === 4){
    // 采购单
    loadPurchaseListContract()
  }
}


const formatNumber = (num: number) => {
  if(num){
    return num.toLocaleString('en-US')
  } else{
    return '0'
  }
}

// 将日期字符串转换为时间戳（毫秒）
const dateTimestamp = (dateStr: string) => {
  if (!dateStr) return undefined
  try {
    // dateStr 格式: YYYY-MM-DD
    const date = new Date(dateStr)
    // 设置为当天的开始时间（00:00:00）
    date.setHours(0, 0, 0, 0)
    return date.getTime()
  } catch (error) {
    console.error('日期转换失败:', error)
    return undefined
  }
}

// 在组件卸载时清理预览URL
onUnmounted(() => {
  // 确保在组件卸载前清理所有图片预览URL
  materialList.value.forEach(item => {
    if (item.images && Array.isArray(item.images)) {
      item.images.forEach(image => {
        if (image instanceof File) {
          const url = getImagePreviewUrl(image)
          if (url) {
            URL.revokeObjectURL(url)
          }
        }
      })
    }
  })
})


// 在script setup部分添加相关变量和方法
const fileInputs = ref<{ [key: number]: HTMLInputElement }>({})
const uploadLoading = ref(false)
const uploadProgress = ref(0)

// 获取图片预览URL
const getImagePreviewUrl = (file: string | File | { url: string; name: string }) => {
  if (!file) return ''
  try {
    if (typeof file === 'string') {
      return file
    }
    if (file instanceof File) {
      return URL.createObjectURL(file)
    }
    return file.url
  } catch (error) {
    console.error('创建图片预览URL失败:', error)
    return ''
  }
}

// PDF日期格式化
const formatPdfDate = (timestamp: number | string | undefined) => {
  if (!timestamp) return '/'
  const ts = typeof timestamp === 'string' ? parseInt(timestamp) : timestamp
  const date = new Date(ts)
  if (isNaN(date.getTime())) return '/'
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}/${month}/${day}`
}

// PDF数字格式化
const formatPdfNumber = (num: number | string | undefined) => {
  if (num === undefined || num === null) return '0'
  const n = typeof num === 'string' ? parseFloat(num) : num
  if (isNaN(n)) return '0'
  return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

// 获取付款方式文本（PDF用）
const getPaymentMethodLabel = (value: string | undefined) => {
  const method = paymentMethods.find(m => Number(m.value) === Number(value))
  return method ? method.label : '/'
}

// 准备PDF数据
const preparePdfData = async (item: any) => {
  // 获取采购单详情
  const response = await purchaseApi.getPurchaseDetail(item.id)
  
  if (response.code !== 0 || !response.data) {
    throw new Error('获取采购单详情失败')
  }
  
  const purchaseDetail = response.data
  const itemList = response.data.itemList || []
  return {
    pdfData: {
      ...purchaseDetail
    },
    itemList: itemList
  }
}

// 导出采购单PDF
const handleExportMaterialPdf = async (item: any) => {
  try {
    showCommonLoading.value = true
    commonLoadingText.value = '正在导出PDF...'
    isExportingPdf.value = true

    const { pdfData, itemList } = await preparePdfData(item)

    previewPdfData.value = pdfData
    previewItemList.value = itemList
    const ord = previewPdfData.value?.order
    if (ord) {
      ord.warehouseAddress =
        warehouseList.value.find((w) => w.warehouseName === ord.warehouseName)?.warehouseAddress ||
        ord.warehouseAddress ||
        ''
    }
    console.log('previewPdfData', previewPdfData.value)
    await nextTick()

    previewPdfDialog.value = true

    await nextTick()
    await new Promise(resolve => setTimeout(resolve, 300))

    commonLoadingText.value = '正在导出PDF...'

    await exportPdfFromElement()

    previewPdfDialog.value = false
    setTimeout(() => {
      isExportingPdf.value = false
    }, 300)

    showSuccess('PDF导出成功')
  } catch (error: any) {
    console.error('导出PDF失败:', error)
    showError(error.message || '导出PDF失败')
    previewPdfDialog.value = false
    setTimeout(() => {
      isExportingPdf.value = false
    }, 300)
  } finally {
    showCommonLoading.value = false
    commonLoadingText.value = ''
  }
}

// 批量导出生产单PDF（拉取全量数据后导出）
const handleExportProductionOrderPdf = async () => {
  try {
    if (!contractId.value) {
      showError('请先选择项目')
      return
    }

    showCommonLoading.value = true
    commonLoadingText.value = '正在获取生产单数据...'

    // 按当前筛选条件拉取全量数据（不分页）
    const params: any = {
      ignoreFactoryFilter: 1,
      page: 1,
      pageSize: 10000,
      orderBy: 'id',
      sort: 'desc',
      hideRoomNumber: 1,
      contractId: Number(contractId.value)
    }
    if (productionOrderSearchForm.value.typeOf.length > 0) {
      params.typeOf = productionOrderSearchForm.value.typeOf.join(',')
    }
    if (keywordSearchProduct.value) {
      params.keyword = keywordSearchProduct.value
    }
    if (productAreaFilterForm.value.building) {
      params.building = productAreaFilterForm.value.building
    }
    if (productAreaFilterForm.value.roomType) {
      params.roomType = productAreaFilterForm.value.roomType
    }
    if (productAreaFilterForm.value.floor) {
      params.floor = productAreaFilterForm.value.floor
    }
    if (productAreaFilterForm.value.areaRoomType) {
      params.areaRoomType = productAreaFilterForm.value.areaRoomType
    }

    const res = await contractApi.getFactoryProductList(params)

    if (res?.code !== 0 || !res.data?.records?.length) {
      showError(res?.message || '当前条件下没有生产单数据，无法导出')
      return
    }

    // 过滤掉已作废的记录
    const validRecords = res.data.records.filter((item: any) => {
      return Number(item.productionInvalidStatus) !== 1 && Number(item.isDelete) !== 1 && Number(item.count) !== 0
    })

    if (!validRecords.length) {
      showError('当前条件下没有有效的生产单数据，无法导出')
      return
    }

    exportProductionList.value = validRecords.map((item: any) => ({
      area: item.area || '/',
      productionInvalidStatus: Number(item.productionInvalidStatus) || 0,
      description: item.description || '/',
      id: item.id,
      originId: item.originId,
      code: item.code,
      batch: item.batch,
      contractCode: item.contractCode,
      project: item.project,
      syscode: item.syscode,
      nameShort: item.nameShort,
      preProduction: Number(item.preProduction) || 0,
      qtyUpdateNoticeId: item.qtyUpdateNoticeId,
      qtyUpdateOldTotal: item.qtyUpdateOldTotal,
      count: item.count,
      deliveryTime: item.deliveryTime,
      toProductionStatus: Number(item.toProductionStatus) || 0,
      currentType: item.currentType || '',
      salesmanName: item.salesmanName || '/',
      productionAssignTime: item.productionAssignTime,
      productionNode: item.productionNode
        ? (typeof item.productionNode === 'string' ? item.productionNode.split(',') : item.productionNode)
        : [],
      productionBomId: item.productionBomId || null,
      imageUrls: item.imageUrls
        ? (typeof item.imageUrls === 'string' ? JSON.parse(item.imageUrls) : item.imageUrls)
        : [],
      typeOf: item.typeOf || '',
      width: item?.width || '/',
      height: item?.height || '/',
      depth: item?.depth || '/'
    }))

    await pdfExportRef.value?.triggerExport()
  } catch (error: any) {
    console.error('导出生产单PDF失败:', error)
    showError(error?.message || '导出生产单PDF失败')
  } finally {
    showCommonLoading.value = false
    commonLoadingText.value = ''
  }
}

const handleExportFromPreview = async () => {
  try {
    showCommonLoading.value = true
    commonLoadingText.value = '正在导出PDF...'
    await exportPdfFromElement()
    previewPdfDialog.value = false
    showSuccess('PDF导出成功')
  } catch (error: any) {
    console.error('导出PDF失败:', error)
    showError(error.message || '导出PDF失败')
  } finally {
    showCommonLoading.value = false
    commonLoadingText.value = ''
  }
}

const handleBrowserPrintPurchase = async (item: any) => {
  try {
    showCommonLoading.value = true
    commonLoadingText.value = '正在准备打印...'
    isExportingPdf.value = true

    const { pdfData, itemList } = await preparePdfData(item)
    previewPdfData.value = pdfData
    previewItemList.value = itemList
    const ord = previewPdfData.value?.order
    if (ord) {
      ord.warehouseAddress =
        warehouseList.value.find((w) => w.warehouseName === ord.warehouseName)?.warehouseAddress ||
        ord.warehouseAddress ||
        ''
    }

    await nextTick()
    previewPdfDialog.value = true
    await nextTick()
    await nextTick()
    await new Promise((r) => setTimeout(r, 650))

    await new Promise<void>((resolve) => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => resolve())
      })
    })
    printPurchaseOrderByContentId()

    previewPdfDialog.value = false
    setTimeout(() => {
      isExportingPdf.value = false
    }, 300)
  } catch (error: any) {
    console.error('浏览器打印失败:', error)
    showError(error.message || '浏览器打印失败')
    previewPdfDialog.value = false
    setTimeout(() => {
      isExportingPdf.value = false
    }, 300)
  } finally {
    showCommonLoading.value = false
    commonLoadingText.value = ''
  }
}

// 从元素生成PDF - 逐页转换，确保每个 purchase-pdf-page 对应一张 A4 纸
const exportPdfFromElement = async () => {
  const pdfContent = document.getElementById('purchase-pdf-content')
  if (!pdfContent) {
    throw new Error('PDF内容元素不存在')
  }
  
  // 获取所有页面元素
  const pageElements = pdfContent.querySelectorAll('.purchase-pdf-page')
  if (pageElements.length === 0) {
    throw new Error('没有找到PDF页面元素')
  }
  
  // 创建PDF（A4纵向）
  const pdf = new jsPDF('portrait', 'mm', 'a4')
  const pageWidth = pdf.internal.pageSize.getWidth()
  const pageHeight = pdf.internal.pageSize.getHeight()
  
  // 逐页转换
  for (let i = 0; i < pageElements.length; i++) {
    const pageElement = pageElements[i] as HTMLElement
    
    // 使用 html2canvas 将单个页面转换为图片
    const canvas = await html2canvas(pageElement, {
      scale: 2,
      useCORS: true,
      logging: false,
      backgroundColor: '#ffffff',
      width: pageElement.scrollWidth,
      height: pageElement.scrollHeight
    })
    
    // 将 canvas 转换为图片数据
    const imgData = canvas.toDataURL('image/png')
    
    // 计算图片尺寸以适应页面宽度，高度按比例缩放
    const imgWidth = pageWidth
    const imgHeight = (canvas.height * pageWidth) / canvas.width
    
    // 如果不是第一页，先添加新页
    if (i > 0) {
      pdf.addPage()
    }
    
    // 将图片添加到页面顶部
    pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight)
  }
  
  // 保存PDF
  const fileName = `采购单_${previewPdfData.value.order?.purchaseOrderNo}.pdf`
  pdf.save(fileName)
}

</script>

<style scoped lang="scss">
.material-list-page {
  /* min-height: 100vh; */
  width: 100%;
  background-color: #2B2D33;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  /* padding: 16px; */
}

.material-list-container {
  width: 100%;
  max-width: 1400px;
  position: relative;
  top: -32px;
}

.form-card {
  background-color: #2B2D33 !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.form-card :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px;
  background: #D2475D;
}

.form-card :deep(.v-card-text) {
  padding: 24px;
  background-color: #2B2D33 !important;
}

.material-table, .price-table {
  background-color: transparent;
  width: 100%;
  table-layout: fixed;
  min-width: 1200px;
  border-collapse: separate;
  border-spacing: 0;
}

.material-table :deep(th), .price-table :deep(th) {
  /* background-color: rgba(255, 255, 255, 0.05) !important; */
  color: rgba(255, 255, 255, 0.7) !important;
  font-weight: 500;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
  white-space: nowrap;
  padding: 12px 8px;
  position: sticky;
  top: 0;
  z-index: 1;
}

.material-table :deep(td), .price-table :deep(td) {
  color: #fff !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
  white-space: nowrap;
  padding: 8px;
  transition: background-color 0.3s ease;
}

/* 确保表格内容不会溢出 */
.material-table :deep(td) > *, .price-table :deep(td) > * {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  /* margin-right: 8px; */
  word-break: break-all;
  white-space: pre-wrap;
}

/* 备注和描述字段样式 */
.material-table :deep(td) .v-textarea, .price-table :deep(td) .v-textarea {
  /* min-height: 36px; */
}

.material-table :deep(td) .v-textarea .v-field__input, .price-table :deep(td) .v-textarea .v-field__input {
  /* min-height: 36px; */
  padding: 8px !important;
  margin-right: 8px;
}

.material-table :deep(div.remark), .price-table :deep(div.remark){
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  width: 95%;
  white-space: pre-wrap;
  text-align: left;
  margin: 0 auto;
}
/* .auto-grow-textarea {
  width: 100%;
} */

.auto-grow-textarea :deep(.v-field__input) {
  /* min-height: 36px !important; */
  padding: 6px 8px !important;
  line-height: 1.5;
  overflow-y: hidden !important;
  resize: none !important;
}

.auto-grow-textarea :deep(.v-field) {
  min-height: 36px !important;
}

.auto-grow-textarea :deep(.v-field__outline) {
  min-height: 36px !important;
}

.auto-grow-textarea :deep(textarea) {
  overflow: hidden !important;
  resize: none !important;
}

.form-section {
  margin-bottom: 24px;
}

.material-list-section{
  background-color: #2B2D33 !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
  box-sizing: border-box;
}

.normal-title {
  color: #fff;
  cursor: pointer;
  width: 106px;
  font-size: 16px;
  font-weight: 500;
  // margin-bottom: 16px;
  padding-left: 8px;
}

.normal-title-active{
  border-left: 3px solid #D2475D;
}

:deep(.v-text-field) .v-field__input,
:deep(.v-text-field) .v-field__field,
:deep(.v-text-field) input,
:deep(.v-select) .v-field__input,
:deep(.v-select) .v-field__field,
:deep(.v-select) input,
:deep(.v-select) .v-select__selection-text,
:deep(.v-select) .v-select__selection,
:deep(.v-textarea) .v-field__input,
:deep(.v-textarea) .v-field__field,
:deep(.v-textarea) textarea {
  color: #fff !important;
}

:deep(.v-text-field) .v-field__outline,
:deep(.v-select) .v-field__outline,
:deep(.v-textarea) .v-field__outline {
  color: rgba(255, 255, 255, 0.12) !important;
}

:deep(.v-text-field) .v-field__input::placeholder,
:deep(.v-select) .v-field__input::placeholder,
:deep(.v-textarea) .v-field__input::placeholder {
  color: rgba(255, 255, 255, 0.7) !important;
}

:deep(.v-text-field) .v-label,
:deep(.v-select) .v-label,
:deep(.v-textarea) .v-label {
  color: rgba(255, 255, 255, 0.7) !important;
}

:deep(.v-text-field) .v-field__append-inner i,
:deep(.v-select) .v-field__append-inner i,
:deep(.v-textarea) .v-field__append-inner i {
  color: rgba(255, 255, 255, 0.7) !important;
}

.product-image-section {
  width: 100%;
  display: flex;
  align-items: flex-start;
  padding: 16px 0;
}

.image-label {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  margin-right: 16px;
  padding-top: 8px;
  min-width: 80px;
}

.image-content {
  flex: 1;
  display: flex;
  justify-content: flex-start;
}

.image-upload-area {
  width: 300px;
  height: 200px;
  border: 2px dashed rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.image-upload-area:hover {
  border-color: #1976D2;
  background-color: rgba(25, 118, 210, 0.05);
}

.image-upload-area .v-icon {
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 8px;
}

.image-upload-area span {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
}

.image-preview {
  width: 300px;
  height: 200px;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-actions {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.image-preview:hover .image-actions {
  opacity: 1;
}

.image-actions .v-icon {
  color: #fff;
  cursor: pointer;
  font-size: 24px;
  transition: color 0.3s ease;
}

.image-actions .v-icon:hover {
  color: #ff5252;
}

.hidden-input {
  display: none;
}

.form-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  background-color: rgba(43, 45, 51, 0.95);
  backdrop-filter: blur(8px);
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  /* display: flex;
  justify-content: center;
  margin-top: 32px;
  padding: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.12); */
}

.form-actions .v-btn {
  min-width: 120px;
  margin-right: 16px;
}

.material-images-container {
  display: flex;
  justify-content: center;
  align-items: center;
  /* flex-wrap: wrap; */
  gap: 8px;
}

.material-image-upload {
  width: 120px;
  height: 120px;
  border: 2px dashed rgba(255, 255, 255, 0.12);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  margin: 0 auto;
}

.image-preview-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0 auto;
}


/* .image-preview-item .image-actions {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
} */

.material-suggestions-dialog {
  background-color: #2B2D33 !important;
}

.material-suggestions-dialog :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px;
}

.material-suggestions-dialog :deep(.v-card-text) {
  padding: 16px;
}

.material-list {
  max-height: 500px;
  overflow-y: auto;
  background-color: transparent !important;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) rgba(255, 255, 255, 0.05);
  padding-bottom: 50px;
}

/* Firefox 滚动条样式 */
.material-table {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) rgba(255, 255, 255, 0.05);
}

.material-suggestions-dialog {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) rgba(255, 255, 255, 0.05);
}

.scroll-textarea {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) rgba(255, 255, 255, 0.05);
}

.material-list::-webkit-scrollbar,
.material-table::-webkit-scrollbar,
.material-suggestions-dialog::-webkit-scrollbar,
.scroll-textarea::-webkit-scrollbar,
.purchase-dialog::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.material-list::-webkit-scrollbar-track,
.material-table::-webkit-scrollbar-track,
.material-suggestions-dialog::-webkit-scrollbar-track,
.scroll-textarea::-webkit-scrollbar-track,
.purchase-dialog::-webkit-scrollbar-track
:deep(.filter-menu-text::-webkit-scrollbar-track) {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
}

.material-list::-webkit-scrollbar-thumb,
.material-table::-webkit-scrollbar-thumb,
.material-suggestions-dialog::-webkit-scrollbar-thumb,
.scroll-textarea::-webkit-scrollbar-thumb,
.purchase-dialog::-webkit-scrollbar-thumb
:deep(.filter-menu-text::-webkit-scrollbar-thumb) {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.1) 100%);
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.material-list::-webkit-scrollbar-thumb:hover,
.material-table::-webkit-scrollbar-thumb:hover,
.material-suggestions-dialog::-webkit-scrollbar-thumb:hover,
.scroll-textarea::-webkit-scrollbar-thumb:hover,
.purchase-dialog::-webkit-scrollbar-thumb:hover
:deep(.filter-menu-text::-webkit-scrollbar-thumb:hover) {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.2) 100%);
  border-color: rgba(255, 255, 255, 0.2);
  transform: scale(1.1);
}

.material-list::-webkit-scrollbar-thumb:active,
.material-table::-webkit-scrollbar-thumb:active,
.material-suggestions-dialog::-webkit-scrollbar-thumb:active,
.scroll-textarea::-webkit-scrollbar-thumb:active,
.purchase-dialog::-webkit-scrollbar-thumb:active
:deep(.filter-menu-text::-webkit-scrollbar-thumb:active) {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0.3) 100%);
}

/* 滚动条角落样式 */
.material-list::-webkit-scrollbar-corner,
.material-table::-webkit-scrollbar-corner,
.material-suggestions-dialog::-webkit-scrollbar-corner,
.scroll-textarea::-webkit-scrollbar-corner,
.purchase-dialog::-webkit-scrollbar-corner
:deep(.filter-menu-text::-webkit-scrollbar-corner) {
  background: transparent;
}

.material-suggestion-item {
  cursor: pointer;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 12px 16px;
}
.material-suggestion-item :deep(.v-list-item__content) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.material-suggestion-item:hover {
  background-color: rgba(255, 255, 255, 0.05);
}

.material-suggestion-item :deep(.v-list-item-title) {
  color: #fff;
  font-size: 14px;
  margin-bottom: 4px;
  white-space: inherit!important;
}

.material-suggestion-item :deep(.v-list-item-subtitle) {
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  white-space: inherit!important;
  -webkit-line-clamp: none!important;
}

.material-suggestions-dialog :deep(.v-text-field) {
  margin-bottom: 16px;
}

.material-suggestions-dialog :deep(.v-text-field .v-field__input) {
  color: #fff !important;
}

.material-suggestions-dialog :deep(.v-text-field .v-field__outline) {
  /* color: rgba(255, 255, 255, 0.12) !important; */
}

.material-suggestions-dialog :deep(.v-text-field .v-field__input::placeholder) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.material-suggestions-dialog :deep(.v-text-field .v-label) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.material-suggestions-dialog :deep(.v-text-field .v-field__append-inner i) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.material-suggestions-dialog :deep(.v-btn:hover) {
  background-color: rgba(25, 118, 210, 0.1) !important;
}

.image-count {
  color: #fff;
  font-size: 14px;
  margin-left: 8px;
}

.image-preview-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, 300px);
  gap: 16px;
  width: 100%;
}

.image-preview {
  width: 300px;
  height: 200px;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.image-preview:hover .preview-image {
  transform: scale(1.05);
}

.image-actions {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.image-preview:hover .image-actions {
  opacity: 1;
}

.image-actions .v-icon {
  color: #fff;
  cursor: pointer;
  font-size: 24px;
}

.delete-icon {
  position: absolute;
  top: 4px;
  right: 4px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.image-preview-item:hover .delete-icon {
  opacity: 1;
}

.delete-icon:hover {
  color: #ff5252;
}

.v-table__wrapper .v-field__input {
  width: 100% !important;
  padding: 6px 8px !important;
}

.product-table-container td{
  padding: 10px 0px !important;
  text-align: center;
}

.product-table-container tr{
  padding: 10px !important;
}

.product-table-container td:first-child{
  padding-left: 8px!important;
}

.text-right :deep(input) {
  text-align: right!important;
}

/* 隐藏productQuote输入框的上下箭头 */
.product-table-container :deep(input[type="number"])::-webkit-inner-spin-button,
.product-table-container :deep(input[type="number"])::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.table-container :deep(input[type="number"]) {
  -moz-appearance: textfield;
}

.material-suggestions-dialog :deep(.mdi-magnify),
.material-suggestions-dialog :deep(.mdi-magnify::before),
.material-suggestions-dialog :deep(.mdi-close::before),
.material-suggestions-dialog :deep(.mdi-close-circle),
.material-suggestions-dialog :deep(.mdi-close) {
  color: #fff!important;
}

/* .mdi-magnify::before,
.mdi-close-circle::before {
  color: #fff!important;
} */

.mdi-close:hover{
  color: #ff5252!important;
}

/* 
.material-table :deep(th:nth-child(10)),
.material-table :deep(td:nth-child(10)) {
  position: sticky!important;
  right: 0;
  background-color: #2B2D33 !important;
  z-index: 2;
  min-width: 160px;
  width: 160px;
}

.material-table :deep(th:nth-child(10)) {
  z-index: 3;
}

.material-table :deep(td:nth-child(10)) {
  background-color: #2B2D33 !important;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  padding: 8px;
} */

/* 删除确认对话框样式 */
.delete-confirm-dialog {
  background-color: #2B2D33 !important;
}

.delete-confirm-dialog :deep(.v-card-title) {
  color: #fff;
  padding: 16px;
}

.delete-confirm-dialog :deep(.v-card-text) {
  color: rgba(255, 255, 255, 0.8);
  padding: 16px;
}

.delete-confirm-dialog :deep(.v-card-actions) {
  padding: 16px;
}

.delete-confirm-dialog :deep(.v-btn) {
  color: #fff;
}

.delete-confirm-dialog :deep(.v-btn--variant-text) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.delete-confirm-dialog :deep(.v-btn--variant-text:hover) {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.v-table__wrapper .v-field__input {
  width: 100% !important;
  padding: 6px 8px !important;
}

.correlate-btn{
  position: fixed;
  bottom: 0;
  right: 0;
  width: 100%;
  background-color: #2B2D33;
  padding: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
}

.calculate-dialog {
  background-color: #2B2D33 !important;
}

.calculate-dialog :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px;
}

.calculate-dialog :deep(.v-card-text) {
  padding: 24px;
}

.formula-section {
  margin-bottom: 24px;
}

.formula-title {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
}

.formula-content {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  white-space: pre-wrap;
}

.variables-section {
  margin-bottom: 24px;
}

.variables-title {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
}

.result-section {
  margin: 24px 0;
}

.result-title {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
}

.result-value {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
}

.calc-section{
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

/* .calc-section .calc-input{
  width: 100px !important;
  min-width: 100px !important;
  max-width: 100px !important;
} */

.calc-section :deep(.v-text-field),
.calc-section :deep(.v-field) {
  width: 88px !important;
  min-width: 88px !important;
  max-width: 88px !important;
  /* padding-inline: revert!important;  */
}

.calc-section :deep(.v-field--readonly.v-text-field),
.calc-section :deep(.v-field--readonly .v-field),
.calc-section :deep(.v-field--readonly .v-field__input) {
  width: 70px !important;
  min-width: 70px !important;
  max-width: 70px !important;
  /* padding-inline: revert!important;  */
}

.calc-section :deep(.v-field--readonly.calc-input-readonly.v-text-field),
.calc-section :deep(.v-field--readonly.calc-input-readonly .v-field),
.calc-section :deep(.v-field--readonly.calc-input-readonly .v-field__input) {
  width: 90px !important;
  min-width: 90px !important;
  max-width: 90px !important;
  /* padding-inline: revert!important;  */
}


.calc-section :deep(.v-field--readonly.calc-input-readonly.calc-special-input.v-text-field),
.calc-section :deep(.v-field--readonly.calc-input-readonly.calc-special-input .v-field),
.calc-section :deep(.v-field--readonly.calc-input-readonly.calc-special-input .v-field__input),
.calc-section :deep(.calc-special-input.v-text-field),
.calc-section :deep(.calc-special-input .v-field),
.calc-section :deep(.calc-special-input .v-field__input) {
  width: 94px !important;
  min-width: 94px !important;
  max-width: 94px !important;
  /* padding-inline: revert!important;  */
}

.calc-item{
  font-size: 26px;
  font-weight: 500;
  color: #fff;
  /* margin: 0 8px; */
  line-height: 40px;
}

.title-textImg{
  display: flex;
  align-items: center;
  justify-content: center;
}

.title-text img{
  cursor: pointer;
}

/* 隐藏计算对话框输入框的上下箭头 */
.calculate-dialog :deep(input[type="number"])::-webkit-inner-spin-button,
.calculate-dialog :deep(input[type="number"])::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.calculate-dialog :deep(input[type="number"]) {
  -moz-appearance: textfield;
}

.seeRecord{
  width: 70%;
  text-align: center;
  margin: 0 auto;
  height: 32px;
  line-height: 30px;
  border: 1px solid #FFFFFF;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  box-sizing: border-box;
}

.material-table td:last-child .v-btn {
  display: block;
  min-width: auto;
  /* padding: 0 12px; */
  height: 32px;
  font-size: 13px;
  margin: 6px auto 8px;
  width: 70%;
}

.name-input :deep(.mdi:before){
  font-size: 24px!important;
}

.material-table td > * {
  max-width: 100%;
  text-overflow: ellipsis;
  margin-right: 8px;
}

.material-table td:last-child > * {
  margin-right: 0px!important;
  margin: 6px auto 8px auto!important;
}

.material-bom-table-body td:last-child > *, .material-summary-table-body td:last-child > * {
  margin: 0px!important;
}

.material-bom-table-body tr{
  height: 106px;
  box-sizing: border-box;
}

.material-summary-table-body tr{
  height: 80px;
  box-sizing: border-box;
}
/* 引用汇总对话框复选框样式 */
.material-suggestions-dialog :deep(.v-checkbox .v-selection-control) {
  color: #fff !important;
}

.material-suggestions-dialog :deep(.v-checkbox .v-selection-control__wrapper) {
  color: #fff !important;
}

.material-suggestions-dialog :deep(.v-checkbox .v-selection-control__wrapper .v-icon) {
  color: #fff !important;
}

.material-suggestions-dialog :deep(.v-checkbox .v-selection-control__wrapper .v-selection-control__input) {
  color: #fff !important;
}

.material-suggestions-dialog :deep(.v-checkbox .v-selection-control__wrapper .v-selection-control__input .v-icon) {
  color: #fff !important;
}

/* 未选中状态的边框 */
.material-suggestions-dialog :deep(.v-checkbox .v-selection-control__wrapper .v-selection-control__input:not(.v-selection-control--dirty) .v-icon) {
  /* color: #fff !important; */
  /* border: 2px solid #fff !important; */
  border-radius: 2px;
}

/* 选中状态的背景色 */
.material-suggestions-dialog :deep(.v-checkbox .v-selection-control__wrapper .v-selection-control__input.v-selection-control--dirty .v-icon) {
  background-color: #fff !important;
  color: #2B2D33 !important;
  border: 1px solid #fff !important;
  border-radius: 2px;
}

.price-table :deep(th){
  padding: 0!important;
}


.product-info-item{
  text-align: left;
  text-overflow: ellipsis;
  word-break: break-all;
  width: 95%;
  white-space: pre-wrap;
  line-height: 1.25;
  margin-top: 6px;
  font-size: 12px;
}
.count-item{
  width: fit-content;
  max-width: inherit!important;
  text-align: center;
  padding: 4px 6px;
  border: 1px solid #FFFFFF;
  border-radius: 2px;
  color: #fff;
  margin-top: 6px;
}

.float-left{
  /* float: left; */
  margin-bottom: 12px;
}

.product-table-container {
  position: relative;
  z-index: 150;
}

/* 分页样式 */
.custom-pagination {
  padding: 16px;
  color: rgba(255, 255, 255, 0.7);
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.custom-pagination .pagination-info {
  font-size: 14px;
}

.custom-pagination .pagination-controls {
  display: flex;
  align-items: center;
}

.custom-pagination .pagination-btn {
  color: rgba(255, 255, 255, 0.7) !important;
}

.custom-pagination .pagination-btn:hover {
  color: #fff !important;
}

.custom-pagination .pagination-btn:disabled {
  color: rgba(255, 255, 255, 0.3) !important;
}

.custom-pagination .pagination-text {
  font-size: 14px;
}

.small-input :deep(.v-input){
  width: 70px!important;
  margin-right: 8px;
}

.small-input :deep(.v-field--variant-outlined .v-label.v-field-label--floating){
  font-size: 11px!important;
  display: inline-block;
  transform: translateY(-60%)!important;
}

.has-normal-input{
  position: absolute;
  bottom: 1px;
  right: 8px;
  padding: 2px 4px;
  font-size: 9px;
  color: #C3C4C5 !important;
}

.big-input :deep(.v-input){
  width: 116px!important;
  margin-right: 9px;
}

.right-0 :deep(.v-input){
  margin-right: 0px!important;
}

.calc-tip{
  width: 32px; 
  height: 16px; 
  margin-right: 0px; 
  cursor: pointer;
  margin-left: 4px;
}

.product-table-container :deep(.v-field--prepended) {
  --v-field-padding-start: 4px!important;
  padding-inline-start: 4px!important;
}

.product-table-container :deep(.v-field__input),
.product-table-container :deep(input),
.material-control-table :deep(input),
.material-control-table :deep(.v-field__input){
  font-size: 12px!important;
}

.product-table-container :deep(.v-field__input),
.product-table-container :deep(input){
  padding: 0 4px!important;
}
/* 隐藏quote输入框的上下箭头 */
:deep(input[type="number"])::-webkit-inner-spin-button,
:deep(input[type="number"])::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

:deep(input[type="number"]) {
  -moz-appearance: textfield;
}
.auto-grow-textarea :deep(.v-field__input) {
  /* min-height: 36px !important; */
  padding: 6px 8px !important;
  line-height: 1.5;
  overflow-y: hidden !important;
  resize: none !important;
}

.auto-grow-textarea :deep(.v-field) {
  /* min-height: 36px !important; */
}

.auto-grow-textarea :deep(.v-field__outline) {
  /* min-height: 36px !important; */
}

.auto-grow-textarea :deep(textarea) {
  overflow: hidden !important;
  resize: none !important;
}

.price-input-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* .priceLeft {
  float: left;
  width: 46%;
}

.priceRight {
  float: right;
  width: 46%;
} */

/* 清除浮动 */
.priceLeft::after,
.priceRight::after {
  content: '';
  display: block;
  clear: both;
}

.price-input-group :deep(.v-field) {
  /* background-color: rgba(255, 255, 255, 0.05); */
}

.price-input-group :deep(.v-field--readonly .v-field__input) {
  /* color: #ff5252 !important; */
}

.price-input-group :deep(.v-field__outline) {
  color: rgba(255, 255, 255, 0.12) !important;
}

.price-input-group :deep(.v-field:hover .v-field__outline) {
  color: rgba(255, 255, 255, 0.3) !important;
}

.price-input-group :deep(.v-field--focused .v-field__outline) {
  /* color: #1976D2 !important; */
}
.contract-new-container {
  width: 100%;
  max-width: 1500px;
}

.form-card {
  background-color: #2B2D33 !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.form-card :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px;
  background: #D2475D;
}

.form-card :deep(.v-card-text) {
  padding: 24px;
  background-color: #2B2D33 !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.form-section {
  margin-bottom: 24px;
}

:deep(.v-text-field) .v-field__input,
:deep(.v-text-field) .v-field__field,
:deep(.v-text-field) input,
:deep(.v-select) .v-field__input,
:deep(.v-select) .v-field__field,
:deep(.v-select) input,
:deep(.v-select) .v-select__selection-text,
:deep(.v-select) .v-select__selection,
:deep(.v-textarea) .v-field__input,
:deep(.v-textarea) .v-field__field,
:deep(.v-textarea) textarea {
  color: #fff !important;
}

:deep(.v-text-field) .v-field__outline,
:deep(.v-select) .v-field__outline,
:deep(.v-textarea) .v-field__outline {
  color: rgba(255, 255, 255, 0.12) !important;
}

:deep(.v-text-field) .v-field__input::placeholder,
:deep(.v-select) .v-field__input::placeholder,
:deep(.v-textarea) .v-field__input::placeholder {
  color: rgba(255, 255, 255, 0.7) !important;
}

:deep(.v-text-field) .v-label,
:deep(.v-select) .v-label,
:deep(.v-textarea) .v-label {
  color: rgba(255, 255, 255, 0.7) !important;
}

:deep(.v-text-field) .v-field__append-inner i,
:deep(.v-select) .v-field__append-inner i,
:deep(.v-textarea) .v-field__append-inner i {
  color: rgba(255, 255, 255, 0.7) !important;
}

.material-table-card {
  margin-top: 8px;
  width: 100%;
  overflow-x: auto;
}

.material-table :deep(th) {
  background-color: transparent !important;
  color: rgba(255, 255, 255, 0.7) !important;
  font-weight: 500;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
  white-space: nowrap;
  padding: 8px;
}

.material-table {
  color: #fff !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
  white-space: nowrap;
  /* padding: 8px; */
}

.material-control-table :deep(td) > *{
  word-break: break-all;
  white-space: pre-wrap;
}

.product-table :deep(.v-field__input) {
  padding: 0 8px;
}

.product-table-card {
  margin-top: 8px;
  width: 100%;
}


.table-container {
  width: 100%;
  /* max-height: 70vh; */
  overflow-x: hidden;
  overflow-y: auto;
  padding-top: 8px; /* 为顶部滚动条预留空间 */
  /* padding-right: 8px; */
  /* 将滚动条放在顶部 */
  /* direction: rtl; */
}

/* .table-container > * {
  direction: ltr;
} */

.product-table {
  background-color: transparent;
  width: 100%;
  table-layout: fixed;
  min-width: 1200px;
  border-collapse: separate;
  border-spacing: 0;
  /* max-height: 68vh; */
  /* overflow: auto; */
}

.product-table :deep(.v-table__wrapper) {
  overflow-x: hidden;
}

.product-table :deep(th) {
  /* background-color: rgba(255, 255, 255, 0.05) !important; */
  color: rgba(255, 255, 255, 0.7) !important;
  font-weight: 500;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
  white-space: nowrap;
  padding: 12px 8px;
  position: sticky;
  top: 0;
  z-index: 1;
}

/* 修改操作列固定在右侧的样式 */
/* .product-table-container :deep(th:nth-child(14)), */
/* .product-table-container :deep(td:nth-child(14)), */
/* .material-control-table :deep(th:nth-child(14)),
.material-control-table :deep(td:nth-child(14)) {
  position: sticky!important;
  right: 0;
  background-color: #2B2D33 !important;
  z-index: 2;
  min-width: 160px;
  width: 160px;
} */

/* .product-table-container :deep(th:nth-child(14)),
.material-control-table :deep(th:nth-child(14)) {
  z-index: 3;
} */

/* .product-table-container :deep(td:nth-child(14)),
.material-control-table :deep(td:nth-child(14)) {
  background-color: #2B2D33 !important;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  padding: 8px;
} */

.material-control-table .text-right :deep(input) {
  text-align: right!important;
}

.product-table-container tr td{
  text-align: center!important;
}
.product-table-container :deep(.v-chip){
  // height: 40px!important;
  // width: 70px!important;
  // line-height: 40px!important;
  // text-align: center!important;
  // margin: 0 auto!important;
  // padding: 0!important;
  // display: inline-block!important;
}

.material-control-table :deep(.remark){
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  width: 95%;
  white-space: pre-wrap;
  text-align: left;
  margin: 0 auto;
  font-size: 12px!important;
}

/* 修改操作按钮容器的样式 */
.product-table :deep(td:last-child) .d-flex {
  position: sticky;
  right: 0;
  background-color: #2B2D33;
  padding: 0 8px;
  width: 100%;
  justify-content: center;
  gap: 8px;
}

/* 修改操作按钮的样式 */
.product-table :deep(td:last-child) .v-btn {
  display: block;
  min-width: auto;
  /* padding: 0 12px; */
  height: 32px;
  font-size: 13px;
  margin: 6px auto 8px;;
  width: 70%;
}

.product-table :deep(td) {
  color: #fff !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
  white-space: nowrap;
  padding: 8px;
  transition: background-color 0.3s ease;
}

/* 确保表格内容不会溢出 */
.product-table :deep(td) > * {
  max-width: 100%;
  /* overflow: hidden; */
  text-overflow: ellipsis;
  margin-right: 8px;
}

.product-table td:last-child > div{
  margin-right: 0;
}

.priceRight {
  margin-right: 0px;
}

/* 表格中设置上下间距可显示label */
/* .product-table-container td{
  padding: 15px 0 !important;
} */

.product-table-container td:first-child{
  padding: 0!important;
}

/* 备注和描述字段样式 */
.product-table :deep(td) .v-textarea {
  /* min-height: 36px; */
  height: auto!important;
}

.product-table :deep(td) .v-textarea .v-field__input {
  /* min-height: 36px; */
  padding: 10px 4px !important;
  margin-right: 8px;
}

.product-table :deep(td) .v-textarea.materialDescription .v-field__input {
  height: auto!important;
  /* padding: 10px 4px 10px 38px !important; */
  /* position: relative; */
}

.auto-grow-textarea {
  /* width: 100%; */
}

.auto-grow-textarea :deep(.v-field__input) {
  /* min-height: 36px !important; */
  padding: 8px !important;
  line-height: 1.5;
  overflow-y: hidden !important;
  resize: none !important;
}

.auto-grow-textarea :deep(.v-field) {
  /* min-height: 36px !important; */
}

.auto-grow-textarea :deep(.v-field__outline) {
  /* min-height: 36px !important; */
}

.auto-grow-textarea :deep(textarea) {
  overflow: hidden !important;
  resize: none !important;
}

.preview-image-zoomed{
  max-width: 300px!important;
  width: 300px!important;
  height: 300px!important;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1500;
  /* background: white;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); */
}

.preview-image-zoomed .image-preview-item{
  width: 300px!important;
  height: 300px!important;
}

/* .product-image-upload {
  width: 120px;
  height: 120px;
  border: 2px dashed rgba(255, 255, 255, 0.12);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  margin: 0 auto;
}

.image-preview-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0 auto;
} */

.image-preview-item {
  width: 120px;
  height: 120px;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
  cursor: pointer;
  margin: 0 auto;
}

.image-preview-item .preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.image-preview-item:hover .preview-image {
  transform: scale(1.05);
}

.image-preview-item .image-actions {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.image-preview-item:hover .image-actions {
  opacity: 1;
}

.image-preview-item .image-actions .v-icon {
  color: #fff;
  cursor: pointer;
}

.image-preview-item .image-actions .v-icon:hover {
  color: #ff5252;
}

.delete-icon {
  position: absolute;
  top: 4px;
  right: 4px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.image-preview-item:hover .delete-icon {
  opacity: 1;
}

.delete-icon:hover {
  color: #ff5252;
}

.hidden-input {
  display: none;
}

/* 只读字段样式 */
:deep(.v-field--readonly ) {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

:deep(.v-field--readonly .v-field__input) {
  color: rgba(255, 255, 255, 0.5) !important;
}


:deep(.v-field--readonly.description) {
  background-color: transparent!important;
}

:deep(.v-field--readonly.description .v-field__field) {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

.company-suggestions-dialog {
  background-color: #2B2D33 !important;
}

.company-suggestions-dialog :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px;
}

.company-suggestions-dialog :deep(.v-card-text) {
  padding: 16px;
}

.company-list {
  max-height: 400px;
  overflow-y: auto;
  background-color: transparent !important;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
}

.company-list::-webkit-scrollbar {
  width: 6px;
}

.company-list::-webkit-scrollbar-track {
  background: transparent;
}

.company-list::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.company-list::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255, 255, 255, 0.3);
}

.company-suggestion-item {
  cursor: pointer;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.company-suggestion-item:hover {
  background-color: rgba(255, 255, 255, 0.05);
}

.company-suggestion-item :deep(.v-list-item-title) {
  color: #fff;
  font-size: 14px;
}

.company-suggestion-item :deep(.v-list-item-subtitle) {
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
}

:deep(.dialog-bottom-transition-enter-active),
:deep(.dialog-bottom-transition-leave-active) {
  transition: transform 0.2s ease-in-out;
}

:deep(.dialog-bottom-transition-enter-from),
:deep(.dialog-bottom-transition-leave-to) {
  transform: translateY(100%);
}

.submit-btn {
  background-color: #1976D2 !important;
  color: #fff !important;
}

.submit-btn:hover {
  background-color: #1565C0 !important;
}

.save-btn {
  background-color: rgba(3, 169, 244, 0.6) !important;
  color: #03A9F4 !important;
  font-weight: 500;
}

.save-btn:hover {
  background-color: rgba(3, 169, 244, 0.5) !important;
}

.region-dialog {
  background-color: #2B2D33 !important;
}

.region-dialog :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px;
}

.region-dialog :deep(.v-card-text) {
  padding: 16px;
}

.region-selector {
  display: flex;
  gap: 16px;
  height: 400px;
}

.province-list,
.city-list {
  flex: 1;
  overflow-y: auto;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
  padding: 8px;
}

.province-item,
.city-item {
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.7);
  transition: all 0.3s ease;
}

.province-item:hover,
.city-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.province-item.active,
.city-item.active {
  background-color: #1976D2;
  color: #fff;
}

.province-list::-webkit-scrollbar,
.city-list::-webkit-scrollbar {
  width: 6px;
}

.province-list::-webkit-scrollbar-track,
.city-list::-webkit-scrollbar-track {
  background: transparent;
}

.province-list::-webkit-scrollbar-thumb,
.city-list::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.province-list::-webkit-scrollbar-thumb:hover,
.city-list::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255, 255, 255, 0.3);
}


.exchange-rate-field :deep(.v-field__append-inner) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.exchange-rate-field :deep(.v-field__append-inner .v-icon) {
  cursor: help;
}

.exchange-rate-field :deep(.v-field__append-inner .v-icon:hover) {
  color: #ff5252 !important;
}

.auto-grow-textarea :deep(.v-field__input) {
  /* min-height: 36px !important; */
  padding: 6px 8px !important;
  line-height: 1.5;
  overflow-y: hidden !important;
  resize: none !important;
}

.auto-grow-textarea :deep(.v-field) {
  /* min-height: 36px !important; */
}

.auto-grow-textarea :deep(.v-field__outline) {
  /* min-height: 36px !important; */
}

.auto-grow-textarea :deep(textarea) {
  overflow: hidden !important;
  resize: none !important;
}

.price-input-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* .priceLeft {
  float: left;
  width: 46%;
}

.priceRight {
  float: right;
  width: 46%;
} */

/* 清除浮动 */
.priceLeft::after,
.priceRight::after {
  content: '';
  display: block;
  clear: both;
}

.price-input-group :deep(.v-field) {
  /* background-color: rgba(255, 255, 255, 0.05); */
}

.price-input-group :deep(.v-field--readonly .v-field__input) {
  /* color: #ff5252 !important; */
}

.price-input-group :deep(.v-field__outline) {
  color: rgba(255, 255, 255, 0.12) !important;
}

.price-input-group :deep(.v-field:hover .v-field__outline) {
  color: rgba(255, 255, 255, 0.3) !important;
}

.price-input-group :deep(.v-field--focused .v-field__outline) {
  /* color: #1976D2 !important; */
}

.delete-confirm-dialog {
  background-color: #2B2D33 !important;
}

.delete-confirm-dialog :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px;
}

.delete-confirm-dialog :deep(.v-card-text) {
  color: rgba(255, 255, 255, 0.7);
  padding: 16px;
}

.delete-confirm-dialog :deep(.v-card-actions) {
  padding: 8px 16px 16px;
}

/* 隐藏quote输入框的上下箭头 */
:deep(input[type="number"])::-webkit-inner-spin-button,
:deep(input[type="number"])::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

:deep(input[type="number"]) {
  -moz-appearance: textfield;
}

.price-show div{
  width: 200px!important;
}

.contract-btns{
  display: flex;
}

.contract-btns .ml-4{
  margin-left: 0px!important;
  margin-right: 16px!important;
}

.text-right :deep(input) {
  text-align: right!important;
}

.mdi-magnify::before{
  color: #fff!important;
}

.mdi-close:hover{
  color: #ff5252!important;
}

.company-suggestions-dialog :deep(.mdi-magnify),
.company-suggestions-dialog :deep(.mdi-magnify::before),
.company-suggestions-dialog :deep(.mdi-close::before),
.company-suggestions-dialog :deep(.mdi-close-circle),
.company-suggestions-dialog :deep(.mdi-close),
.material-suggestions-dialog :deep(.mdi-magnify),
.material-suggestions-dialog :deep(.mdi-magnify::before),
.material-suggestions-dialog :deep(.mdi-close::before),
.material-suggestions-dialog :deep(.mdi-close-circle),
.material-suggestions-dialog :deep(.mdi-close) {
  color: #fff!important;
}
   
.text-status-default{
  height: 40px !important;
  width: 70px !important;
  line-height: 40px !important;
  text-align: center !important;
  margin: 0 auto !important;
  padding: 0 !important;
  display: inline-block !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  background-color: #414141 !important;
  color: #fff !important;
}    

.text-status-process{
  height: 40px !important;
  width: 70px !important;
  line-height: 40px !important;
  text-align: center !important;
  margin: 0 auto !important;
  padding: 0 !important;
  display: inline-block !important;
  background-color: #453237 !important;
  color: rgb(var(--v-theme-error)) !important;
  font-size: 12px !important;
  font-weight: 400 !important;
}    

.text-status-waiting{
  height: 40px !important;
  width: 70px !important;
  line-height: 40px !important;
  text-align: center !important;
  margin: 0 auto !important;
  padding: 0 !important;
  display: inline-block !important;
  background-color: #453F2E !important;
  color: #EAB20B !important;
  font-size: 12px !important;
  font-weight: 400 !important;
}

.text-status-success{
  height: 40px !important;
  width: 70px !important;
  line-height: 40px !important;
  text-align: center !important;
  margin: 0 auto !important;
  padding: 0 !important;
  display: inline-block !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  background-color: #3B4D3E !important;
  color: #66BB6A !important;
}

.prosee-status-wait,
.prosee-status-process,
.prosee-status-success{
  border-radius: 4px;
  min-width: 110px!important;
  height: 40px!important;
  text-align: center;
  margin-right: 16px!important;    
  line-height: 1.2;
  padding: 4px 0;
  cursor: pointer;
}

.prosee-status-error{
  min-width: 110px!important;
  height: 40px!important;
  text-align: center;
  margin-right: 16px!important;    
  line-height: 1.2;
  padding: 4px 0;
  cursor: pointer;
  background: var(--primary-gradient) !important;
  box-shadow: 0 2px 4px #D2475D !important;
  color: #fff!important;
  border-radius: 4px;
  border: none !important;
  font-weight: 500 !important;
  position: relative;
}

.prosee-status-wait{
  border-radius: 4px;
  background-color: #453F2E !important;
  color: #EAB20B !important;
  /* padding: 0!important; */
  /* line-height: 50px!important; */
}

.prosee-status-process{
  border-radius: 4px;
  background-color: #453237 !important;
  color: rgb(var(--v-theme-error)) !important;
}

.prosee-status-success{
  border-radius: 4px;
  background-color: #3B4D3E !important;
  color: #66BB6A !important;
}

.status-time{
  font-size: 12px;
  /* color: rgba(255, 255, 255, 0.7); */
}

.proseeBg,.contract-btns .v-btn{
  min-width: 110px!important;
  height: 40px!important;
  line-height: 1.2;
  padding: 4px 0;
}

.proseeBg{
  background-color: #453237 !important;
  margin-right: 16px;
  text-align: center;
  /* padding: 6px 16px; */
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}
.processing{
  color: rgb(var(--v-theme-error)) !important;
}
.processed{
  color: #66BB6A !important;
}

.section-title-group{
  display: flex;
  gap: 16px;
  // margin-top: 40px;
  position: relative;
}

.estimate-btn{
  position: absolute;
  /* right: 28px; */
  right: 0;
  top: 0;
  width: 76px;
}

.section-title-group div{
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  width: 96px;
  box-sizing: border-box;
  color: rgba(255, 255, 255, 0.6)!important;
}

.section-title-group div.section-title{
  color: #fff!important;
}

.v-img__img--cover{
  object-fit: contain!important;
}

.action-confirm-dialog {
  background-color: #2B2D33 !important;
}

.action-confirm-dialog :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px;
}

.action-confirm-dialog :deep(.v-card-text) {
  color: rgba(255, 255, 255, 0.7);
  padding: 16px;
}

.action-confirm-dialog :deep(.v-card-actions) {
  padding: 8px 16px 16px;
}

.seeRecord{
  width: 70%;
  text-align: center;
  margin: 0 auto;
  height: 32px;
  line-height: 30px;
  border: 1px solid #FFFFFF;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  box-sizing: border-box;
}

.salesman-review-refuse{
  width: 70%;
  text-align: center;
  margin: 0 auto;
  height: 32px;
  line-height: 32px;
  background: #453237;
  border-radius: 4px;
  color: #DE4B63;
  margin-top: 12px;
  box-sizing: border-box;
}
.salesman-review-agree{
  width: 70%;
  text-align: center;
  margin: 0 auto;
  height: 32px;
  line-height: 32px;
  background-color: #3B4D3E;
  border-radius: 4px;
  color: #fff;
  margin-top: 12px;
  box-sizing: border-box;
}

/* 确保PDF图标能正确显示 */
:deep(.mdi-file-pdf-box),
:deep(.mdi-file-pdf) {
  font-family: "Material Design Icons" !important;
  font-weight: normal !important;
  font-style: normal !important;
  font-size: 24px !important;
  line-height: 1 !important;
  letter-spacing: normal !important;
  text-transform: none !important;
  display: inline-block !important;
  white-space: nowrap !important;
  word-wrap: normal !important;
  direction: ltr !important;
  -webkit-font-smoothing: antialiased !important;
  text-rendering: optimizeLegibility !important;
  -moz-osx-font-smoothing: grayscale !important;
  -webkit-font-feature-settings: "liga" !important;
  font-feature-settings: "liga" !important;
}

.status-icon {
  position: absolute;
  top: 4px;
  right: 2px;
  background-color: #2B2D33;
  border-radius: 50%;
  padding: 2px;
  cursor: pointer;
  color: #fff!important;
  background: transparent!important;
  border: 1px solid #fff!important;
  font-size: 14px!important;
  width: 14px!important;
  height: 14px!important;
}

.v-table--fixed-header > .v-table__wrapper > table > thead{
  background: #2B2D33 !important;
  z-index: 500;
}

/* 导入动画样式 */
.import-animation-dialog {
  background-color: rgba(43, 45, 51, 0.8) !important;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  border-radius: 0;
}

.import-animation-dialog :deep(.v-card) {
  background: transparent !important;
  box-shadow: none !important;
}

.import-animation-dialog :deep(.v-card-text) {
  color: rgba(255, 255, 255, 0.9);
  padding: 0;
  background: transparent;
}

.import-animation-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  width: 100%;
}

.import-animation-text {
  color: #fff !important;
  font-weight: 500;
  line-height: 1.4;
  text-align: center;
  font-size: 1.5rem;
  margin-bottom: 2rem;
}

.import-animation-dots {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 2rem;
}

.import-animation-dots .dot {
  width: 12px;
  height: 12px;
  background-color: var(--v-theme-primary);
  border-radius: 50%;
  animation: dot-pulse 1.5s infinite ease-in-out;
}

.import-animation-dots .dot:nth-child(1) {
  animation-delay: 0s;
}

.import-animation-dots .dot:nth-child(2) {
  animation-delay: 0.2s;
}

.import-animation-dots .dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes dot-pulse {
  0%, 80%, 100% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  40% {
    transform: scale(1.2);
    opacity: 1;
  }
}

.import-animation-dialog :deep(.v-card-text) {
  max-height: 100vh;
  overflow: hidden;
}

.material-suggestions-dialog {
  background-color: #2B2D33 !important;
}

.material-suggestions-dialog :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px;
}

.material-suggestions-dialog :deep(.v-card-text) {
  padding: 16px;
}

.material-list {
  max-height: 400px;
  overflow-y: auto;
  background-color: transparent !important;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
}

.material-list::-webkit-scrollbar {
  width: 6px;
}

.material-list::-webkit-scrollbar-track {
  background: transparent;
}

.material-list::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.material-list::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255, 255, 255, 0.3);
}

.material-suggestion-item {
  cursor: pointer;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 12px 16px;
}
.material-suggestion-item :deep(.v-list-item__content) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.material-suggestion-item:hover {
  background-color: rgba(255, 255, 255, 0.05);
}

.material-suggestion-item :deep(.v-list-item-title) {
  color: #fff;
  font-size: 14px;
  margin-bottom: 4px;
}

.material-suggestion-item :deep(.v-list-item-subtitle) {
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
}

.material-suggestions-dialog :deep(.v-text-field) {
  margin-bottom: 16px;
}

.material-suggestions-dialog :deep(.v-text-field .v-field__input) {
  color: #fff !important;
}

.material-suggestions-dialog :deep(.v-text-field .v-field__outline) {
  /* color: rgba(255, 255, 255, 0.12) !important; */
}

.material-suggestions-dialog :deep(.v-text-field .v-field__input::placeholder) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.material-suggestions-dialog :deep(.v-text-field .v-label) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.material-suggestions-dialog :deep(.v-text-field .v-field__append-inner i) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.material-suggestions-dialog :deep(.v-btn:hover) {
  background-color: rgba(25, 118, 210, 0.1) !important;
}

.price-tip-tooltip :deep(.v-overlay__content) {
  padding: 0!important;
}

.price-tip-table {
  display: flex;
  align-items: center;
}

.title-text{
  min-width: 70px; 
  text-align: center;
  height: 30px;
  line-height: 30px;
  color: #fff;
}

.title-text-1{
  min-width: 50px;
  color: rgba(255, 255, 255, 0.7) !important;
}

.name-input :deep(.mdi:before){
  font-size: 24px!important;
}

.product-table-container :deep(.v-field--prepended) {
  --v-field-padding-start: 4px!important;
  padding-inline-start: 4px!important;
}

.product-table-container :deep(.v-field__input),
.product-table-container :deep(input),
.material-control-table :deep(input),
.material-control-table :deep(.v-field__input){
  font-size: 12px!important;
}

.product-table-container :deep(.v-field__input),
.product-table-container :deep(input){
  padding: 0 4px!important;
}
.material-control-table :deep(thead > tr > th),
.product-table-container :deep(thead > tr > th){
  padding: 0!important;
}

.product-table-container :deep(.description .v-field__input),
.material-control-table :deep(.description .v-field__input){
  font-size: 10px!important;
}

.product-table-container .price-input-group :deep(.v-field__input){
  font-size: 14px!important;
}

.local-amount-display{
  position: absolute;
  bottom: 11px;
  right: 0px;
  padding: 2px 4px;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.5) !important;
}

.local-amount-display2{
  position: absolute;
  bottom: -2px;
  right: 0px;
  padding: 2px 4px;
  font-size: 9px;
  color: rgba(255, 255, 255, 0.5) !important;
}

.code-input{
  margin-bottom: 16px!important;
}

.size-input,.size-input :deep(.v-field__input),.size-input :deep(.v-field){
  height: 30px!important;
  min-height: 30px!important;
  box-sizing: border-box!important;
  margin-bottom: 8px!important;
}

.priceLeft:deep(div.mb-1){
  margin-bottom: 12px!important;
}

.priceLeft :deep(.v-field__input){
  position: relative;
  /* top: -2px; */
}

.product-table-container {
  position: relative;
  z-index: 150;
}

.prosee-status-error.btn-hover :hover{
  box-shadow: #D2475D -1px 4px 14px 1px!important;
  /* box-shadow: 0px 4px 12px #D2475D!important; */
}

.estimate-dialog-content{
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: space-between;
  align-items: center;
}

.estimate-dialog-content :deep(.v-field__input),
.estimate-dialog-content :deep(.v-input){
  width: 100px!important;
  text-align: right!important;
}

:deep(.mdi:before, .mdi-set){
    color: #FFFFFF;
}

.image-navigation :deep(.mdi:before, .mdi-set){
    font-size: 36px!important;
}

.zoom-controls{
  margin: 0 auto;
}

.zoom-controls button{
  width: 30px!important;
  height: 30px!important;
  background: rgba(43, 45, 51, 0.8) !important;
  border-radius: 50% !important;
}

.zoom-controls :deep(.mdi:before, .mdi-set){
    font-size: 20px!important;
}
/* 确保v-menu能正确显示 */
:deep(.v-menu) {
    z-index: 9999;
}

/* v-date-picker样式 */
:deep(.v-date-picker) {
    background-color: #2B2D33;
    border: 1px solid #404248;
}

.product-info-section {
  width: 100%;
  max-width: 1500px;
}

.form-card {
  background-color: #2B2D33 !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.form-card :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px;
  background: #D2475D;
}

.form-card :deep(.v-card-text) {
  padding: 24px;
  background-color: #2B2D33 !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.form-section {
  margin-bottom: 24px;
}

.section-title {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
  padding-left: 8px;
  border-left: 3px solid #D2475D;
}

:deep(.v-text-field) .v-field__input,
:deep(.v-text-field) .v-field__field,
:deep(.v-text-field) input,
:deep(.v-select) .v-field__input,
:deep(.v-select) .v-field__field,
:deep(.v-select) input,
:deep(.v-select) .v-select__selection-text,
:deep(.v-select) .v-select__selection,
:deep(.v-textarea) .v-field__input,
:deep(.v-textarea) .v-field__field,
:deep(.v-textarea) textarea {
  color: #fff !important;
}

:deep(.v-text-field) .v-field__outline,
:deep(.v-select) .v-field__outline,
:deep(.v-textarea) .v-field__outline {
  color: rgba(255, 255, 255, 0.12) !important;
}

:deep(.v-text-field) .v-field__input::placeholder,
:deep(.v-select) .v-field__input::placeholder,
:deep(.v-textarea) .v-field__input::placeholder {
  color: rgba(255, 255, 255, 0.7) !important;
}

:deep(.v-text-field) .v-label,
:deep(.v-select) .v-label,
:deep(.v-textarea) .v-label {
  color: rgba(255, 255, 255, 0.7) !important;
}

:deep(.v-text-field) .v-field__append-inner i,
:deep(.v-select) .v-field__append-inner i,
:deep(.v-textarea) .v-field__append-inner i {
  color: rgba(255, 255, 255, 0.7) !important;
}

.material-table-card {
  margin-top: 8px;
  width: 100%;
  overflow-x: auto;
}

.material-table {
  background-color: transparent;
  width: 100%;
  table-layout: fixed;
}

.material-table :deep(th) {
  background-color: transparent !important;
  color: rgba(255, 255, 255, 0.7) !important;
  font-weight: 500;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
  white-space: nowrap;
  padding: 8px;
}

/* .material-table {
  color: #fff !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
  white-space: nowrap;
  padding: 8px;
} */

.material-control-table :deep(td) > *{
  word-break: break-all;
  white-space: pre-wrap;
}



.product-table :deep(.v-field__input) {
  padding: 0 8px;
}

.product-table-card {
  margin-top: 8px;
  width: 100%;
}

.product-table {
  background-color: transparent;
  width: 100%;
  table-layout: fixed;
  min-width: 1200px;
  border-collapse: separate;
  border-spacing: 0;
  /* max-height: 68vh; */
  /* overflow: auto; */
}

.product-images-container {
  display: flex;
  /* flex-wrap: wrap; */
  justify-content: center;
  align-items: center;
  gap: 8px;
  /* position: relative; */
  width: 100px;
  height: 100px;
  background: rgba(0, 0, 0, .25);
  border-radius: 4px;
}


.delete-icon {
  position: absolute;
  top: 4px;
  right: 4px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.image-preview-item:hover .delete-icon {
  opacity: 1;
}

.delete-icon:hover {
  color: #ff5252;
}

.hidden-input {
  display: none;
}

/* 只读字段样式 */
:deep(.v-field--readonly ) {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

/* :deep(.v-field--readonly .v-field__input) {
  color: rgba(255, 255, 255, 0.5) !important;
} */


:deep(.v-field--readonly.description) {
  background-color: transparent!important;
}

:deep(.v-field--readonly.description .v-field__field) {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

/* 优化滚动条样式 */
:deep(.table-container .v-table__wrapper)::-webkit-scrollbar,
.table-container::-webkit-scrollbar,
.company-list::-webkit-scrollbar,
.province-list::-webkit-scrollbar,
.city-list::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

:deep(.table-container .v-table__wrapper)::-webkit-scrollbar-track,
.table-container::-webkit-scrollbar-track,
.company-list::-webkit-scrollbar-track,
.province-list::-webkit-scrollbar-track,
.city-list::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
}

:deep(.table-container .v-table__wrapper)::-webkit-scrollbar-thumb,
.table-container::-webkit-scrollbar-thumb,
.company-list::-webkit-scrollbar-thumb,
.province-list::-webkit-scrollbar-thumb,
.city-list::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  transition: all 0.3s ease;
}

:deep(.table-container .v-table__wrapper)::-webkit-scrollbar-thumb:hover,
.table-container::-webkit-scrollbar-thumb:hover,
.company-list::-webkit-scrollbar-thumb:hover,
.province-list::-webkit-scrollbar-thumb:hover,
.city-list::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255, 255, 255, 0.3);
}

.company-suggestions-dialog {
  background-color: #2B2D33 !important;
}

.company-suggestions-dialog :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px;
}

.company-suggestions-dialog :deep(.v-card-text) {
  padding: 16px;
}

.company-list {
  max-height: 400px;
  overflow-y: auto;
  background-color: transparent !important;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
}

.company-list::-webkit-scrollbar {
  width: 6px;
}

.company-list::-webkit-scrollbar-track {
  background: transparent;
}

.company-list::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.company-list::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255, 255, 255, 0.3);
}

.company-suggestion-item {
  cursor: pointer;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.company-suggestion-item:hover {
  background-color: rgba(255, 255, 255, 0.05);
}

.company-suggestion-item :deep(.v-list-item-title) {
  color: #fff;
  font-size: 14px;
}

.company-suggestion-item :deep(.v-list-item-subtitle) {
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
}

:deep(.dialog-bottom-transition-enter-active),
:deep(.dialog-bottom-transition-leave-active) {
  transition: transform 0.2s ease-in-out;
}

:deep(.dialog-bottom-transition-enter-from),
:deep(.dialog-bottom-transition-leave-to) {
  transform: translateY(100%);
}

.submit-btn {
  background-color: #1976D2 !important;
  color: #fff !important;
}

.submit-btn:hover {
  background-color: #1565C0 !important;
}

.save-btn {
  background-color: rgba(3, 169, 244, 0.6) !important;
  color: #03A9F4 !important;
  font-weight: 500;
}

.save-btn:hover {
  background-color: rgba(3, 169, 244, 0.5) !important;
}

.region-dialog {
  background-color: #2B2D33 !important;
}

.region-dialog :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px;
}

.region-dialog :deep(.v-card-text) {
  padding: 16px;
}

.region-selector {
  display: flex;
  gap: 16px;
  height: 400px;
}

.province-list,
.city-list {
  flex: 1;
  overflow-y: auto;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
  padding: 8px;
}

.province-item,
.city-item {
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.7);
  transition: all 0.3s ease;
}

.province-item:hover,
.city-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.province-item.active,
.city-item.active {
  background-color: #1976D2;
  color: #fff;
}

.province-list::-webkit-scrollbar,
.city-list::-webkit-scrollbar {
  width: 6px;
}

.province-list::-webkit-scrollbar-track,
.city-list::-webkit-scrollbar-track {
  background: transparent;
}

.province-list::-webkit-scrollbar-thumb,
.city-list::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.province-list::-webkit-scrollbar-thumb:hover,
.city-list::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255, 255, 255, 0.3);
}

.exchange-rate-field :deep(.v-field__append-inner) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.exchange-rate-field :deep(.v-field__append-inner .v-icon) {
  cursor: help;
}

.exchange-rate-field :deep(.v-field__append-inner .v-icon:hover) {
  color: #ff5252 !important;
}

.auto-grow-textarea :deep(.v-field__input) {
  /* min-height: 36px !important; */
  padding: 6px 8px !important;
  line-height: 1.5;
  overflow-y: hidden !important;
  resize: none !important;
}

.auto-grow-textarea :deep(.v-field) {
  /* min-height: 36px !important; */
}

.auto-grow-textarea :deep(.v-field__outline) {
  /* min-height: 36px !important; */
}

.auto-grow-textarea :deep(textarea) {
  overflow: hidden !important;
  resize: none !important;
}

.price-input-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* .priceLeft {
  float: left;
  width: 46%;
}

.priceRight {
  float: right;
  width: 46%;
} */

/* 清除浮动 */
.priceLeft::after,
.priceRight::after {
  content: '';
  display: block;
  clear: both;
}

.price-input-group :deep(.v-field) {
  /* background-color: rgba(255, 255, 255, 0.05); */
}

.price-input-group :deep(.v-field--readonly .v-field__input) {
  /* color: #ff5252 !important; */
}

.price-input-group :deep(.v-field__outline) {
  color: rgba(255, 255, 255, 0.12) !important;
}

.price-input-group :deep(.v-field:hover .v-field__outline) {
  color: rgba(255, 255, 255, 0.3) !important;
}

.price-input-group :deep(.v-field--focused .v-field__outline) {
  /* color: #1976D2 !important; */
}
.contract-new-container {
  width: 100%;
  max-width: 1500px;
}

.form-card {
  background-color: #2B2D33 !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.form-card :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px;
  background: #D2475D;
}

.form-card :deep(.v-card-text) {
  padding: 24px;
  background-color: #2B2D33 !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.form-section {
  margin-bottom: 24px;
}

.section-title {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
}

/* 产品信息固定样式 */
.product-info-section {
  transition: all 0.3s ease;
  z-index: 100;
}

.product-info-section.fixed-top {
  position: fixed;
  top: 64px;
  left: 50%;
  transform: translateX(-50%);
  right: 0;
  /* background: #1E1E1E; */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  padding: 16px;
  margin: 0;
  border-radius: 0;
  width: 1380px;
  z-index: 1000;
}

.product-info-section.fixed-top .form-section {
  margin: 0;
}

.product-info-section.fixed-top .table-container {
  max-height: 80vh;
  overflow-y: auto;
}

.product-table :deep(td) .v-textarea.description .v-field__input {
  /* height: auto!important; */
  padding: 10px 4px 10px 38px !important;
  /* position: relative; */
}

/* 图片切换导航样式 */
.image-navigation {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  /* background: rgba(0, 0, 0, 0.7); */
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.image-preview-item:hover .image-navigation {
  opacity: 1;
}

.nav-btn {
  width: 30px !important;
  height: 30px !important;
  background: rgba(43,45,51,0.8) !important;
  border-radius: 50% !important;
  /* transition: all 0.3s ease !important; */
}

.nav-btn:hover {
  /* transform: scale(1.1); */
}

.nav-btn:disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
}

.top-input{
  margin-top: 16px;
}

.material-table .image-preview-item {
  width: 140px;
  height: 140px;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
  cursor: pointer;
  margin: 0 auto;
}

.material-table .image-preview-item {
  width: 80px!important;
  height: 80px!important;
}
.image-preview-item .preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.image-preview-item:hover .preview-image {
  transform: scale(1.05);
}

.material-table .image-count-icon{
  width: 10px!important;
  height: 10px!important;
}

.material-table .image-count-preview{
  font-size: 10px!important;
}

.material-table td{
  padding: 0px !important;
  text-align: center;
}

.scroll-textarea{
  padding: 6px 0!important;
}

.v-btn.bg-primary.v-btn--variant-flat.seeMaterial{
  border: 1px solid #FFFFFF!important;
  background-color: transparent!important;
  background: transparent!important;
  box-shadow: none!important;
  margin-right: 4px!important;
}

.material-table[data-v-2c12aa8c], .price-table[data-v-2c12aa8c] {
  background-color: transparent;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  /* table-layout: fixed; */
  /* min-width: 1200px; */
  border-collapse: separate;
  border-spacing: 0;
}

.material-list-table{
  background-color: transparent;
  width: 100%;
  /* table-layout: fixed; */
  /* min-width: 1200px; */
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid #36383D;
  color: #fff !important;
}

.material-list-table td{
  border-bottom: 1px solid rgb(54, 56, 61)!important;
}

.material-list-table th{
  color: #fff!important;
  text-align: center!important;
}

.material-list-table th .small-title{
  font-size: 12px!important;
}

:deep(.estimate-checkbox){
  width: 36px;
  height: 36px;
}

:deep(.estimate-checkbox .v-selection-control){
  width: 36px;
  height: 36px;
  min-height: 36px;
  background: #D4485E;
  border-radius: 3px 3px 3px 3px;
}

:deep(.estimate-checkbox .v-icon){
  left: -2px!important;
}
/* :deep(.estimate-checkbox .v-field__input){
  color: #fff!important;
}

:deep(.estimate-checkbox .v-field__input .v-icon){
  color: #fff!important;
} */

/* 去除按钮点击时的黑色透明圆样式 */
:deep(.v-btn:active),
:deep(.v-btn:focus),
:deep(.v-btn:focus-visible) {
  background-color: transparent !important;
  box-shadow: none !important;
}

:deep(.v-btn .v-ripple__container) {
  display: none !important;
}

:deep(.estimate-checkbox .v-checkbox:active),
:deep(.estimate-checkbox.v-checkbox:focus),
:deep(.estimate-checkbox.v-checkbox:focus-visible) {
  background-color: transparent !important;
  box-shadow: none !important;
}

:deep(.estimate-checkbox .v-checkbox .v-ripple__container) {
  display: none !important;
}

/* 去除所有按钮的ripple效果 */
:deep(.estimate-checkbox .v-ripple__container) {
  display: none !important;
}

/* 去除按钮active状态的背景色 */
:deep(.estimate-checkbox .v-btn--active) {
  background-color: transparent !important;
}

/* 去除按钮focus状态的背景色 */
:deep(.estimate-checkbox .v-btn:focus) {
  background-color: transparent !important;
}

.del-tr{
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: left center;
}

.material-book-container{
  position: fixed;
  top: 80px;
  right: 18px;
  z-index: 1000;
}

.material-book-btn{
  position: fixed;
  top: 80px;
  right: 18px;
  z-index: 1000;
  width: 36px;
  /* height: 76px; */
  /* background: #FFFFFF;
  box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.1);
  border-radius: 2px;
  text-align: center; */
  cursor: pointer;
  color: #000;
  /* font-size: 14px;
  line-height: 18px;
  font-weight: 500; */
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.material-book-content{
  position: fixed;
  top: 190px;
  right: 18px;
  z-index: 1000;
  width: 600px;
  max-height: 750px;
  overflow-y: auto;
  background: #36383D;
  box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.1);
  border-radius: 5px 5px 5px 5px;
  padding: 14px 14px 14px 14px;
}

.material-book-content::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.material-book-content::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
}

.material-book-content::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  transition: all 0.3s ease;
}

.material-book-title{
  font-size: 16px;
  font-weight: 400;
  color: #D4D4D4;
}

.material-book-tip{
  font-weight: 400;
  font-size: 14px;
  color: #B6B6B6;
  margin-bottom: 10px;
}

.material-book-list{
  width: 100%;
  /* height: 390px;
  overflow-y: auto; */
}

.material-book-list img{
  width: 100%;
}

:deep(.v-field--readonly .mdi-menu-down) {
  display: none!important;
}

.common-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.common-loading-container {
  text-align: center;
  color: #fff;
}

.common-loading-spinner {
  border: 4px solid #2B2D33;
  border-top: 4px solid #D2475D;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.common-loading-text {
  margin-top: 16px;
  font-size: 14px;
}

.outsourceBtn{
  background: #36383D;
  border-radius: 2px 2px 2px 2px;
  color: #FFFFFF;
}

.yinyonghuizong :deep(.v-input__details){
  display: none!important;
}

.icon-white :deep(.v-field__append-inner .v-icon) {
  color: white !important;
  cursor: pointer;
}

.icon-white :deep(.v-field__field) {
  cursor: pointer;
}

:deep(.height-description .v-field__input) {
  max-height: 80px!important;
  overflow-y: auto!important;
  /* font-size: 12px!important; */
  margin-right: 0!important;
  word-break: break-all!important;
}

/* 筛选按钮样式 */
.filter-btn {
  opacity: 0.7;
  transition: all 0.3s ease;
}

.filter-btn:hover {
  opacity: 1;
}

:deep(.filter-btn-active .mdi-filter::before){
  color: #D2475D !important;
}

.filter-btn-active {
  opacity: 1 !important;
}

.filter-menu {
  background-color: #2B2D33 !important;
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.filter-menu :deep(.v-card-text) {
  max-height: 400px;
  overflow-y: auto;
}

.filter-radio-group :deep(.v-label) {
  color: rgba(255, 255, 255, 0.87) !important;
  font-size: 14px;
}

.filter-radio-group :deep(.v-selection-control) {
  min-height: 36px;
}

.filter-radio-group :deep(.v-selection-control:hover) {
  background-color: rgba(255, 255, 255, 0.05);
}

/* 筛选复选框组样式 */
.filter-checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.filter-checkbox-group :deep(.v-label) {
  color: rgba(255, 255, 255, 0.87) !important;
  font-size: 14px;
}

.filter-checkbox-group :deep(.v-selection-control) {
  min-height: 32px;
  width: 100%;
}

.filter-checkbox-group :deep(.v-selection-control:hover) {
  background-color: rgba(255, 255, 255, 0.05);
}

/* 表头筛选单元格样式 */
.filter-header-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.filter-header-cell > span {
  display: flex;
  align-items: center;
}

/* 已选中标签样式 */
.selected-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 2px;
}

.selected-tags :deep(.v-chip) {
  height: 20px !important;
  font-size: 11px !important;
}

.selected-tags :deep(.v-chip__close) {
  font-size: 14px !important;
  margin-left: 2px !important;
}

:deep(.v-selection-control__input .mdi::before){
  color: #D2475D !important;
  font-size: 18px !important;
}

:deep(.height-description .v-field__input::-webkit-scrollbar) {
  width: 8px!important;
  height: 8px!important;
}

:deep(.height-description .v-field__input::-webkit-scrollbar-thumb) {
  background-color: rgba(255, 255, 255, 0.2)!important;
  border-radius: 4px!important;
  cursor: default;
}

:deep(.height-description .v-field__input::-webkit-scrollbar-track) {
  background-color: rgba(255, 255, 255, 0.05)!important;
  border-radius: 4px!important;
}

.material-bom-table-body tr td,.material-summary-table-body tr td{
  word-break: break-all!important;
  white-space: normal!important;
}

.material-code{
  color: #898989;
}

.material-bom-table :deep(.filter-btn), .material-summary-table :deep(.filter-btn){
  margin-left: 0!important;
}

/* 采购弹窗样式 */
.purchase-dialog {
  background-color: #2B2D33 !important;
}

.purchase-dialog :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px 24px;
  font-size: 18px;
  font-weight: 500;
}

.purchase-dialog :deep(.v-card-text) {
  padding: 24px;
}

.purchase-dialog :deep(.v-card-actions) {
  padding: 16px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.purchase-dialog :deep(.v-autocomplete .v-field__input),
.purchase-dialog :deep(.v-text-field .v-field__input),
.purchase-dialog :deep(.v-autocomplete input),
.purchase-dialog :deep(.v-text-field input) {
  color: #fff !important;
}

.purchase-dialog :deep(.v-autocomplete .v-field__outline),
.purchase-dialog :deep(.v-text-field .v-field__outline) {
  color: rgba(255, 255, 255, 0.12) !important;
}

.purchase-dialog :deep(.v-autocomplete .v-field__input::placeholder),
.purchase-dialog :deep(.v-text-field .v-field__input::placeholder) {
  color: rgba(255, 255, 255, 0.5) !important;
}

.purchase-dialog :deep(.v-label) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.purchase-dialog :deep(.v-autocomplete .v-field__append-inner i),
.purchase-dialog :deep(.v-text-field .v-field__append-inner i) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.purchase-dialog :deep(.v-list) {
  background-color: #2B2D33 !important;
}

.purchase-dialog :deep(.v-list-item) {
  color: #fff !important;
}

.purchase-dialog :deep(.v-list-item:hover) {
  background-color: rgba(255, 255, 255, 0.08) !important;
}

.purchase-dialog :deep(.v-list-item-title) {
  color: #fff !important;
}

.purchase-dialog :deep(.v-list-item-subtitle) {
  color: rgba(255, 255, 255, 0.6) !important;
}

.purchase-dialog :deep(.v-messages__message) {
  color: #ff5252 !important;
}

/* 隐藏数字输入框的箭头 */
.purchase-dialog :deep(input[type="number"])::-webkit-inner-spin-button,
.purchase-dialog :deep(input[type="number"])::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.purchase-dialog :deep(input[type="number"]) {
  -moz-appearance: textfield;
}

.purchase-dialog :deep(.mdi) {
  color: #fff !important;
}

:deep(.material-checkbox .v-checkbox-btn) {
  justify-content: center!important;
}

/* 物料采购列表样式 */
.material-purchase-list {
  margin: 20px 0;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 4px;
  overflow: hidden;
}

.material-purchase-item {
  display: flex;
  align-items: center;
  padding: 10px 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  transition: background-color 0.2s;
}

.material-purchase-item:hover {
  background-color: rgba(255, 255, 255, 0.03);
}

.material-purchase-item:last-child {
  border-bottom: none;
}

.material-purchase-item .item-content {
  color: #fff;
  font-size: 14px;
  text-align: center;
  padding: 0 4px;
  word-break: break-all;
}

/* 左侧区域：序号 + 物料信息 */
.material-purchase-item .material-left-section {
  display: flex;
  align-items: center;
  width: 160px;
  min-width: 160px;
  flex-shrink: 0;
}

.material-purchase-item .material-index {
  color: #fff;
  margin-right: 10px;
  font-size: 14px;
  min-width: 20px;
}

.material-purchase-item .material-info {
  flex: 1;
}

.material-purchase-item .material-name {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  line-height: 1.4;
}

.material-purchase-item .material-spec {
  color: #b0b0b0;
  font-size: 12px;
  text-align: left;
  line-height: 1.4;
}

.material-purchase-item .material-code {
  color: #898989;
  font-size: 12px;
  text-align: left;
  line-height: 1.4;
}

/* 右侧区域：上下两行内容 */
.material-purchase-item .material-right-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
}

.material-purchase-item .top-content {
  display: flex;
  align-items: center;
}

.material-purchase-item .bottom-content {
  display: flex;
  align-items: center;
}

.payment-type{
  width: 50px;
  padding: 4px 0px;
  font-size: 12px;
  border-radius: 4px;
  border: 1px solid #FFFFFF;
  font-weight: 400;
  color: #E8E8E8;
  text-align: center;
  font-style: normal;
  text-transform: none;
  display: inline-block;
}

.text-primary {
  color: #D2475D !important;
}

.text-left{
  text-align: left!important;
}

.text-center{
  text-align: center!important;
}

.product-table-container td.text-left,.product-table-container  th.text-left{
  padding-left: 4px!important;
  text-align: left!important;
}

/* ========== 采购单PDF模板样式 ========== */
.purchase-pdf-container {
  width: 100%;
  background: #fff;
}

.purchase-pdf-page {
  width: 100%;
  background: #fff;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Microsoft YaHei', 'SimHei', Arial, sans-serif;
  color: #000;
  page-break-after: always;
  page-break-inside: avoid;
  break-after: page;
  break-inside: avoid;
  margin-bottom: 40px;
}

.purchase-pdf-page:nth-child(n+1) {
  margin-bottom: 6px;
}

.purchase-pdf-page:last-child {
  page-break-after: auto;
  break-after: auto;
  margin-bottom: 0;
}

/* 简化头部样式（非第一页） */
.pdf-simple-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: linear-gradient(180deg, #f8f8f8 0%, #fff 100%);
  border-bottom: 1px solid #e0e0e0;
  height: 60px;
  box-sizing: border-box;
  margin-top: 6px;
}

.pdf-simple-header .simple-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.pdf-simple-header .company-logo-small {
  width: 36px;
  height: 36px;
  object-fit: contain;
}

.pdf-simple-header .simple-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.pdf-simple-header .simple-header-right {
  font-size: 12px;
  color: #666;
}

.pdf-header-container{
  background: url('@/assets/liaodanPdfTop.png') no-repeat center center;
  background-size: 100% 100%;
  padding: 16px;
}

/* 头部区域 */
.pdf-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.header-left {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.company-logo {
  width: 50px;
  height: 50px;
  object-fit: contain;
}

.company-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.company-name-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
}

.company-name {
  font-size: 20px;
  font-weight: bold;
  color: #000;
}

.order-tag {
  display: inline-block;
  width: 60px;
  height: 24px;
  line-height: 21px;
  text-align: center;
  box-sizing: border-box;
  border: 1px solid #000000;
  border-radius: 4px;
  color: #D2475D;
  font-size: 14px;
  font-weight: bold;
}

.order-numbers {
  font-size: 16px;
  color: #333;
}

.order-numbers .order-no {
  font-weight: bold;
  margin-left: 8px;
}

.header-right {
  font-size: 12px;
  color: #666;
}

/* 订单信息区域 */
.pdf-order-info {
  margin-top: 10px;
}

.pdf-order-info .info-columns {
  display: flex;
  gap: 40px;
}

.pdf-order-info .info-left,
.pdf-order-info .info-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.pdf-order-info .info-item {
  display: flex;
  align-items: flex-start;
  font-size: 16px;
}

.pdf-order-info .info-label {
  // color: #666;
  color: #000;
  min-width: 75px;
  flex-shrink: 0;
  font-weight: bold;
}

.info-right .info-label {
  min-width: 90px;
}

.pdf-order-info .info-value {
  color: #000;
  flex: 1;
  font-weight: 500;
}

/* 表格区域 */
.pdf-table-container {
  margin: 0 16px 16px 16px;
  border-radius: 4px;
  border: 1px solid #3E4046;
  border-bottom: none;
  overflow: hidden;
}

.pdf-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.pdf-table tr{
  border-bottom: 1px solid #3E4046;
}

.pdf-table th{
  padding: 8px 6px;
  text-align: left;
  vertical-align: middle;
}

.pdf-table td {
  padding: 4px 0;
  text-align: left;
  vertical-align: middle;
  line-height: 1.1;
  height: 60px;
}

.pdf-table th {
  background: #f5f5f5;
  font-weight: bold;
  text-align: center;
  color: #333;
}

.pdf-table td.text-center {
  text-align: center;
}

.pdf-table td.text-right {
  text-align: right;
}

.pdf-table .sub-text {
  font-size: 12px;
  /* color: #666; */
  color: #000;
}

.pdf-table .confirm-date-box {
  border: 1px solid #ccc;
  min-height: 20px;
  background: #fff;
  border-radius: 4px;
}

/* 汇总区域 */
.pdf-summary {
  margin: 0 16px;
  padding: 6px 10px;
  background-color: #EEEEEE;
  border-radius: 4px;
  border: 1px solid #3E4046;
}

.pdf-summary .summary-row {
  display: flex;
  align-items: center;
  font-size: 16px;
}

.pdf-summary .summary-label {
  color: #000;
  font-weight: bold;
}

.pdf-summary .summary-currency {
  color: #000;
  margin-left: 8px;
  font-weight: bold;
}

.pdf-summary .summary-amount {
  font-weight: bold;
  color: #000;
  margin-left: 8px;
  min-width: 80px;
}

.pdf-summary .summary-amount.total {
  color: #D2475D;
  font-size: 16px;
}

/* 备注区域 - 最大300px */
.pdf-remarks {
  margin: 0 16px;
  margin-top: 16px;
  padding: 6px 10px;
  border-radius: 4px;
  border: 1px solid #3E4046;
  max-height: 300px;
  overflow: hidden;
}

.pdf-remarks .remarks-title {
  font-weight: bold;
  font-size: 16px;
}

.pdf-remarks .remarks-content {
  font-size: 16px;
  // color: #333;
  color: #000;
  white-space: pre-wrap;
  display: -webkit-box;
  -webkit-line-clamp: 12;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* 底部签章区域 - 固定高度 */
.pdf-footer {
  margin: 0 16px;
  margin-top: 16px;
  padding: 6px 10px 80px 10px;
  border-radius: 4px;
  border: 1px solid #3E4046;
  height: 140px;
  box-sizing: content-box;
}

.pdf-footer .footer-row {
  display: flex;
  justify-content: space-between;
}

.pdf-footer .footer-row.footer-company {
  margin-top: 6px;
}

.pdf-footer .footer-item {
  flex: 1;
  font-size: 16px;
}

.pdf-footer .footer-label {
  font-weight: bold;
}

.pdf-footer .footer-value {
  color: #000;
  margin-left: 8px;
}

.pdf-footer .stamp-area {
  font-size: 16px;
}

.production-node{
  margin-right: 0px!important;
}

:deep(.product-info-cell-border) {
  border-right: 1px solid rgba(255, 255, 255, 0.12) !important
}

.search-type-toggle {
  margin: 14px 10px 14px 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 32px;
  .button-group {
    border-radius: 24px;
    background-color: #333;
    overflow: hidden;
    height: 32px;
  }

  .toggle-button {
    min-width: 42px;
    border-radius: 24px;
    font-weight: 500;
    color: #999 !important;

    &.v-btn--active {
      background: var(--primary-gradient) !important;
      color: white !important;
    }
  }
}

.table-border {
  border-top: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.bg-status-default{
  border-radius: 4px;
  background-color: #3b3b3b !important;
}

.bg-status-process{
  border-radius: 4px;
  background-color: #453237 !important;
  color: rgb(var(--v-theme-error)) !important;;
}

.bg-status-success{
  border-radius: 4px;
  background-color: #3B4D3E !important;
  color: #66BB6A !important;
}

.sum-wuliao-table td:nth-child(7),.sum-wuliao-table th:nth-child(7){
  border-right: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.del-tr-1{
  background-image: url('@/assets/delBg.png')!important;
}

.statusImg{
  width: 52px;
  height: 22px;
  display: inline-block;
  margin: 0 auto;
}

/* 只读字段样式 */
:deep(.v-field--readonly) {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

:deep(.v-field--readonly .v-field__input) {
  color: rgba(255, 255, 255, 0.8) !important;
}
</style>